// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 
//   const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;
//       let lettersData = [];
//       if (Array.isArray(data)) { lettersData = data; } 
//       else if (data && typeof data === 'object' && Array.isArray(data.letters)) { lettersData = data.letters; } 
//       else if (data && typeof data === 'object') { lettersData = [data]; }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const fetchDetailedApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//       setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching detailed applicants:", error); }
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations(),
//              fetchDetailedApplicants()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations, fetchDetailedApplicants]);

//   // --- Processing ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, letterId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) { return; }

//      setIsSending(prev => ({ ...prev, [letterId]: true }));
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;

//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: cleanPath, 
//          letter_type: LetterType,
//          letter_id: letterId
//        });
       
//        setLetters(prevLetters => prevLetters.map(l => l.id === letterId ? { ...l, sent: true } : l));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${letterId}/`, { sent: 1 });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [letterId]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          console.error("Error downloading PDF:", error); 
//          Swal.fire("Error", "Could not download PDF. File may not exist on server.", "error"); 
//      }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => { setUploadedFile(e.target.files[0] || null); }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//      if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null; return;
//      }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = (selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const candidateDetails = selectedOption?.details || {};
     
//      // Match logic: Use 'user_id' from evaluation details to match 'user' from applicants API. 
//      // Also fall back to email matching which is more robust if IDs differ across tables.
//      const targetId = candidateDetails.user_id || candidateDetails.user;
//      const detailedApp = allDetailedApplicants.find(app => 
//         (targetId && String(app.user) === String(targetId)) || 
//         (selectedOption.email && app.email === selectedOption.email)
//      );

//      let candAddress = "", candPin = "", candPhone = "";

//      if (detailedApp) {
//         // Construct detailed address. Use address_type as base (it holds the H.No/Street from your screenshot)
//         const addrParts = [
//             detailedApp.address_type,
//             detailedApp.village, 
//             detailedApp.tehsil, 
//             detailedApp.district, 
//             detailedApp.state, 
//             detailedApp.country
//         ].filter(part => part && String(part).trim() !== "" && String(part).toLowerCase() !== "null");
        
//         candAddress = addrParts.join(", ");
//         candPin = detailedApp.zip_code || "";
//         candPhone = detailedApp.phone || "";
//      } else {
//         // Fallback to evaluation details if not found in detailed list
//         candAddress = candidateDetails.combined_address || candidateDetails.address || candidateDetails.location || "";
//         candPin = candidateDetails.zip_code || candidateDetails.pincode || "";
//         candPhone = candidateDetails.phone || candidateDetails.mobile || "";
//      }

//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: selectedOption?.fullName || "", user_id: selectedOption?.value || null, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      setShowApplicantData(true);
//    }; 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";

//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                 if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
            
//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 payload.append('evaluation_id', formData.user_id); payload.append('candidateName', formData.candidateName); payload.append('letterType', formData.section); payload.append('customContent', customContent); payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('digital_signature', signatureFile, signatureFile.name);
//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
            
//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
//                 payload.append('generation_method', 'upload'); payload.append('evaluation_id', formData.user_id); payload.append('letterType', formData.section); payload.append('uploadedFile', uploadedFile); payload.append('date', formData.date); payload.append('reporting_manager', formData.reporting_manager || "N/A");
//                 if (signatureFile) { payload.append('digital_signature', signatureFile, signatureFile.name); }
//                 successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
//                                         const isSent = letter.sent === true || letter.sent === 1 || letter.sent === "true";
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.Time)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'Address Not Provided'}, Pin: {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Row>
//                                   <Col md={6} lg={4} className="mb-3">
//                                      <Form.Group controlId="dateUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                         <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                   <Col md={6} lg={4} className="mb-3">
//                                     <Form.Group controlId="reportingManagerUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
//                                         <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager Name" size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                 </Row>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileUpload" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Digital Signature <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                    {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                    {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;



import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
import Swal from "sweetalert2";
import { FcApproval, FcHighPriority } from "react-icons/fc";
import Select from "react-select";
import { removeBackground } from "@imgly/background-removal";
import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle, FaCalendar } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const cleanHtmlForBackend = (rawHtml) => {
  if (!rawHtml) return "";
  let html = rawHtml;

  // 1. Remove MS Word comments <!--[if gte mso 9]>...<![endif]-->
  html = html.replace(/<!--[\s\S]*?-->/g, '');

  // 2. Remove Word system metadata tags (<meta>, <link>, <style>, <xml>, <o:p>)
  html = html.replace(/<meta[^>]*>/gi, '');
  html = html.replace(/<link[^>]*>/gi, '');
  html = html.replace(/<style[\s\S]*?<\/style>/gi, '');
  html = html.replace(/<xml[\s\S]*?<\/xml>/gi, '');
  html = html.replace(/<\/?o:p[^>]*>/gi, '');

  // 3. Fix <br> tags: convert all br tags to self-closing <br/> and collapse 2+ consecutive <br/> tags into 1
  html = html.replace(/<\/br>/gi, '');
  html = html.replace(/<br[^>]*>/gi, '<br/>');
  html = html.replace(/(<br\s*\/?>\s*){2,}/gi, '<br/>');

  // 4. Remove Word XML namespaces like <w:...>, <v:...>, <m:...>
  html = html.replace(/<\/?\w+:[^>]*>/gi, '');

  // 5. Replace MS Word proprietary 'windowtext' color with black '#000000'
  html = html.replace(/windowtext/gi, '#000000');

  // 6. Strip hardcoded cell widths (e.g. width="72" or style="width:.75in") so columns auto-fit container
  html = html.replace(/\s*width=["'][^"']*["']/gi, '');

  // 7. Clean up style="..." attributes: remove font-family (prevents ReportLab findSpanStyle crash), mso- rules, border:none, etc.
  html = html.replace(/style="([^"]*)"/gi, (match, styleContent) => {
    let cleaned = styleContent
      .replace(/font-family\s*:\s*[^;"]+;?/gi, '') // Fixes ReportLab 'findSpanStyle not implemented in this parser'
      .replace(/mso-[^:";\s>]+:[^;";\s>]+;?/gi, '')
      .replace(/border\s*:\s*none\s*;?/gi, '')
      .replace(/border-[a-z]+\s*:\s*none\s*;?/gi, '')
      .replace(/width\s*:\s*[^;"]+;?/gi, '')
      .replace(/margin-[a-z]+\s*:\s*[^;"]+;?/gi, '')
      .replace(/windowtext/gi, '#000000')
      .replace(/&quot;/g, '')
      .replace(/(?:solid|dashed|dotted|double|none|#000000|\d+\.?\d*pt)\s+\.?[0-9a-z]+\s*;?/gi, '')
      .replace(/;+/g, ';');

    return cleaned.trim() ? `style="${cleaned.trim()}"` : '';
  });

  // 8. Completely unwrap <span> and <font> tags to prevent ReportLab 'findSpanStyle not implemented in this parser' crash
  html = html.replace(/<\/?span[^>]*>/gi, '');
  html = html.replace(/<\/?font[^>]*>/gi, '');

  // 9. Ensure <table> has width:100%, max-width:100%, table-layout:auto, border-collapse:collapse, border:1px solid #000000
  html = html.replace(/<table(\s+[^>]*)?>/gi, (match) => {
    if (!match.includes('style=')) {
      return match.replace('<table', '<table style="width:100%; max-width:100%; table-layout:auto; border-collapse:collapse; border:1px solid #000000; margin:10px 0;"');
    } else {
      return match.replace(/style="([^"]*)"/i, 'style="$1; width:100%; max-width:100%; table-layout:auto; border-collapse:collapse; border:1px solid #000000; margin:10px 0;"');
    }
  });

  // 10. Ensure <td> and <th> have solid black border (1px solid #000000), padding, and word-break
  html = html.replace(/<td(\s+[^>]*)?>/gi, (match) => {
    if (!match.includes('style=')) {
      return match.replace('<td', '<td style="border:1px solid #000000; padding:4px 6px; vertical-align:top; word-break:break-word;"');
    } else {
      return match.replace(/style="([^"]*)"/i, 'style="$1; border:1px solid #000000; padding:4px 6px; vertical-align:top; word-break:break-word;"');
    }
  });

  html = html.replace(/<th(\s+[^>]*)?>/gi, (match) => {
    if (!match.includes('style=')) {
      return match.replace('<th', '<th style="border:1px solid #000000; padding:4px 6px; background-color:#f2f2f2; font-weight:bold; vertical-align:top; word-break:break-word;"');
    } else {
      return match.replace(/style="([^"]*)"/i, 'style="$1; border:1px solid #000000; padding:4px 6px; background-color:#f2f2f2; font-weight:bold; vertical-align:top; word-break:break-word;"');
    }
  });

  // 11. Strip leading <br/> tags at the very start of content
  html = html.replace(/^(<br\s*\/?>\s*)+/gi, '');

  return html.trim();
};

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const editorRef = React.useRef(null);
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    if (editorRef.current) {
      if (editorRef.current.innerHTML !== (value || "")) {
        editorRef.current.innerHTML = value || "";
      }
    }
  }, [value]);

  const execCommand = (command, val = null) => {
    document.execCommand(command, false, val);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.clipboardData;
    let html = clipboardData.getData('text/html');
    let text = clipboardData.getData('text/plain');

    if (html) {
      html = cleanHtmlForBackend(html);

      const selection = window.getSelection();
      if (selection.rangeCount && editorRef.current && editorRef.current.contains(selection.anchorNode)) {
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = html;

        const frag = document.createDocumentFragment();
        let node;
        let lastNode;
        while ((node = tempContainer.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);

        if (lastNode) {
          range.setStartAfter(lastNode);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else if (editorRef.current) {
        editorRef.current.innerHTML += html;
      }
    } else if (text) {
      document.execCommand('insertText', false, text);
    }

    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const changeFontSize = (size) => {
    if (!size) return;
    document.execCommand('fontSize', false, '7');
    if (editorRef.current) {
      const fontElements = editorRef.current.querySelectorAll('font[size="7"]');
      fontElements.forEach(fontEl => {
        const span = document.createElement('span');
        span.style.fontSize = size;
        span.innerHTML = fontEl.innerHTML;
        fontEl.parentNode.replaceChild(span, fontEl);
      });
      onChange(editorRef.current.innerHTML);
    }
  };

  const changeFontFamily = (font) => {
    if (!font) return;
    document.execCommand('fontName', false, font);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const insertTable = () => {
    const tableHtml = `<table style="width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 13px;"><tr style="background-color: #f2f2f2;"><th style="border: 1px solid #ccc; padding: 6px;">Header 1</th><th style="border: 1px solid #ccc; padding: 6px;">Header 2</th></tr><tr><td style="border: 1px solid #ccc; padding: 6px;">Cell 1</td><td style="border: 1px solid #ccc; padding: 6px;">Cell 2</td></tr></table>`;
    execCommand('insertHTML', tableHtml);
  };

  const isContentEmpty = !value || value === '<p><br></p>' || value === '<br>' || value.replace(/<[^>]*>/g, '').trim() === '';

  return (
    <div className="custom-rich-editor border rounded bg-white">
      <div className="editor-toolbar bg-light p-2 border-bottom d-flex flex-wrap gap-1 align-items-center">
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Bold" onClick={() => execCommand('bold')}><b>B</b></button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Italic" onClick={() => execCommand('italic')}><i>I</i></button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Underline" onClick={() => execCommand('underline')}><u>U</u></button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Strikethrough" onClick={() => execCommand('strikeThrough')}><strike>S</strike></button>

        <span className="border-end mx-1" style={{ height: '18px' }}></span>

        <div className="d-flex align-items-center gap-1">
          <span className="small text-muted" style={{ fontSize: '11px' }}>Font:</span>
          <select className="form-select form-select-sm w-auto py-0" onChange={(e) => changeFontFamily(e.target.value)} defaultValue="Arial" style={{ fontSize: '12px', minWidth: '110px', paddingRight: '24px', paddingLeft: '8px' }} title="Font Family">
            <option value="Arial">Arial</option>
            <option value="Calibri">Calibri</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Georgia">Georgia</option>
            <option value="Verdana">Verdana</option>
            <option value="Tahoma">Tahoma</option>
            <option value="Courier New">Courier New</option>
            <option value="Trebuchet MS">Trebuchet MS</option>
          </select>
        </div>

        <div className="d-flex align-items-center gap-1">
          <span className="small text-muted" style={{ fontSize: '11px' }}>Size:</span>
          <select className="form-select form-select-sm w-auto py-0" onChange={(e) => changeFontSize(e.target.value)} defaultValue="12pt" style={{ fontSize: '12px', minWidth: '85px', paddingRight: '24px', paddingLeft: '8px' }} title="Font Size (MS Word style)">
            <option value="8pt">8 pt</option>
            <option value="9pt">9 pt</option>
            <option value="10pt">10 pt</option>
            <option value="11pt">11 pt</option>
            <option value="12pt">12 pt</option>
            <option value="14pt">14 pt</option>
            <option value="16pt">16 pt</option>
            <option value="18pt">18 pt</option>
            <option value="20pt">20 pt</option>
            <option value="22pt">22 pt</option>
            <option value="24pt">24 pt</option>
            <option value="28pt">28 pt</option>
            <option value="36pt">36 pt</option>
            <option value="48pt">48 pt</option>
            <option value="72pt">72 pt</option>
          </select>
        </div>

        <span className="border-end mx-1" style={{ height: '18px' }}></span>

        <div className="d-flex align-items-center gap-1">
          <span className="small text-muted" style={{ fontSize: '11px' }}>Text:</span>
          <input type="color" className="form-control form-control-color form-control-sm p-0 border-0" title="Text Color" onChange={(e) => execCommand('foreColor', e.target.value)} defaultValue="#000000" style={{ width: '24px', height: '24px', cursor: 'pointer' }} />
        </div>

        <div className="d-flex align-items-center gap-1">
          <span className="small text-muted" style={{ fontSize: '11px' }}>Bg:</span>
          <input type="color" className="form-control form-control-color form-control-sm p-0 border-0" title="Highlight Color" onChange={(e) => execCommand('hiliteColor', e.target.value)} defaultValue="#ffffff" style={{ width: '24px', height: '24px', cursor: 'pointer' }} />
        </div>

        <span className="border-end mx-1" style={{ height: '18px' }}></span>

        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Align Left" onClick={() => execCommand('justifyLeft')}>Left</button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Align Center" onClick={() => execCommand('justifyCenter')}>Center</button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Align Right" onClick={() => execCommand('justifyRight')}>Right</button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Justify" onClick={() => execCommand('justifyFull')}>Justify</button>

        <span className="border-end mx-1" style={{ height: '18px' }}></span>

        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Bullet List" onClick={() => execCommand('insertUnorderedList')}>• List</button>
        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-2" title="Numbered List" onClick={() => execCommand('insertOrderedList')}>1. List</button>

        <span className="border-end mx-1" style={{ height: '18px' }}></span>

        <button type="button" className="btn btn-sm btn-outline-primary py-0 px-2 fw-semibold" title="Insert Table" onClick={insertTable}>+ Table</button>
        <button type="button" className="btn btn-sm btn-outline-danger py-0 px-2" title="Clear Formatting" onClick={() => execCommand('removeFormat')}>Clear Format</button>
      </div>

      <div style={{ position: 'relative' }}>
        {isContentEmpty && !isFocused && (
          <div style={{ position: 'absolute', top: '12px', left: '14px', color: '#a0aec0', pointerEvents: 'none', fontSize: '14px' }}>
            {placeholder || "Paste or type letter content here (tables, fonts, colors, and formatting from Word are preserved)..."}
          </div>
        )}
        <div
          ref={editorRef}
          contentEditable
          suppressContentEditableWarning
          onInput={handleInput}
          onPaste={handlePaste}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            minHeight: '240px',
            maxHeight: '450px',
            overflowY: 'auto',
            padding: '12px 14px',
            outline: 'none',
            fontSize: '14px',
            lineHeight: '1.6',
            backgroundColor: '#ffffff',
          }}
        />
      </div>
    </div>
  );
};

// --- Professional Styles ---
const styles = {
      gradientText: {
        background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '600',
      },
      cardHeader: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e9ecef',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 1.5rem',
      },
      modalSection: {
        border: '1px solid #dee2e6',
        borderRadius: '0.375rem',
        padding: '1.5rem',
        marginBottom: '1.5rem',
        backgroundColor: '#f8f9fa'
      },
      signaturePreview: {
        maxWidth: '200px',
        maxHeight: '100px',
        border: '2px dashed #ced4da',
        padding: '10px',
        borderRadius: '0.375rem',
        backgroundColor: '#ffffff',
        marginTop: '15px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        objectFit: 'contain',
      },
      pageWrapper: {
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: 'hidden',
      },
      contentWrapper: {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden',
      },
      mainContentArea: {
        flexGrow: 1,
        overflowY: 'auto',
        padding: '1.5rem 2rem',
        backgroundColor: '#f4f7fc',
        height: 'calc(100vh - 56px)',
      },
      reactSelectStyles: {
        control: (provided, state) => ({
             ...provided,
              borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
              boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
              '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
              minHeight: '38px', height: 'auto',
              backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
        }),
        valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
        input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
        indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
        placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
        option: (provided, state) => ({
             ...provided,
              backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
              color: state.isSelected ? 'white' : '#212529',
              ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
        }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
        singleValue: (provided, state) => ({
             ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
        }),
      },
};

const OfferLetterGenerator = () => {
  // --- States ---
  const [letters, setLetters] = useState([]); 
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredLetters, setFilteredLetters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [noDataFound, setNoDataFound] = useState(false);
  // Removed sentStatus state to prevent sync issues. We will use letters state directly.
  const [isDownloading, setIsDownloading] = useState({});
  const [isSending, setIsSending] = useState({});
  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [showApplicantData, setShowApplicantData] = useState(false);
  const [hrList, setHrList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [generationMethod, setGenerationMethod] = useState("template");
  const [customContent, setCustomContent] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
  const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
  // Data States
  const [evaluations, setEvaluations] = useState([]);
  const [interviewEvaluations, setInterviewEvaluations] = useState([]);
  const [processedJobs, setProcessedJobs] = useState([]); 
  const [candidatesMap, setCandidatesMap] = useState({}); 
  const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);

  // Selection States
  const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
  const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
  const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
  const [initialFormData] = useState({
    candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
    address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
    reporting_manager: "", headquarter: "", opening_post: "" 
  });
  const [formData, setFormData] = useState(initialFormData);

  // --- Data Fetching ---

  const fetchLetters = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
      const data = response.data;

      let lettersData = [];
      
      if (Array.isArray(data)) {
          lettersData = data;
      } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
          lettersData = data.letters;
      } else if (data && typeof data === 'object') {
          lettersData = [data];
      }

      if (lettersData.length > 0) {
        // Sort letters by Time in descending order (newest first)
        const sortedLetters = lettersData.sort((a, b) => {
          const dateA = new Date(a.Time || 0);
          const dateB = new Date(b.Time || 0);
          return dateB - dateA;
        });
        setLetters(sortedLetters);
        setNoDataFound(false);
      } else { 
        setLetters([]); 
        setNoDataFound(true); 
      }
    } catch (error) { 
        console.error("Error fetching letters:", error); 
        setLetters([]); 
        setNoDataFound(true); 
    }
  }, []);

  const fetchHrList = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
      const data = response.data;
      if (data && Array.isArray(data)) { setHrList(data); }
      else { setHrList([]); }
    } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
  }, []);

  const fetchEvaluations = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
      const data = response.data;
      console.log("Evaluations API Data:", data);

      let list = [];
      if (Array.isArray(data)) { 
        list = data; 
      } else if (data && typeof data === 'object') { 
        if (Array.isArray(data.results)) list = data.results;
        else if (Array.isArray(data.data)) list = data.data;
        else if (Array.isArray(data.evaluations)) list = data.evaluations;
        else if (Array.isArray(data.items)) list = data.items;
        else {
          const vals = Object.values(data);
          if (vals.length > 0 && typeof vals[0] === 'object') {
            list = vals;
          }
        }
      }
      setEvaluations(list);
    } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
  }, []);

  const fetchInterviewEvaluations = useCallback(async () => {
    try {
        const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
        const data = response.data;
        if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
        else { setInterviewEvaluations([]); }
    } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
  }, []);

const fetchDetailedApplicants = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
      setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
    } catch (error) { console.error("Error fetching detailed applicants:", error); }
  }, []);

  // --- Load Data ---
  useEffect(() => {
    const loadInitialData = async () => {
      setIsLoadingData(true);
      try {
         await Promise.all([ 
             fetchLetters(), 
             fetchHrList(),
             fetchEvaluations(),
             fetchInterviewEvaluations(),
             fetchDetailedApplicants()
         ]);
      } catch (error) {
         console.error("Error during initial data fetch:", error);
         Swal.fire("Load Error", "Failed to load necessary data.", "error");
      } finally {
         setIsLoadingData(false);
      }
    };
    loadInitialData();
  }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations, fetchDetailedApplicants]);

  // --- Processing ... ---
  useEffect(() => {
    const jobMap = {}; 
    const evArray = Array.isArray(evaluations) ? evaluations : [];

    evArray.forEach((ev, idx) => {
        if (!ev || typeof ev !== 'object') return;

        // Check if item has candidate_details nested object (from API response schema)
        const details = ev.candidate_details || ev.candidate || ev;

        const jobTitle = details.job_title || ev.job_title || details.job_name || ev.job_name || details.title || ev.title || details.posting_title || ev.posting_title || details.position || ev.position;
        const postingId = details.posting_id || ev.posting_id || details.job_posting || ev.job_posting || details.job_posting_id || ev.job_posting_id || details.job_id || ev.job_id || jobTitle || ev.id || `job-${idx}`;
        
        const displayTitle = jobTitle || (typeof postingId === 'string' && !postingId.startsWith('job ') ? postingId : jobTitle || `Job #${postingId}`);
        if (!displayTitle) return;

        const key = String(postingId);

        if (!jobMap[key]) {
            jobMap[key] = { 
                id: key, 
                pureTitle: displayTitle, 
                label: displayTitle, 
                type: details.posting_type || ev.posting_type || details.job_type || ev.job_type || "", 
                candidates: [] 
            };
        } else {
             if (jobTitle && (!jobMap[key].pureTitle || jobMap[key].pureTitle.startsWith('Job #'))) {
                 jobMap[key].pureTitle = jobTitle;
                 jobMap[key].label = jobTitle;
             }
        }

        const candidateId = ev.id || details.id || details.interview_id || details.candidate_id || details.user_id || details.user || `cand-${idx}`;
        const candidateName = details.candidate_name || ev.candidate_name || details.name || ev.name || details.applicant_name || ev.applicant_name || "Unknown Candidate";
        const candidateEmail = details.candidate_email || ev.candidate_email || details.email || ev.email || details.evaluator_email || ev.evaluator_email || "";

        const exists = jobMap[key].candidates.find(c => String(c.id) === String(candidateId) || (candidateEmail && c.email === candidateEmail));
        if (!exists) {
            jobMap[key].candidates.push({ 
                id: candidateId, 
                name: candidateName, 
                email: candidateEmail, 
                details: ev 
            }); 
        }
    });

    const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
    setProcessedJobs(jobsArray);

    const candMap = {}; 
    jobsArray.forEach(job => { 
        candMap[job.id] = job.candidates; 
    }); 
    setCandidatesMap(candMap);
  }, [evaluations]);

  const applySearchAndPagination = useCallback(() => {
    let filteredData = letters.filter((letter) => {
      const searchLower = searchQuery.toLowerCase();
      const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
      const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
      const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
      const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
      return candidateMatches || typeMatches || methodMatches || phoneMatches;
    });
    setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
    setFilteredLetters(filteredData);
  }, [letters, searchQuery]);

  useEffect(() => {
    applySearchAndPagination();
    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
    if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
    else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
    else if (filteredLetters.length === 0) { setCurrentPage(1); }
  }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

   // --- Actions ---

   const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, letterId, position) => {
     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
     // --- Confirmation Alert BEFORE sending ---
     const result = await Swal.fire({
        title: 'Confirm Send',
        text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, send it!',
        cancelButtonText: 'Cancel'
     });

     if (!result.isConfirmed) {
        return; 
     }

     setIsSending(prev => ({ ...prev, [letterId]: true }));
     
     // Remove leading slash for consistency with payload requirement
     let cleanPath = pdfPath;
     if (cleanPath.startsWith('/')) {
        cleanPath = cleanPath.substring(1);
     }

     try {
       await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
         candidate_name: candidateName, 
         pdf_path: cleanPath, 
         letter_type: LetterType,
         letter_id: letterId,
         position: position
       });
       
       // Update UI state immediately to reflect 'Sent'
       setLetters(prevLetters => 
         prevLetters.map(l => l.id === letterId ? { ...l, sent: true } : l)
       );
       
       // Call API to persist status if necessary (redundancy for safety)
       await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${letterId}/`, { sent: 1 });

       Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
     } catch (error) { 
         console.error("Error sending email:", error); 
         Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
     } finally { 
         setIsSending(prev => ({ ...prev, [letterId]: false })); 
     }
   }, []);

   const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
    if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
     
     // --- FIX: Sanitize Path ---
     let cleanPath = pdfPath;
     if (cleanPath.startsWith('/')) {
         cleanPath = cleanPath.substring(1);
     }
     
     setIsDownloading(prev => ({ ...prev, [pk]: true }));
     try {
        const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement("a");
        link.href = url;
        const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
        link.setAttribute("download", filename);
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
     } catch (error) { 
         console.error("Error downloading PDF:", error); 
         Swal.fire("Error", "Could not download PDF. File may not exist on server.", "error"); 
     }
     finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
   }, []);

   const handleChange = useCallback((e) => {
     const { name, value } = e.target;
     setFormData(prevState => ({ ...prevState, [name]: value }));
   }, []);

   const handleHrChange = useCallback((selectedOption) => {
     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
     setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
   }, [hrList]);

   const handleFileChange = useCallback((e) => {
     setUploadedFile(e.target.files[0] || null);
   }, []);

   const handleSignatureFileChange = useCallback(async (e) => {
     const file = e.target.files[0] || null;
     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
     if (!file) return;
      if (!file.type.startsWith('image/')) {
          Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
          if (e?.target) e.target.value = null;
          return;
      }
     setIsProcessingSignature(true);
     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
     try {
       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
       const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
       setSignatureFile(processedFile);
       const reader = new FileReader();
       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
       reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
       reader.readAsDataURL(processedBlob);
     } catch (error) {
       console.error("Error removing background:", error);
       Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
       setSignatureFile(null); setSignaturePreviewUrl(null);
       if (e?.target) e.target.value = null;
     } finally {
       setIsProcessingSignature(false);
       if (Swal.isVisible()) { Swal.close(); }
     }
   }, []);

   const handleJobTitleChange = useCallback((event) => {
     const postingId = event.target.value; 
     setSelectedJobTitle(postingId);
     const jobObj = processedJobs.find(j => j.id === postingId);
     const cleanTitle = jobObj ? jobObj.pureTitle : "";
     const jobType = jobObj ? jobObj.type : ""; 
     setSelectedJobLabel(jobObj ? jobObj.label : "");
     setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
     setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
     if (postingId && candidatesMap[postingId]) {
         const candidates = candidatesMap[postingId];
         const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
         setFilteredCandidateOptions(options);
     }
   }, [processedJobs, candidatesMap, initialFormData]);

   const handleCandidateChange = (selectedOption) => {
     setSelectedCandidate(selectedOption);
     
     // candidateDetails comes from the evaluation/letter API
     const candidateDetails = selectedOption?.details || {};
     
     // This is the 'user_id' (e.g., "51") from the letter/evaluation API
     const evaluationUserId = candidateDetails.user_id || candidateDetails.user;

     // FIND MATCH: Match 'evaluationUserId' with 'app.user' (e.g., 9) from the applicants API
     // We also use email as a fallback for higher accuracy
     const detailedApp = allDetailedApplicants.find(app => 
        (evaluationUserId && String(app.user) === String(evaluationUserId)) || 
        (selectedOption.email && app.email === selectedOption.email)
     );

     let candAddress = "", candPin = "", candPhone = "";

     if (detailedApp) {
        // Construct detailed address. 
        // Based on your SS, address_type contains the street info (H.No...)
        const addrParts = [
            detailedApp.address_type,
            detailedApp.village, 
            detailedApp.tehsil, 
            detailedApp.district, 
            detailedApp.state, 
            detailedApp.country
        ].filter(part => 
            part && 
            String(part).trim() !== "" && 
            String(part).toLowerCase() !== "null"
        );
        
        candAddress = addrParts.join(", ");
        candPin = detailedApp.zip_code || "";
        candPhone = detailedApp.phone || "";
     } else {
        // Fallback to evaluation details if no match is found in the detailed applicants list
        candAddress = candidateDetails.combined_address || candidateDetails.address || candidateDetails.location || "";
        candPin = candidateDetails.zip_code || candidateDetails.pincode || "";
        candPhone = candidateDetails.phone || candidateDetails.mobile || "";
     }

     // Update local display states
     setAddress(candAddress); 
     setPinCode(candPin); 
     setMobileNumber(candPhone); 

     // Update global form data
     setFormData(prevState => ({ 
         ...prevState, 
         candidateName: selectedOption?.fullName || "", 
         user_id: selectedOption?.value || null, // Keeping the Evaluation PK for backend submission
         address: candAddress, 
         pinCode: candPin, 
         mobileNumber: candPhone 
     }));

     setShowApplicantData(true);
   };


   const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
        if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
        if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
        let endpoint = "";
        let payload = new FormData();
        let headers = { 'Content-Type': 'multipart/form-data' };
        let navigateTo = null; let navigateState = null; let successMessage = "";

        try {
            // Common optional fields
            payload.append('opening_post', formData.opening_post);
            if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
            if (generationMethod === "template") {
                endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
                if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
                payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
                if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
                if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
                successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
                navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
                 if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
            
            } else if (generationMethod === "custom") {
                endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
                const isContentEmpty = (html) => {
                  if (!html) return true;
                  const stripped = html.replace(/<[^>]*>/g, '').trim();
                  return stripped.length === 0 && !html.includes('<img') && !html.includes('<table');
                };
                if (isContentEmpty(customContent)) { throw new Error("Please enter custom letter content."); }
                
                payload.append('evaluation_id', formData.user_id);
                payload.append('candidateName', formData.candidateName);
                payload.append('letterType', formData.section);
                const sanitizedContent = cleanHtmlForBackend(customContent);
                payload.append('customContent', sanitizedContent);
                payload.append('date', formData.date);
                
                if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
                if (signatureFile) payload.append('digital_signature', signatureFile, signatureFile.name);

                successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
                navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
                 if (formData.section !== "Offer Letter") { delete navigateState.hr; }
            
            } else if (generationMethod === "upload") {
                endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
                
                if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
                if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
                
                payload.append('generation_method', 'upload');
                payload.append('evaluation_id', formData.user_id);
                payload.append('letterType', formData.section);
                payload.append('uploadedFile', uploadedFile);
                payload.append('date', formData.date);
                payload.append('reporting_manager', formData.reporting_manager || "N/A");
                
                if (signatureFile) {
                    payload.append('digital_signature', signatureFile, signatureFile.name);
                }

                successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
            } else { throw new Error("Invalid generation method selected."); }

          const response = await axios.post(endpoint, payload, { headers: headers });
          const backendSuccessMessage = response.data.message;
          successMessage = backendSuccessMessage || successMessage;
          Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
        } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
   }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


   const handleOpenModal = useCallback(() => {
     setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
     const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
     const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
     setShowModal(true);
   }, [initialFormData]);

   const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
   const formatDateTime = (dateTimeString) => {
     if (!dateTimeString) return <span className="text-muted small">N/A</span>;
     const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
     try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
   };
   const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
   const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
   const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
   const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


  return (
    <>
      <div style={styles.pageWrapper}>
        <DashNavbar />
        <div style={styles.contentWrapper}>
          <Sidebar />
          <main style={styles.mainContentArea}>
             <Container fluid className="p-0">
                <Card className="shadow-sm border-0 h-100">
                    <Card.Header style={styles.cardHeader}>
                        <h1 className="mb-0 h2" style={styles.gradientText}> Offer Letters Management</h1>
                        <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
                            {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
                            Create Letter
                        </Button>
                    </Card.Header>

                     <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
                         <Row className="mb-4 flex-shrink-0">
                             <Col md={7} lg={5}>
                                 <InputGroup size="sm">
                                     <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
                                     <InputGroup.Text><FaSearch /></InputGroup.Text>
                                 </InputGroup>
                             </Col>
                         </Row>

                         <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
                             <Table hover responsive className="align-middle mb-0 small">
                                 <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
                                      <tr>
                                         <th style={{ width: '5%' }}>#</th>
                                         <th style={{ width: '25%' }}>Candidate Name</th>
                                         <th style={{ width: '15%' }}>Letter Type</th>
                                         <th style={{ width: '10%' }}>Method</th>
                                         <th style={{ width: '10%' }} className="text-center">Download</th>
                                         <th style={{ width: '20%' }}>Generated On</th>
                                         <th style={{ width: '10%' }} className="text-center">Send Email</th>
                                         <th style={{ width: '5%' }} className="text-center">Status</th>
                                     </tr>
                                 </thead>
                                 <tbody>
                                 {isLoadingData ? (
                                     <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
                                 ) : currentItems.length > 0 ? (
                                     currentItems.map((letter, index) => {
                                         const globalIndex = indexOfFirstItem + index;
                                        const pk = letter.id; 
                                        
                                        // Robust check for sent status: handles boolean true, string "true", or number 1
                                        const isSent = letter.sent === true || letter.sent === 1 || letter.sent === "true";
                                        
                                        const method = letter.generation_method || 'N/A';
                                        const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
                                        const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                                        const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

                                         return (
                                             <tr key={pk}>
                                                 <td>{globalIndex + 1}</td>
                                                 <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
                                                 <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
                                                 <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
                                                 <td className="text-center">
                                                     <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
                                                         {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
                                                     </Button>
                                                 </td>
                                                 
                                                 <td>{formatDateTime(letter.Time)}</td>
                                                 
                                                 <td className="text-center">
                                                     <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk, letter.position || letter.opening_post || "Employee")} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
                                                         {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
                                                     </Button>
                                                 </td>
                                                 <td className="text-center">
                                                     {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
                                                 </td>
                                             </tr>
                                         );
                                     })
                                 ) : (
                                     <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
                                 )}
                                 </tbody>
                             </Table>
                         </div>

                        {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
                             <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
                                 <div className="d-flex align-items-center">
                                     <span className="me-2 text-muted small">Rows:</span>
                                     <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                         <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
                                     </Form.Select>
                                <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem,                                                                                                                                                                                              filteredLetters.length)} of {filteredLetters.length} entries</span>
                                 </div>
                                 <Pagination size="sm" className="mb-0">
                                      <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                     <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                     <Pagination.Item active>{currentPage}</Pagination.Item>
                                     {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
                                     {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
                                     {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
                                     <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                     <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                                 </Pagination>
                             </div>
                        )}
                    </Card.Body>
                </Card>
            </Container>
          </main>
        </div>

        {/* --- MODAL --- */}
        <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title style={styles.gradientText}>
                     { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
                     { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
                     { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
                     Create New Letter 
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
                <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
                    <div style={styles.modalSection}>
                         <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
                          <Row>
                              <Col md={6} lg={4} className="mb-3">
                                  <Form.Group controlId="generationMethod">
                                      <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
                                      <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
                                          <option value="template">Generate from Template</option>
                                          <option value="custom">Write Custom Content</option>
                                          <option value="upload">Upload Existing PDF</option>
                                      </Form.Select>
                                  </Form.Group>
                              </Col>
                              <Col md={6} lg={4} className="mb-3">
                                  <Form.Group controlId="section">
                                      <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
                                      <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
                                          <option value="Offer Letter">Offer Letter</option>
                                          <option value="Rejection Letter">Rejection Letter</option>
                                      </Form.Select>
                                  </Form.Group>
                              </Col>
                          </Row>
                          <Row>
                               <Col md={6} className="mb-3">
                                  <Form.Group controlId="jobTitleSelect">
                                      <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
                                      <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
                                          <option value="">-- Select Job --</option>
                                          {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
                                      </Form.Select>
                                      {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
                                  </Form.Group>
                              </Col>
                               <Col md={6} className="mb-3">
                                  <Form.Group controlId="candidateNameSelect">
                                      <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
                                      <Select
                                          styles={styles.reactSelectStyles}
                                          options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
                                          placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
                                          isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
                                          noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
                                      />
                                      {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
                                      {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
                                  </Form.Group>
                              </Col>
                          </Row>
                         {showApplicantData && (
                             <Alert variant="secondary" className="p-2 small mt-2 mb-0">
                                 <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
                             </Alert>
                          )}
                    </div>

                    <div style={styles.modalSection}>
                       <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
                         {generationMethod === 'template' && (
                             <>
                               <Row>
                                   <Col md={6} lg={4} className="mb-3">
                                        <Form.Group controlId="dateTemplate">
                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
                                           <InputGroup size="sm">
                                               <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required id="dateTemplateInput" />
                                               <InputGroup.Text 
                                                   style={{ cursor: 'pointer' }} 
                                                   onClick={() => { document.getElementById('dateTemplateInput').showPicker(); }}
                                               >
                                                   <FaCalendar className="text-primary"/>
                                               </InputGroup.Text>
                                           </InputGroup>
                                       </Form.Group>
                                   </Col>
                               </Row>
                               {formData.section === "Offer Letter" && (
                                   <Row>
                                      <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
                                      <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
                                      <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
                                      <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
                                      <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
                                  </Row>
                               )}
                               <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
                                    {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
                                    {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
                                    {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
                               </Form.Group>
                            </>
                         )}
                          {generationMethod === 'custom' && (
                              <>
                                <Row>
                                   <Col md={6} lg={4} className="mb-3">
                                       <Form.Group controlId="dateCustom">
                                          <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
                                          <InputGroup size="sm">
                                              <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required id="dateCustomInput" />
                                              <InputGroup.Text 
                                                  style={{ cursor: 'pointer' }} 
                                                  onClick={() => { document.getElementById('dateCustomInput').showPicker(); }}
                                              >
                                                  <FaCalendar className="text-primary"/>
                                              </InputGroup.Text>
                                          </InputGroup>
                                      </Form.Group>
                                    </Col>
                                   {formData.section === "Offer Letter" && (
                                     <Col md={6} lg={4} className="mb-3">
                                       <Form.Group controlId="hrNameSelectCustom">
                                         <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
                                         <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
                                       </Form.Group>
                                     </Col>
                                   )}
                                </Row>
                                <Form.Group className="mb-3" controlId="customContent">
                                   <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
                                   <RichTextEditor value={customContent} onChange={setCustomContent} placeholder="Enter the full content of the letter here (tables, fonts, colors, and formatting from Word are preserved)..." />
                                </Form.Group>
                                <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
                                   <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
                                   <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
                                    {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
                                    {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
                                    {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
                                </Form.Group>
                             </>
                          )}
                          {generationMethod === 'upload' && (
                              <>
                                <Row>
                                  <Col md={6} lg={4} className="mb-3">
                                     <Form.Group controlId="dateUpload">
                                        <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
                                        <InputGroup size="sm">
                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required id="dateUploadInput" />
                                            <InputGroup.Text 
                                                style={{ cursor: 'pointer' }} 
                                                onClick={() => { document.getElementById('dateUploadInput').showPicker(); }}
                                            >
                                                <FaCalendar className="text-primary"/>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Form.Group>
                                  </Col>
                                  <Col md={6} lg={4} className="mb-3">
                                    <Form.Group controlId="reportingManagerUpload">
                                        <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
                                        <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager Name" size="sm"/>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Alert variant="info" className="d-flex align-items-center small">
                                  <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
                                  Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
                                </Alert>
                                <Form.Group controlId="uploadedFile" className="mb-3">
                                  <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
                                  <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
                                  {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
                                </Form.Group>
                                <Form.Group controlId="signatureImageFileUpload" className="mb-3 mt-3 border-top pt-3">
                                   <Form.Label className="fw-bold small text-uppercase text-muted">Digital Signature <small>(Optional)</small></Form.Label>
                                   <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
                                   {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
                                   {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
                                </Form.Group>
                             </>
                          )}
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-light border-top">
                <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
                <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
                    {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
                    ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
                        (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
                        <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
                      )}
                </Button>
            </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default OfferLetterGenerator;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 
//   const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       setLetters(lettersData);
//       setNoDataFound(lettersData.length === 0);
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       setHrList(Array.isArray(data) ? data : []);
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       setEvaluations(Array.isArray(data) ? data : []);
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         setInterviewEvaluations(Array.isArray(data) ? data : []);
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const fetchDetailedApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//       setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching detailed applicants:", error); }
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations(),
//              fetchDetailedApplicants()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations, fetchDetailedApplicants]);

//   // --- Processing ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       return (
//         letter.candidate_name?.toLowerCase().includes(searchLower) ||
//         letter.LetterType?.toLowerCase().includes(searchLower) ||
//         letter.generation_method?.toLowerCase().includes(searchLower) ||
//         letter.phone?.toLowerCase().includes(searchLower)
//       );
//     });
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//   }, [letters, searchQuery, applySearchAndPagination]);

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, letterId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonText: 'Yes, send it!',
//      });

//      if (!result.isConfirmed) return;

//      setIsSending(prev => ({ ...prev, [letterId]: true }));
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;

//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: cleanPath, 
//          letter_type: LetterType,
//          letter_id: letterId
//        });
//        setLetters(prevLetters => prevLetters.map(l => l.id === letterId ? { ...l, sent: true } : l));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${letterId}/`, { sent: 1 });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false });
//      } catch (error) { 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred." }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [letterId]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_'));
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          Swal.fire("Error", "Could not download PDF.", "error"); 
//      } finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = (e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    };

//    const handleHrChange = (selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    };

//    const handleFileChange = (e) => setUploadedFile(e.target.files[0] || null);

//    const handleSignatureFileChange = async (e) => {
//      const file = e.target.files[0] || null;
//      if (!file) return;
//      setIsProcessingSignature(true);
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        setSignatureFile(new File([processedBlob], `sig_${Date.now()}.png`, { type: "image/png" }));
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        Swal.fire({ icon: "error", title: "Background Removal Failed" });
//      } finally { setIsProcessingSignature(false); }
//    };

//    const handleJobTitleChange = (event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      setSelectedJobLabel(jobObj?.label || "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//      setFormData(prev => ({ ...initialFormData, position: jobObj?.pureTitle || '', opening_post: jobObj?.type || '' }));
//      if (postingId && candidatesMap[postingId]) {
//          setFilteredCandidateOptions(candidatesMap[postingId].map(c => ({ value: c.id, label: `${c.name} (${c.email})`, fullName: c.name, email: c.email, details: c.details })));
//      }
//    };

//    const handleCandidateChange = (selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || "";
     
//      // FIXED LOGIC: Match "user" from detailed applicants with "user_id" from the letter context
//      const contextUserId = selectedOption?.details?.user_id || selectedOption?.details?.user;

//      const detailedApp = allDetailedApplicants.find(app => 
//         Number(app.user) === Number(contextUserId)
//      );

//      let candAddress = "", candPin = "", candPhone = "";

//      if (detailedApp) {
//         // Pull specifically from the requested detailed API fields
//         candAddress = detailedApp.address_type || "";
//         candPin = detailedApp.zip_code || "";
//         candPhone = detailedApp.phone || "";
//      } else {
//         // Fallback to basic candidate details if not found in detailed list
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || "";
//         candPhone = details.phone || details.mobile || "";
//      }

//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ 
//         ...prevState, 
//         candidateName: applicantName, 
//         user_id: applicantId, 
//         address: candAddress, 
//         pinCode: candPin, 
//         mobileNumber: candPhone 
//      }));
//      setShowApplicantData(true);
//    }; 

//    const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Error", "Select job and candidate", "warning"); setIsLoading(false); return; }
        
//         let payload = new FormData();
//         payload.append('opening_post', formData.opening_post);
//         if (selectedCandidate?.email) payload.append('candidate_email', selectedCandidate.email);
        
//         try {
//             if (generationMethod === "template") {
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); 
//                 payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/offer_letter/", payload);
//                 navigate(formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform", { state: { ...formData, generationMethod: 'template', signaturePreviewUrl, jobTitle: selectedJobLabel } });
//             } else if (generationMethod === "custom") {
//                 payload.append('evaluation_id', formData.user_id); payload.append('candidateName', formData.candidateName);
//                 payload.append('letterType', formData.section); payload.append('customContent', customContent); payload.append('date', formData.date);
//                 if (signatureFile) payload.append('digital_signature', signatureFile);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/create_custom_letter/", payload);
//                 navigate("/letterform", { state: { ...formData, customContent, generationMethod: 'custom', signaturePreviewUrl } });
//             } else if (generationMethod === "upload") {
//                 payload.append('evaluation_id', formData.user_id); payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile); payload.append('date', formData.date);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/upload_existing_letter/", payload);
//                 fetchLetters();
//                 handleCloseModal();
//             }
//             Swal.fire("Success", "Process completed", "success");
//         } catch (error) { Swal.fire("Error", error.response?.data?.error || error.message, "error"); } finally { setIsLoading(false); }
//    };

//    const handleOpenModal = () => {
//      setFormData(initialFormData); setSelectedCandidate(null); setShowModal(true);
//    };

//    const handleCloseModal = () => setShowModal(false);
//    const formatDateTime = (s) => s ? new Date(s).toLocaleString() : "N/A";
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             <FaPlus className="me-1" /> Create Letter
//                         </Button>
//                     </Card.Header>
//                      <Card.Body className="d-flex flex-column p-4">
//                          <Row className="mb-4">
//                              <Col md={5}><InputGroup size="sm"><Form.Control placeholder="Search..." onChange={(e) => setSearchQuery(e.target.value)} /><InputGroup.Text><FaSearch /></InputGroup.Text></InputGroup></Col>
//                          </Row>
//                          <Table hover responsive className="small">
//                              <thead className="table-light">
//                                   <tr><th>#</th><th>Candidate</th><th>Type</th><th>Method</th><th className="text-center">Download</th><th>Date</th><th className="text-center">Send</th><th className="text-center">Status</th></tr>
//                              </thead>
//                              <tbody>
//                              {isLoadingData ? <tr><td colSpan="8" className="text-center"><Spinner animation="border" /></td></tr> :
//                                  currentItems.map((letter, index) => {
//                                     const isSent = letter.sent === true || letter.sent === 1 || letter.sent === "true";
//                                     return (
//                                         <tr key={letter.id}>
//                                             <td>{indexOfFirstItem + index + 1}</td>
//                                             <td>{letter.candidate_name}</td>
//                                             <td>{letter.LetterType}</td>
//                                             <td><Badge bg="info">{letter.generation_method}</Badge></td>
//                                             <td className="text-center"><Button size="sm" variant="link" onClick={() => downloadPdf(letter.pdf_path, letter.id, letter.candidate_name, letter.LetterType)}><FaDownload /></Button></td>
//                                             <td>{formatDateTime(letter.Time)}</td>
//                                             <td className="text-center"><Button size="sm" variant="outline-success" onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, letter.id)} disabled={isSent}><FaPaperPlane /></Button></td>
//                                             <td className="text-center">{isSent ? <FcApproval size="20" /> : <FcHighPriority size="20" />}</td>
//                                         </tr>
//                                     );
//                                  })
//                              }
//                              </tbody>
//                          </Table>
//                          <Pagination className="mt-3 justify-content-end">
//                              {[...Array(totalPages)].map((_, i) => <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>)}
//                          </Pagination>
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static">
//             <Modal.Header closeButton><Modal.Title style={styles.gradientText}>Create New Letter</Modal.Title></Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
//                 <Form onSubmit={handleSubmit} id="letterForm">
//                     <div style={styles.modalSection}>
//                         <h5>Step 1: Selection</h5>
//                         <Row>
//                             <Col md={4}><Form.Group><Form.Label>Method</Form.Label><Form.Select value={generationMethod} onChange={e => setGenerationMethod(e.target.value)} size="sm"><option value="template">Template</option><option value="custom">Custom</option><option value="upload">Upload</option></Form.Select></Form.Group></Col>
//                             <Col md={4}><Form.Group><Form.Label>Type</Form.Label><Form.Select name="section" value={formData.section} onChange={handleChange} size="sm"><option value="Offer Letter">Offer Letter</option><option value="Rejection Letter">Rejection Letter</option></Form.Select></Form.Group></Col>
//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={6}><Form.Group><Form.Label>Job</Form.Label><Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} size="sm"><option value="">Select Job</option>{processedJobs.map(j => <option key={j.id} value={j.id}>{j.label}</option>)}</Form.Select></Form.Group></Col>
//                             <Col md={6}><Form.Group><Form.Label>Candidate</Form.Label><Select options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange} isDisabled={!selectedJobTitle} styles={styles.reactSelectStyles}/></Form.Group></Col>
//                         </Row>
//                         {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-3"><FaInfoCircle /> <strong>Details:</strong> {address}, {pinCode}, Ph: {mobileNumber}</Alert>
//                         )}
//                     </div>

//                     <div style={styles.modalSection}>
//                         <h5>Step 2: Details</h5>
//                         <Row>
//                             <Col md={4}><Form.Group><Form.Label>Date</Form.Label><Form.Control type="date" name="date" value={formData.date} onChange={handleChange} size="sm" required/></Form.Group></Col>
//                             {formData.section === "Offer Letter" && generationMethod === "template" && (
//                                 <>
//                                     <Col md={4}><Form.Group><Form.Label>HR</Form.Label><Select options={hrList.map(h => ({value: h.id, label: h.name}))} onChange={handleHrChange} styles={styles.reactSelectStyles}/></Form.Group></Col>
//                                     <Col md={4}><Form.Group><Form.Label>Position</Form.Label><Form.Control name="position" value={formData.position} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>Salary</Form.Label><Form.Control name="salary" value={formData.salary} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>Manager</Form.Label><Form.Control name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>HQ</Form.Label><Form.Control name="headquarter" value={formData.headquarter} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                 </>
//                             )}
//                         </Row>
//                         {generationMethod === "custom" && <Form.Group className="mt-3"><Form.Label>Content</Form.Label><Form.Control as="textarea" rows={6} value={customContent} onChange={e => setCustomContent(e.target.value)}/></Form.Group>}
//                         {generationMethod === "upload" && <Form.Group className="mt-3"><Form.Label>PDF</Form.Label><Form.Control type="file" accept=".pdf" onChange={handleFileChange}/></Form.Group>}
//                         {(generationMethod === "template" || generationMethod === "custom") && (
//                             <Form.Group className="mt-3">
//                                 <Form.Label>Signature (Optional)</Form.Label>
//                                 <Form.Control type="file" onChange={handleSignatureFileChange} size="sm"/>
//                                 {signaturePreviewUrl && <img src={signaturePreviewUrl} alt="Preview" style={styles.signaturePreview}/>}
//                             </Form.Group>
//                         )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
//                 <Button variant="primary" type="submit" form="letterForm" disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : "Generate"}</Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 
//   const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;
//       let lettersData = Array.isArray(data) ? data : (data?.letters || []);
//       setLetters(lettersData);
//       setNoDataFound(lettersData.length === 0);
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       setHrList(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching HR list:", error); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       setEvaluations(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching evaluations:", error); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         setInterviewEvaluations(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching interview evaluations:", error); }
//   }, []);

//   const fetchDetailedApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//       setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching detailed applicants:", error); }
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations(),
//              fetchDetailedApplicants()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations, fetchDetailedApplicants]);

//   // --- Processing ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       return (
//         letter.candidate_name?.toLowerCase().includes(searchLower) ||
//         letter.LetterType?.toLowerCase().includes(searchLower) ||
//         letter.generation_method?.toLowerCase().includes(searchLower) ||
//         letter.phone?.toLowerCase().includes(searchLower)
//       );
//     });
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//   }, [letters, searchQuery, applySearchAndPagination]);

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, letterId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonText: 'Yes, send it!',
//      });

//      if (!result.isConfirmed) return;

//      setIsSending(prev => ({ ...prev, [letterId]: true }));
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;

//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: cleanPath, 
//          letter_type: LetterType,
//          letter_id: letterId
//        });
//        setLetters(prevLetters => prevLetters.map(l => l.id === letterId ? { ...l, sent: true } : l));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${letterId}/`, { sent: 1 });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false });
//      } catch (error) { 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred." }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [letterId]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      let cleanPath = pdfPath.startsWith('/') ? pdfPath.substring(1) : pdfPath;
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_'));
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          Swal.fire("Error", "Could not download PDF.", "error"); 
//      } finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = (e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    };

//    const handleHrChange = (selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    };

//    const handleFileChange = (e) => setUploadedFile(e.target.files[0] || null);

//    const handleSignatureFileChange = async (e) => {
//      const file = e.target.files[0] || null;
//      if (!file) return;
//      setIsProcessingSignature(true);
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        setSignatureFile(new File([processedBlob], `sig_${Date.now()}.png`, { type: "image/png" }));
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        Swal.fire({ icon: "error", title: "Background Removal Failed" });
//      } finally { setIsProcessingSignature(false); }
//    };

//    const handleJobTitleChange = (event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      setSelectedJobLabel(jobObj?.label || "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//      setFormData(prev => ({ ...initialFormData, position: jobObj?.pureTitle || '', opening_post: jobObj?.type || '' }));
//      if (postingId && candidatesMap[postingId]) {
//          setFilteredCandidateOptions(candidatesMap[postingId].map(c => ({ value: c.id, label: `${c.name} (${c.email})`, fullName: c.name, email: c.email, details: c.details })));
//      }
//    };

//    const handleCandidateChange = (selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || "";
     
//      // NEW LOGIC: Fetch from detailed applicant list
//      const detailedApp = allDetailedApplicants.find(app => 
//         String(app.id) === String(applicantId) || app.email === selectedOption?.email
//      );

//      let candAddress = "", candPin = "", candPhone = "";

//      if (detailedApp) {
//         // Construct detailed address from the provided API format
//         const addrParts = [
//             detailedApp.village, 
//             detailedApp.tehsil, 
//             detailedApp.district, 
//             detailedApp.state, 
//             detailedApp.country
//         ].filter(Boolean);
        
//         candAddress = addrParts.join(", ");
//         candPin = detailedApp.zip_code || "";
//         candPhone = detailedApp.phone || "";
//      } else {
//         // Fallback to evaluation details if not in detailed list
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || "";
//         candPhone = details.phone || details.mobile || "";
//      }

//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      setShowApplicantData(true);
//    }; 

//    const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Error", "Select job and candidate", "warning"); setIsLoading(false); return; }
        
//         let payload = new FormData();
//         payload.append('opening_post', formData.opening_post);
//         if (selectedCandidate?.email) payload.append('candidate_email', selectedCandidate.email);
        
//         try {
//             if (generationMethod === "template") {
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); 
//                 payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/offer_letter/", payload);
//                 navigate(formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform", { state: { ...formData, generationMethod: 'template', signaturePreviewUrl, jobTitle: selectedJobLabel } });
//             } else if (generationMethod === "custom") {
//                 payload.append('evaluation_id', formData.user_id); payload.append('candidateName', formData.candidateName);
//                 payload.append('letterType', formData.section); payload.append('customContent', customContent); payload.append('date', formData.date);
//                 if (signatureFile) payload.append('digital_signature', signatureFile);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/create_custom_letter/", payload);
//                 navigate("/letterform", { state: { ...formData, customContent, generationMethod: 'custom', signaturePreviewUrl } });
//             } else if (generationMethod === "upload") {
//                 payload.append('evaluation_id', formData.user_id); payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile); payload.append('date', formData.date);
//                 await axios.post("https://raasbackend.vetrinahealthcare.com/upload_existing_letter/", payload);
//                 fetchLetters();
//                 handleCloseModal();
//             }
//             Swal.fire("Success", "Process completed", "success");
//         } catch (error) { Swal.fire("Error", error.response?.data?.error || error.message, "error"); } finally { setIsLoading(false); }
//    };

//    const handleOpenModal = () => {
//      setFormData(initialFormData); setSelectedCandidate(null); setShowModal(true);
//    };

//    const handleCloseModal = () => setShowModal(false);
//    const formatDateTime = (s) => s ? new Date(s).toLocaleString() : "N/A";
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             <FaPlus className="me-1" /> Create Letter
//                         </Button>
//                     </Card.Header>
//                      <Card.Body className="d-flex flex-column p-4">
//                          <Row className="mb-4">
//                              <Col md={5}><InputGroup size="sm"><Form.Control placeholder="Search..." onChange={(e) => setSearchQuery(e.target.value)} /><InputGroup.Text><FaSearch /></InputGroup.Text></InputGroup></Col>
//                          </Row>
//                          <Table hover responsive className="small">
//                              <thead className="table-light">
//                                   <tr><th>#</th><th>Candidate Name</th><th>Letter Type</th><th>Method</th><th className="text-center">Download</th><th>Generated On</th><th className="text-center">Send</th><th className="text-center">Status</th></tr>
//                              </thead>
//                              <tbody>
//                              {isLoadingData ? <tr><td colSpan="8" className="text-center"><Spinner animation="border" /></td></tr> :
//                                  currentItems.map((letter, index) => {
//                                     const isSent = letter.sent === true || letter.sent === 1 || letter.sent === "true";
//                                     return (
//                                         <tr key={letter.id}>
//                                             <td>{indexOfFirstItem + index + 1}</td>
//                                             <td>{letter.candidate_name}</td>
//                                             <td>{letter.LetterType}</td>
//                                             <td><Badge bg="info">{letter.generation_method}</Badge></td>
//                                             <td className="text-center"><Button size="sm" variant="link" onClick={() => downloadPdf(letter.pdf_path, letter.id, letter.candidate_name, letter.LetterType)}><FaDownload /></Button></td>
//                                             <td>{formatDateTime(letter.Time)}</td>
//                                             <td className="text-center"><Button size="sm" variant="outline-success" onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, letter.id)} disabled={isSent}><FaPaperPlane /></Button></td>
//                                             <td className="text-center">{isSent ? <FcApproval size="20" /> : <FcHighPriority size="20" />}</td>
//                                         </tr>
//                                     );
//                                  })
//                              }
//                              </tbody>
//                          </Table>
//                          <Pagination className="mt-3 justify-content-end">
//                              {[...Array(totalPages)].map((_, i) => <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>)}
//                          </Pagination>
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static">
//             <Modal.Header closeButton><Modal.Title style={styles.gradientText}>Create New Letter</Modal.Title></Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
//                 <Form onSubmit={handleSubmit} id="letterForm">
//                     <div style={styles.modalSection}>
//                         <h5>Step 1: Selection</h5>
//                         <Row>
//                             <Col md={4}><Form.Group><Form.Label>Method</Form.Label><Form.Select value={generationMethod} onChange={e => setGenerationMethod(e.target.value)} size="sm"><option value="template">Template</option><option value="custom">Custom</option><option value="upload">Upload</option></Form.Select></Form.Group></Col>
//                             <Col md={4}><Form.Group><Form.Label>Type</Form.Label><Form.Select name="section" value={formData.section} onChange={handleChange} size="sm"><option value="Offer Letter">Offer Letter</option><option value="Rejection Letter">Rejection Letter</option></Form.Select></Form.Group></Col>
//                         </Row>
//                         <Row className="mt-3">
//                             <Col md={6}><Form.Group><Form.Label>Job</Form.Label><Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} size="sm"><option value="">Select Job</option>{processedJobs.map(j => <option key={j.id} value={j.id}>{j.label}</option>)}</Form.Select></Form.Group></Col>
//                             <Col md={6}><Form.Group><Form.Label>Candidate</Form.Label><Select options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange} isDisabled={!selectedJobTitle} styles={styles.reactSelectStyles}/></Form.Group></Col>
//                         </Row>
//                         {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-3"><FaInfoCircle /> <strong>Details:</strong> {address}, {pinCode}, Ph: {mobileNumber}</Alert>
//                         )}
//                     </div>

//                     <div style={styles.modalSection}>
//                         <h5>Step 2: Details</h5>
//                         <Row>
//                             <Col md={4}><Form.Group><Form.Label>Date</Form.Label><Form.Control type="date" name="date" value={formData.date} onChange={handleChange} size="sm" required/></Form.Group></Col>
//                             {formData.section === "Offer Letter" && generationMethod === "template" && (
//                                 <>
//                                     <Col md={4}><Form.Group><Form.Label>HR</Form.Label><Select options={hrList.map(h => ({value: h.id, label: h.name}))} onChange={handleHrChange} styles={styles.reactSelectStyles}/></Form.Group></Col>
//                                     <Col md={4}><Form.Group><Form.Label>Position</Form.Label><Form.Control name="position" value={formData.position} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>Salary (LPA)</Form.Label><Form.Control name="salary" value={formData.salary} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>Manager</Form.Label><Form.Control name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                     <Col md={4} className="mt-2"><Form.Group><Form.Label>HQ</Form.Label><Form.Control name="headquarter" value={formData.headquarter} onChange={handleChange} size="sm"/></Form.Group></Col>
//                                 </>
//                             )}
//                         </Row>
//                         {generationMethod === "custom" && <Form.Group className="mt-3"><Form.Label>Content</Form.Label><Form.Control as="textarea" rows={6} value={customContent} onChange={e => setCustomContent(e.target.value)}/></Form.Group>}
//                         {generationMethod === "upload" && <Form.Group className="mt-3"><Form.Label>PDF</Form.Label><Form.Control type="file" accept=".pdf" onChange={handleFileChange}/></Form.Group>}
//                         {(generationMethod === "template" || generationMethod === "custom") && (
//                             <Form.Group className="mt-3">
//                                 <Form.Label>Signature (Optional)</Form.Label>
//                                 <Form.Control type="file" onChange={handleSignatureFileChange} size="sm"/>
//                                 {signaturePreviewUrl && <img src={signaturePreviewUrl} alt="Preview" style={styles.signaturePreview}/>}
//                             </Form.Group>
//                         )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
//                 <Button variant="primary" type="submit" form="letterForm" disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : "Generate"}</Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;





// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   // Removed sentStatus state to prevent sync issues. We will use letters state directly.
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 
//   const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
      
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

// const fetchDetailedApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//       setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching detailed applicants:", error); }
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations(),
//              fetchDetailedApplicants()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);

//   // --- Processing ... ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, letterId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      // --- Confirmation Alert BEFORE sending ---
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) {
//         return; 
//      }

//      setIsSending(prev => ({ ...prev, [letterId]: true }));
     
//      // Remove leading slash for consistency with payload requirement
//      let cleanPath = pdfPath;
//      if (cleanPath.startsWith('/')) {
//         cleanPath = cleanPath.substring(1);
//      }

//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: cleanPath, 
//          letter_type: LetterType,
//          letter_id: letterId
//        });
       
//        // Update UI state immediately to reflect 'Sent'
//        setLetters(prevLetters => 
//          prevLetters.map(l => l.id === letterId ? { ...l, sent: true } : l)
//        );
       
//        // Call API to persist status if necessary (redundancy for safety)
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${letterId}/`, { sent: 1 });

//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [letterId]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
     
//      // --- FIX: Sanitize Path ---
//      let cleanPath = pdfPath;
//      if (cleanPath.startsWith('/')) {
//          cleanPath = cleanPath.substring(1);
//      }
     
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          console.error("Error downloading PDF:", error); 
//          Swal.fire("Error", "Could not download PDF. File may not exist on server.", "error"); 
//      }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = (selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || "";
     
//      // NEW LOGIC: Fetch from detailed applicant list
//      const detailedApp = allDetailedApplicants.find(app => 
//         String(app.id) === String(applicantId) || app.email === selectedOption?.email
//      );

//      let candAddress = "", candPin = "", candPhone = "";

//      if (detailedApp) {
//         // Construct detailed address from the provided API format
//         const addrParts = [
//             detailedApp.village, 
//             detailedApp.tehsil, 
//             detailedApp.district, 
//             detailedApp.state, 
//             detailedApp.country
//         ].filter(Boolean);
        
//         candAddress = addrParts.join(", ");
//         candPin = detailedApp.zip_code || "";
//         candPhone = detailedApp.phone || "";
//      } else {
//         // Fallback to evaluation details if not in detailed list
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || "";
//         candPhone = details.phone || details.mobile || "";
//      }

//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      setShowApplicantData(true);
//    }; 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";

//         try {
//             // Common optional fields
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
            
//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
                
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('letterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
                
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('digital_signature', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
            
//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
                
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
                
//                 payload.append('generation_method', 'upload');
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('date', formData.date);
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
                
//                 if (signatureFile) {
//                     payload.append('digital_signature', signatureFile, signatureFile.name);
//                 }

//                 successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
                                        
//                                         // Robust check for sent status: handles boolean true, string "true", or number 1
//                                         const isSent = letter.sent === true || letter.sent === 1 || letter.sent === "true";
                                        
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Row>
//                                   <Col md={6} lg={4} className="mb-3">
//                                      <Form.Group controlId="dateUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                         <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                   <Col md={6} lg={4} className="mb-3">
//                                     <Form.Group controlId="reportingManagerUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
//                                         <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager Name" size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                 </Row>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileUpload" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Digital Signature <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                    {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                    {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
      
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);

//   // --- Processing ... ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk, userId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      // --- Confirmation Alert BEFORE sending ---
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) {
//         return; // User cancelled
//      }

//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        // Added evaluation_id (userId) to payload so backend can find the email address
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: pdfPath, 
//          letter_type: LetterType,
//          evaluation_id: userId
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [pk]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
     
//      // --- FIX: Sanitize Path ---
//      let cleanPath = pdfPath;
//      if (cleanPath.startsWith('/')) {
//          cleanPath = cleanPath.substring(1);
//      }
     
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          console.error("Error downloading PDF:", error); 
//          Swal.fire("Error", "Could not download PDF. File may not exist on server.", "error"); 
//      }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
//      const existingLetter = letters.find(l => (l.user_id && String(l.user_id) === String(applicantId)) || (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase()));
//      let candAddress = "", candPin = "", candPhone = "";
//      if (existingLetter) {
//         candAddress = existingLetter.combined_address || ""; candPin = existingLetter.zip_code || ""; candPhone = existingLetter.phone || "";
//      } else {
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || ""; candPin = details.zip_code || details.pincode || details.pin_code || ""; candPhone = details.phone || details.mobile || details.contact_number || "";
//      }
//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      if (existingLetter || selectedOption?.details) { setShowApplicantData(true); }
//    }, [letters]); 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";

//         try {
//             // Common optional fields
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
            
//             } else if (generationMethod === "custom") {
//                 // CHANGED: Specific endpoint and payload keys for 'Write Custom Content'
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
                
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
                
//                 // Mapping keys exactly as requested
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('letterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
                
//                 // Optional: HR/Signature if available (though not strictly in the text payload, often needed for rejection letters etc)
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('digital_signature', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
            
//             } else if (generationMethod === "upload") {
//                 // CHANGED: Specific endpoint and payload keys for 'Upload Existing PDF'
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
                
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
                
//                 // Mapping keys exactly as requested in the screenshot
//                 payload.append('generation_method', 'upload');
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('date', formData.date);
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
                
//                 if (signatureFile) {
//                     payload.append('digital_signature', signatureFile, signatureFile.name);
//                 }

//                 successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      {/* Passed letter.user_id (which corresponds to evaluation_id) to sendEmail */}
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk, letter.user_id)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Row>
//                                   <Col md={6} lg={4} className="mb-3">
//                                      <Form.Group controlId="dateUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                         <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                     </Form.Group>
//                                   </Col>
                                 
//                                 </Row>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
                               
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
      
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);

//   // --- Processing ... ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk, userId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      // --- Confirmation Alert BEFORE sending ---
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) {
//         return; // User cancelled
//      }

//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        // Added evaluation_id (userId) to payload so backend can find the email address
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: pdfPath, 
//          letter_type: LetterType,
//          evaluation_id: userId
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [pk]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
     
//      // --- FIX: Sanitize Path ---
//      // Remove leading slash if present to ensure the backend treats it as a relative path
//      let cleanPath = pdfPath;
//      if (cleanPath.startsWith('/')) {
//          cleanPath = cleanPath.substring(1);
//      }
//      // Optional: If path starts with "media/", you might need to strip that too depending on backend
//      // but usually stripping the leading slash is enough for os.path.join()
     
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { 
//          console.error("Error downloading PDF:", error); 
//          Swal.fire("Error", "Could not download PDF. File may not exist on server.", "error"); 
//      }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
//      const existingLetter = letters.find(l => (l.user_id && String(l.user_id) === String(applicantId)) || (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase()));
//      let candAddress = "", candPin = "", candPhone = "";
//      if (existingLetter) {
//         candAddress = existingLetter.combined_address || ""; candPin = existingLetter.zip_code || ""; candPhone = existingLetter.phone || "";
//      } else {
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || ""; candPin = details.zip_code || details.pincode || details.pin_code || ""; candPhone = details.phone || details.mobile || details.contact_number || "";
//      }
//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      if (existingLetter || selectedOption?.details) { setShowApplicantData(true); }
//    }, [letters]); 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";
//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }
                
//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 payload.append('generation_method', 'custom'); 
                
//                 // Defaults for validation
//                 payload.append('position', formData.position || selectedJobLabel || "N/A");
//                 payload.append('salary', formData.salary || "0");
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
//                 payload.append('headquarter', formData.headquarter || "N/A");

//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
                
//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
                
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
                
//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('date', formData.date);
//                 payload.append('generation_method', 'upload'); 

//                 // Defaults for validation
//                 payload.append('position', formData.position || selectedJobLabel || "N/A");
//                 payload.append('salary', formData.salary || "0");
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
//                 payload.append('headquarter', formData.headquarter || "N/A");
//                 payload.append('customContent', "Uploaded existing letter."); 

//                 successMessage = `existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      {/* Passed letter.user_id (which corresponds to evaluation_id) to sendEmail */}
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk, letter.user_id)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Row>
//                                   <Col md={6} lg={4} className="mb-3">
//                                      <Form.Group controlId="dateUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                         <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                 </Row>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
      
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);

//   // --- Processing ... ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk, userId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      // --- Confirmation Alert BEFORE sending ---
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) {
//         return; // User cancelled
//      }

//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        // Added evaluation_id (userId) to payload so backend can find the email address
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: pdfPath, 
//          letter_type: LetterType,
//          evaluation_id: userId
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [pk]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
//      const existingLetter = letters.find(l => (l.user_id && String(l.user_id) === String(applicantId)) || (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase()));
//      let candAddress = "", candPin = "", candPhone = "";
//      if (existingLetter) {
//         candAddress = existingLetter.combined_address || ""; candPin = existingLetter.zip_code || ""; candPhone = existingLetter.phone || "";
//      } else {
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || ""; candPin = details.zip_code || details.pincode || details.pin_code || ""; candPhone = details.phone || details.mobile || details.contact_number || "";
//      }
//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      if (existingLetter || selectedOption?.details) { setShowApplicantData(true); }
//    }, [letters]); 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom' || generationMethod === 'upload')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";
//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }
                
//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 payload.append('generation_method', 'custom'); 
                
//                 // Defaults for validation
//                 payload.append('position', formData.position || selectedJobLabel || "N/A");
//                 payload.append('salary', formData.salary || "0");
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
//                 payload.append('headquarter', formData.headquarter || "N/A");

//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
                
//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
//             } else if (generationMethod === "upload") {
//                 // CHANGED: Endpoint and logic for Upload method to use the offer_letter endpoint with "existing" method
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
                
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
                
//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('date', formData.date);
//                 payload.append('generation_method', 'existing'); // Maps 'upload' UI to 'existing' backend logic

//                 // Defaults for validation (backend requires these fields even for uploads)
//                 payload.append('position', formData.position || selectedJobLabel || "N/A");
//                 payload.append('salary', formData.salary || "0");
//                 payload.append('reporting_manager', formData.reporting_manager || "N/A");
//                 payload.append('headquarter', formData.headquarter || "N/A");
//                 payload.append('customContent', "Uploaded existing letter."); // Safe default if backend requires it

//                 successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      {/* Passed letter.user_id (which corresponds to evaluation_id) to sendEmail */}
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk, letter.user_id)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Row>
//                                   <Col md={6} lg={4} className="mb-3">
//                                      <Form.Group controlId="dateUpload">
//                                         <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                         <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                     </Form.Group>
//                                   </Col>
//                                 </Row>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); 
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;

//       let lettersData = [];
      
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object' && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       } else if (data && typeof data === 'object') {
//           lettersData = [data];
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);

//   // --- Processing ... ---
//   useEffect(() => {
//     const jobMap = {}; 
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = { id: postingId, pureTitle: jobTitle || postingId, label: `${jobTitle || 'Unknown Job'} (${postingId})`, type: jobType || "", candidates: [] };
//         } else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) { jobMap[postingId].type = jobType; }
//         }
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) { jobMap[postingId].candidates.push(candidateObj); }
//     };
//     evaluations.forEach(ev => { addCandidate(ev.posting_id, ev.job_title, ev.posting_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     interviewEvaluations.forEach(ev => { const title = ev.job_title || ev.job_type || "Position"; addCandidate(ev.job_posting, title, ev.job_type, { id: ev.id, name: ev.candidate_name, email: ev.candidate_email, details: ev }); });
//     setProcessedJobs(Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label)));
//     const candMap = {}; Object.values(jobMap).forEach(job => { candMap[job.id] = job.candidates; }); setCandidatesMap(candMap);
//   }, [evaluations, interviewEvaluations]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       const phoneMatches = letter.phone?.toLowerCase().includes(searchLower); 
//       return candidateMatches || typeMatches || methodMatches || phoneMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk, userId) => {
//      if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to send.", "info"); return; }
     
//      // --- Confirmation Alert BEFORE sending ---
//      const result = await Swal.fire({
//         title: 'Confirm Send',
//         text: `Are you sure you want to send the ${LetterType} email to ${candidateName}?`,
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Yes, send it!',
//         cancelButtonText: 'Cancel'
//      });

//      if (!result.isConfirmed) {
//         return; // User cancelled
//      }

//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        // Added evaluation_id (userId) to payload so backend can find the email address
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, 
//          pdf_path: pdfPath, 
//          letter_type: LetterType,
//          evaluation_id: userId
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { 
//          console.error("Error sending email:", error); 
//          Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); 
//      } finally { 
//          setIsSending(prev => ({ ...prev, [pk]: false })); 
//      }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath || pdfPath === "Not available") { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
//      setSelectedJobLabel(jobObj ? jobObj.label : "");
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false); setAddress(""); setPinCode(""); setMobileNumber("");
//      setFormData(prev => ({ ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: cleanTitle || '', opening_post: jobType }));
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({ value: c.id, label: `${c.name} ${c.email ? `(${c.email})` : ''}`, fullName: c.name, email: c.email, details: c.details })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
//      const existingLetter = letters.find(l => (l.user_id && String(l.user_id) === String(applicantId)) || (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase()));
//      let candAddress = "", candPin = "", candPhone = "";
//      if (existingLetter) {
//         candAddress = existingLetter.combined_address || ""; candPin = existingLetter.zip_code || ""; candPhone = existingLetter.phone || "";
//      } else {
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || ""; candPin = details.zip_code || details.pincode || details.pin_code || ""; candPhone = details.phone || details.mobile || details.contact_number || "";
//      }
//      setAddress(candAddress); setPinCode(candPin); setMobileNumber(candPhone); 
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: candAddress, pinCode: candPin, mobileNumber: candPhone }));
//      if (existingLetter || selectedOption?.details) { setShowApplicantData(true); }
//    }, [letters]); 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null; let navigateState = null; let successMessage = "";
//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) { payload.append('candidate_email', selectedCandidate.email); }
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") { if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) { throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template."); } }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('date', formData.date); payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") { payload.append('salary', formData.salary); payload.append('hr_id', formData.hr.id); payload.append('reporting_manager', formData.reporting_manager); payload.append('headquarter', formData.headquarter); }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `${formData.section} template processing initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter; }
//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('customContent', customContent); payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//                 successMessage = `Custom ${formData.section} creation initiated...`; navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, address: formData.address || "Address Not Provided", pinCode: formData.pinCode || "000000", mobileNumber: formData.mobileNumber || "Not Available", customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }
//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }
//                 payload.append('candidate_name', formData.candidateName); payload.append('evaluation_id', formData.user_id); payload.append('LetterType', formData.section); payload.append('uploadedFile', uploadedFile); payload.append('jobTitle', selectedJobLabel || '');
//                 successMessage = `Existing ${formData.section} upload initiated.`; navigateTo = "/letterform"; navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;
//           successMessage = backendSuccessMessage || successMessage;
//           Swal.fire({ title: "Success!", text: successMessage, icon: "success", timer: navigateTo === "/OfferLetter" ? 1500 : 2500, timerProgressBar: true, showConfirmButton: false, }).then(() => { handleCloseModal(); fetchLetters(); if (navigateTo) { navigate(navigateTo, { state: navigateState }); } });
//         } catch (error) { console.error(`Error during ${generationMethod} process:`, error); let errorMsg = error.message; if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; } Swal.fire({ title: "Error!", text: errorMsg, icon: "error" }); } finally { setIsLoading(false); }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle(""); setSelectedJobLabel(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null); setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false); setGenerationMethod("template"); setCustomContent(""); setUploadedFile(null); setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => { setShowModal(false); }, []);
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));
//    const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//    const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; 
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                         const hasPdf = letter.pdf_path && letter.pdf_path !== "Not available";

//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !hasPdf} title={hasPdf ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      {/* Passed letter.user_id (which corresponds to evaluation_id) to sendEmail */}
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk, letter.user_id)} disabled={isSending[pk] || isSent || !hasPdf} title={isSent ? "Email Already Sent" : !hasPdf ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); // Stores data from /get_letters/
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); // Holds Posting ID
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       // --- Updated URL to the specific one requested ---
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/24/");
//       const data = response.data;

//       // Handle both list and single object responses for robustness
//       let lettersData = [];
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && typeof data === 'object') {
//           // Wrap single object in array to treat as list
//           lettersData = [data];
//       } else if (data && Array.isArray(data.letters)) {
//           // Fallback for old structure just in case
//           lettersData = data.letters;
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else { 
//         setLetters([]); 
//         setNoDataFound(true); 
//       }
//     } catch (error) { 
//         console.error("Error fetching letters:", error); 
//         setLetters([]); 
//         setNoDataFound(true); 
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);


//   // --- Process Evaluations & Interview Evaluations for Dropdowns ---
//   useEffect(() => {
//     const jobMap = {}; 
    
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;

//         if (!jobMap[postingId]) {
//             jobMap[postingId] = {
//                 id: postingId,
//                 pureTitle: jobTitle || postingId,
//                 label: `${jobTitle || 'Unknown Job'} (${postingId})`,
//                 type: jobType || "", 
//                 candidates: []
//             };
//         } 
//         else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) {
//                  jobMap[postingId].type = jobType;
//              }
//         }

//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) {
//             jobMap[postingId].candidates.push(candidateObj);
//         }
//     };

//     evaluations.forEach(ev => {
//         addCandidate(ev.posting_id, ev.job_title, ev.posting_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.evaluator_email,
//             details: ev
//         });
//     });

//     interviewEvaluations.forEach(ev => {
//         const title = ev.job_title || ev.job_type || "Position"; 
//         addCandidate(ev.job_posting, title, ev.job_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.candidate_email,
//             details: ev
//         });
//     });

//     const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
//     setProcessedJobs(jobsArray);

//     const candMap = {};
//     Object.values(jobMap).forEach(job => {
//         candMap[job.id] = job.candidates;
//     });
//     setCandidatesMap(candMap);

//   }, [evaluations, interviewEvaluations]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
      
//       // --- Updated key from letter_type to LetterType ---
//       const typeMatches = letter.LetterType?.toLowerCase().includes(searchLower);
      
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => {
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
     
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
     
//      setSelectedJobLabel(jobObj ? jobObj.label : "");

//      setSelectedCandidate(null); 
//      setFilteredCandidateOptions([]); 
//      setShowApplicantData(false);
//      setAddress(""); setPinCode(""); setMobileNumber("");

//      setFormData(prev => ({
//        ...initialFormData, 
//        section: prev.section, 
//        generationMethod: prev.generationMethod, 
//        position: cleanTitle || '',
//        opening_post: jobType 
//      }));

//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({
//              value: c.id, 
//              label: `${c.name} ${c.email ? `(${c.email})` : ''}`,
//              fullName: c.name,
//              email: c.email,
//              details: c.details
//          })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    // --- Candidate Change Handler ---
//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
     
//      // Match by user_id OR by name if user_id matches
//      const existingLetter = letters.find(l => 
//          (l.user_id && String(l.user_id) === String(applicantId)) || 
//          (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase())
//      );

//      let candAddress = "";
//      let candPin = "";
//      let candPhone = "";

//      if (existingLetter) {
//         // Use data from API response if available
//         candAddress = existingLetter.combined_address || "";
//         candPin = existingLetter.zip_code || "";
//         candPhone = existingLetter.phone || "";
//      } else {
//         // Fallback to evaluation details
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || details.pin_code || "";
//         candPhone = details.phone || details.mobile || details.contact_number || "";
//      }

//      setAddress(candAddress); 
//      setPinCode(candPin); 
//      setMobileNumber(candPhone); 
     
//      setFormData(prevState => ({ 
//          ...prevState, 
//          candidateName: applicantName, 
//          user_id: applicantId, 
//          address: candAddress,      
//          pinCode: candPin,          
//          mobileNumber: candPhone    
//      }));

//      if (existingLetter || selectedOption?.details) {
//          setShowApplicantData(true);
//      }
//    }, [letters]); 

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         if (!formData.opening_post && (generationMethod === 'template' || generationMethod === 'custom')) { 
//             console.warn("Opening Post type missing for selected job.");
//         }

//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) {
//                 payload.append('candidate_email', selectedCandidate.email);
//             }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";

//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000"; 
//                 const safeMobile = formData.mobileNumber || "Not Available"; 

//                 navigateState = { 
//                     ...formData, 
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     generationMethod: 'template', 
//                     signaturePreviewUrl: signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
                
//                  if (formData.section !== "Offer Letter") {
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
                
//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000";
//                 const safeMobile = formData.mobileNumber || "Not Available";

//                 navigateState = { 
//                     ...formData,
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     customContent, 
//                     section: formData.section, 
//                     generationMethod: 'custom', 
//                     signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 payload.append('candidate_name', formData.candidateName);
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobLabel || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) {
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             handleCloseModal();
//             fetchLetters();
//             if (navigateTo) {
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle("");
//      setSelectedJobLabel("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []);

//    // --- Utilities ---
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; // API uses 'id'
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A'; // API uses 'generation_method'
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                                        
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  {/* --- Updated Key: LetterType --- */}
//                                                  <td>{letter.LetterType || <span className="text-muted">N/A</span>}</td>
                                                 
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      {/* --- Updated Key: LetterType --- */}
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.LetterType)} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
                                                 
//                                                  {/* --- Updated Key: Time --- */}
//                                                  <td>{formatDateTime(letter.Time)}</td>
                                                 
//                                                  <td className="text-center">
//                                                      {/* --- Updated Key: LetterType --- */}
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.LetterType, pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); // Stores data from /get_letters/
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); // Holds Posting ID
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else { setLetters([]); setNoDataFound(true); }
//     } catch (error) { console.error("Error fetching letters:", error); setLetters([]); setNoDataFound(true); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);


//   // --- Process Evaluations & Interview Evaluations for Dropdowns ---
//   useEffect(() => {
//     const jobMap = {}; 
    
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;

//         if (!jobMap[postingId]) {
//             jobMap[postingId] = {
//                 id: postingId,
//                 pureTitle: jobTitle || postingId,
//                 label: `${jobTitle || 'Unknown Job'} (${postingId})`,
//                 type: jobType || "", 
//                 candidates: []
//             };
//         } 
//         else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) {
//                  jobMap[postingId].type = jobType;
//              }
//         }

//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) {
//             jobMap[postingId].candidates.push(candidateObj);
//         }
//     };

//     evaluations.forEach(ev => {
//         addCandidate(ev.posting_id, ev.job_title, ev.posting_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.evaluator_email,
//             details: ev
//         });
//     });

//     interviewEvaluations.forEach(ev => {
//         const title = ev.job_title || ev.job_type || "Position"; 
//         addCandidate(ev.job_posting, title, ev.job_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.candidate_email,
//             details: ev
//         });
//     });

//     const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
//     setProcessedJobs(jobsArray);

//     const candMap = {};
//     Object.values(jobMap).forEach(job => {
//         candMap[job.id] = job.candidates;
//     });
//     setCandidatesMap(candMap);

//   }, [evaluations, interviewEvaluations]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.letter_type?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => {
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
     
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
     
//      setSelectedJobLabel(jobObj ? jobObj.label : "");

//      setSelectedCandidate(null); 
//      setFilteredCandidateOptions([]); 
//      setShowApplicantData(false);
//      setAddress(""); setPinCode(""); setMobileNumber("");

//      setFormData(prev => ({
//        ...initialFormData, 
//        section: prev.section, 
//        generationMethod: prev.generationMethod, 
//        position: cleanTitle || '',
//        opening_post: jobType 
//      }));

//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({
//              value: c.id, 
//              label: `${c.name} ${c.email ? `(${c.email})` : ''}`,
//              fullName: c.name,
//              email: c.email,
//              details: c.details
//          })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    // --- Candidate Change Handler (PRIORITIZING /get_letters/ DATA) ---
//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
     
//      // 1. Attempt to find this candidate in the existing letters data (from /get_letters/)
//      // We match by user_id OR by name if user_id matches
//      const existingLetter = letters.find(l => 
//          (l.user_id && String(l.user_id) === String(applicantId)) || 
//          (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase())
//      );

//      let candAddress = "";
//      let candPin = "";
//      let candPhone = "";

//      if (existingLetter) {
//         // Use data from /get_letters/ response as requested
//         candAddress = existingLetter.combined_address || "";
//         candPin = existingLetter.zip_code || "";
//         candPhone = existingLetter.phone || "";
//      } else {
//         // Fallback to evaluation details if not found in letters
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || details.pin_code || "";
//         candPhone = details.phone || details.mobile || details.contact_number || "";
//      }

//      // Update UI and Form Data
//      setAddress(candAddress); 
//      setPinCode(candPin); 
//      setMobileNumber(candPhone); 
     
//      setFormData(prevState => ({ 
//          ...prevState, 
//          candidateName: applicantName, 
//          user_id: applicantId, 
//          address: candAddress,      
//          pinCode: candPin,          
//          mobileNumber: candPhone    
//      }));

//      // Show info box if we have data found either in letters OR evaluations
//      if (existingLetter || selectedOption?.details) {
//          setShowApplicantData(true);
//      }
//    }, [letters]); // Depend on letters so we have the API data available

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         if (!formData.opening_post && (generationMethod === 'template' || generationMethod === 'custom')) { 
//             console.warn("Opening Post type missing for selected job.");
//         }

//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) {
//                 payload.append('candidate_email', selectedCandidate.email);
//             }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";

//                 // Ensure Fallback values to prevent preview crash if data is still missing
//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000"; 
//                 const safeMobile = formData.mobileNumber || "Not Available"; 

//                 navigateState = { 
//                     ...formData, 
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     generationMethod: 'template', 
//                     signaturePreviewUrl: signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
                
//                  if (formData.section !== "Offer Letter") {
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
                
//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000";
//                 const safeMobile = formData.mobileNumber || "Not Available";

//                 navigateState = { 
//                     ...formData,
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     customContent, 
//                     section: formData.section, 
//                     generationMethod: 'custom', 
//                     signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobLabel || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) {
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             handleCloseModal();
//             fetchLetters();
//             if (navigateTo) {
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle("");
//      setSelectedJobLabel("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []);

//    // --- Utilities ---
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; // API uses 'id'
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A'; // API uses 'generation_method'
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                                        
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.letter_type || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.letter_type)} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.created_at)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.letter_type, pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]);
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [applicantsList, setApplicantsList] = useState([]); // NEW: Store full applicant details
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); 
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else { setLetters([]); setNoDataFound(true); }
//     } catch (error) { console.error("Error fetching letters:", error); setLetters([]); setNoDataFound(true); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   // NEW: Fetch Applicant Details
//   const fetchApplicants = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setApplicantsList(data); }
//         else { setApplicantsList([]); }
//     } catch (error) { console.error("Error fetching applicants:", error); setApplicantsList([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.pk] = letter.fields.sent == 1;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations(),
//              fetchApplicants() // Add new fetcher
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations, fetchApplicants]);


//   // --- Process Evaluations & Interview Evaluations for Dropdowns ---
//   useEffect(() => {
//     const jobMap = {}; 
    
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;

//         if (!jobMap[postingId]) {
//             jobMap[postingId] = {
//                 id: postingId,
//                 pureTitle: jobTitle || postingId,
//                 label: `${jobTitle || 'Unknown Job'} (${postingId})`,
//                 type: jobType || "", 
//                 candidates: []
//             };
//         } 
//         else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) {
//                  jobMap[postingId].type = jobType;
//              }
//         }

//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) {
//             jobMap[postingId].candidates.push(candidateObj);
//         }
//     };

//     evaluations.forEach(ev => {
//         addCandidate(ev.posting_id, ev.job_title, ev.posting_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.evaluator_email, // Using evaluator_email as proxy if candidate_email not available
//             details: ev
//         });
//     });

//     interviewEvaluations.forEach(ev => {
//         const title = ev.job_title || ev.job_type || "Position"; 
//         addCandidate(ev.job_posting, title, ev.job_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.candidate_email,
//             details: ev
//         });
//     });

//     const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
//     setProcessedJobs(jobsArray);

//     const candMap = {};
//     Object.values(jobMap).forEach(job => {
//         candMap[job.id] = job.candidates;
//     });
//     setCandidatesMap(candMap);

//   }, [evaluations, interviewEvaluations]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.fields.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.fields.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.fields.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => {
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
     
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
     
//      setSelectedJobLabel(jobObj ? jobObj.label : "");

//      setSelectedCandidate(null); 
//      setFilteredCandidateOptions([]); 
//      setShowApplicantData(false);
//      setAddress(""); setPinCode(""); setMobileNumber("");

//      setFormData(prev => ({
//        ...initialFormData, 
//        section: prev.section, 
//        generationMethod: prev.generationMethod, 
//        position: cleanTitle || '',
//        opening_post: jobType 
//      }));

//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({
//              value: c.id, 
//              label: `${c.name} ${c.email ? `(${c.email})` : ''}`,
//              fullName: c.name,
//              email: c.email,
//              details: c.details
//          })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    // --- UPDATED Candidate Change Handler ---
//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
//      const applicantEmail = selectedOption?.email || "";
     
//      // Reset fields first
//      setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
     
//      let foundAddress = "";
//      let foundPin = "";
//      let foundMobile = "";

//      // Match against the Applicants List using Email
//      if (applicantEmail && applicantsList.length > 0) {
//          const fullProfile = applicantsList.find(app => app.email?.toLowerCase() === applicantEmail.toLowerCase());
//          if (fullProfile) {
//              // Construct address from available fields
//              const addrParts = [fullProfile.village, fullProfile.tehsil, fullProfile.district, fullProfile.state, fullProfile.country].filter(Boolean);
//              foundAddress = addrParts.join(", ");
//              foundPin = fullProfile.zip_code ? String(fullProfile.zip_code) : "";
//              foundMobile = fullProfile.phone || "";
//              setShowApplicantData(true);
//          }
//      }

//      // Update State
//      setAddress(foundAddress); 
//      setPinCode(foundPin); 
//      setMobileNumber(foundMobile);

//      setFormData(prevState => ({ 
//          ...prevState, 
//          candidateName: applicantName, 
//          user_id: applicantId,
//          address: foundAddress,
//          pinCode: foundPin,
//          mobileNumber: foundMobile 
//      }));

//    }, [applicantsList]);

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
//         // Ensure manual fields are filled if API didn't provide them
//         if ((generationMethod === 'template' || generationMethod === 'custom') && (!formData.mobileNumber || !formData.address || !formData.pinCode)) {
//              Swal.fire("Validation Error", "Please fill in Mobile Number, Address and Pincode.", "warning");
//              setIsLoading(false);
//              return;
//         }

//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) {
//                 payload.append('candidate_email', selectedCandidate.email);
//             }
//             // Append Details (either autofilled or manual)
//             payload.append('mobileNumber', formData.mobileNumber);
//             payload.append('address', formData.address);
//             payload.append('pinCode', formData.pinCode);
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('section', formData.section);
//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") {
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobLabel || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) {
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             handleCloseModal();
//             fetchLetters();
//             if (navigateTo) {
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle("");
//      setSelectedJobLabel("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []);

//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.pk;
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.fields.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.fields.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.fields.LetterType || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)} disabled={isDownloading[pk] || !letter.fields.pdf_path} title={letter.fields.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.fields.Time)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.fields.candidate_name, letter.fields.pdf_path, letter.fields.LetterType, pk)} disabled={isSending[pk] || isSent || !letter.fields.pdf_path} title={isSent ? "Email Already Sent" : !letter.fields.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Autofilled Applicant Data:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                {/* Input fields for details (autofilled or manual) */}
//                                <Row>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="mobileNumber">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Mobile Number <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required size="sm" placeholder="Candidate's Mobile"/>
//                                        </Form.Group>
//                                     </Col>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="address">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Address <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} required size="sm" placeholder="Full Address"/>
//                                        </Form.Group>
//                                     </Col>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="pinCode">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Pincode <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="pinCode" value={formData.pinCode} onChange={handleChange} required size="sm" placeholder="Pincode"/>
//                                        </Form.Group>
//                                     </Col>
//                                </Row>

//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="mobileNumberCustom">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Mobile Number <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required size="sm" placeholder="Candidate's Mobile"/>
//                                        </Form.Group>
//                                     </Col>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="addressCustom">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Address <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} required size="sm" placeholder="Full Address"/>
//                                        </Form.Group>
//                                     </Col>
//                                     <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="pinCodeCustom">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Pincode <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="text" name="pinCode" value={formData.pinCode} onChange={handleChange} required size="sm" placeholder="Pincode"/>
//                                        </Form.Group>
//                                     </Col>
//                                 </Row>

//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]); // Stores data from /get_letters/
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); // Holds Posting ID
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" 
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else { setLetters([]); setNoDataFound(true); }
//     } catch (error) { console.error("Error fetching letters:", error); setLetters([]); setNoDataFound(true); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);


//   // --- Process Evaluations & Interview Evaluations for Dropdowns ---
//   useEffect(() => {
//     const jobMap = {}; 
    
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;

//         if (!jobMap[postingId]) {
//             jobMap[postingId] = {
//                 id: postingId,
//                 pureTitle: jobTitle || postingId,
//                 label: `${jobTitle || 'Unknown Job'} (${postingId})`,
//                 type: jobType || "", 
//                 candidates: []
//             };
//         } 
//         else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) {
//                  jobMap[postingId].type = jobType;
//              }
//         }

//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) {
//             jobMap[postingId].candidates.push(candidateObj);
//         }
//     };

//     evaluations.forEach(ev => {
//         addCandidate(ev.posting_id, ev.job_title, ev.posting_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.evaluator_email,
//             details: ev
//         });
//     });

//     interviewEvaluations.forEach(ev => {
//         const title = ev.job_title || ev.job_type || "Position"; 
//         addCandidate(ev.job_posting, title, ev.job_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.candidate_email,
//             details: ev
//         });
//     });

//     const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
//     setProcessedJobs(jobsArray);

//     const candMap = {};
//     Object.values(jobMap).forEach(job => {
//         candMap[job.id] = job.candidates;
//     });
//     setCandidatesMap(candMap);

//   }, [evaluations, interviewEvaluations]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.letter_type?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => {
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; 
//      setSelectedJobTitle(postingId);
     
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; 
     
//      setSelectedJobLabel(jobObj ? jobObj.label : "");

//      setSelectedCandidate(null); 
//      setFilteredCandidateOptions([]); 
//      setShowApplicantData(false);
//      setAddress(""); setPinCode(""); setMobileNumber("");

//      setFormData(prev => ({
//        ...initialFormData, 
//        section: prev.section, 
//        generationMethod: prev.generationMethod, 
//        position: cleanTitle || '',
//        opening_post: jobType 
//      }));

//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({
//              value: c.id, 
//              label: `${c.name} ${c.email ? `(${c.email})` : ''}`,
//              fullName: c.name,
//              email: c.email,
//              details: c.details
//          })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    // --- Candidate Change Handler (PRIORITIZING /get_letters/ DATA) ---
//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
     
//      // 1. Attempt to find this candidate in the existing letters data (from /get_letters/)
//      // We match by user_id OR by name if user_id matches
//      const existingLetter = letters.find(l => 
//          (l.user_id && String(l.user_id) === String(applicantId)) || 
//          (l.candidate_name && l.candidate_name.toLowerCase() === applicantName.toLowerCase())
//      );

//      let candAddress = "";
//      let candPin = "";
//      let candPhone = "";

//      if (existingLetter) {
//         // Use data from /get_letters/ response as requested
//         candAddress = existingLetter.combined_address || "";
//         candPin = existingLetter.zip_code || "";
//         candPhone = existingLetter.phone || "";
//      } else {
//         // Fallback to evaluation details if not found in letters
//         const details = selectedOption?.details || {};
//         candAddress = details.combined_address || details.address || details.location || "";
//         candPin = details.zip_code || details.pincode || details.pin_code || "";
//         candPhone = details.phone || details.mobile || details.contact_number || "";
//      }

//      // Update UI and Form Data
//      setAddress(candAddress); 
//      setPinCode(candPin); 
//      setMobileNumber(candPhone); 
     
//      setFormData(prevState => ({ 
//          ...prevState, 
//          candidateName: applicantName, 
//          user_id: applicantId, 
//          address: candAddress,      
//          pinCode: candPin,          
//          mobileNumber: candPhone    
//      }));

//      // Show info box if we have data found either in letters OR evaluations
//      if (existingLetter || selectedOption?.details) {
//          setShowApplicantData(true);
//      }
//    }, [letters]); // Depend on letters so we have the API data available

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
        
//         if (!formData.opening_post && (generationMethod === 'template' || generationMethod === 'custom')) { 
//             console.warn("Opening Post type missing for selected job.");
//         }

//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) {
//                 payload.append('candidate_email', selectedCandidate.email);
//             }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";

//                 // Ensure Fallback values to prevent preview crash if data is still missing
//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000"; 
//                 const safeMobile = formData.mobileNumber || "Not Available"; 

//                 navigateState = { 
//                     ...formData, 
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     generationMethod: 'template', 
//                     signaturePreviewUrl: signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
                
//                  if (formData.section !== "Offer Letter") {
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
                
//                 const safeAddress = formData.address || "Address Not Provided";
//                 const safePin = formData.pinCode || "000000";
//                 const safeMobile = formData.mobileNumber || "Not Available";

//                 navigateState = { 
//                     ...formData,
//                     address: safeAddress,
//                     pinCode: safePin,
//                     mobileNumber: safeMobile,
//                     customContent, 
//                     section: formData.section, 
//                     generationMethod: 'custom', 
//                     signaturePreviewUrl, 
//                     jobTitle: selectedJobLabel 
//                 };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 payload.append('candidate_name', formData.candidateName);

//                 // --- CHANGED KEYS HERE ---
//                 payload.append('evaluation_id', formData.user_id);
//                 payload.append('LetterType', formData.section);
//                 // -------------------------

//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobLabel || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) {
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             handleCloseModal();
//             fetchLetters();
//             if (navigateTo) {
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle("");
//      setSelectedJobLabel("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []);

//    // --- Utilities ---
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.id; // API uses 'id'
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.generation_method || 'N/A'; // API uses 'generation_method'
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                                        
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.letter_type || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, letter.letter_type)} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.created_at)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, letter.letter_type, pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa';

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles ---
// const styles = {
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)',
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([]);
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  
//   // Data States
//   const [evaluations, setEvaluations] = useState([]);
//   const [interviewEvaluations, setInterviewEvaluations] = useState([]);
//   const [processedJobs, setProcessedJobs] = useState([]); 
//   const [candidatesMap, setCandidatesMap] = useState({}); 

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState(""); // Holds Posting ID
//   const [selectedJobLabel, setSelectedJobLabel] = useState(""); 
  
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "", opening_post: "" // Added opening_post to initial state
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else { setLetters([]); setNoDataFound(true); }
//     } catch (error) { console.error("Error fetching letters:", error); setLetters([]); setNoDataFound(true); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);

//   const fetchEvaluations = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/evaluations/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setEvaluations(data); }
//       else { setEvaluations([]); }
//     } catch (error) { console.error("Error fetching evaluations:", error); setEvaluations([]); }
//   }, []);

//   const fetchInterviewEvaluations = useCallback(async () => {
//     try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/interview-evaluations/");
//         const data = response.data;
//         if (data && Array.isArray(data)) { setInterviewEvaluations(data); }
//         else { setInterviewEvaluations([]); }
//     } catch (error) { console.error("Error fetching interview evaluations:", error); setInterviewEvaluations([]); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.pk] = letter.fields.sent == 1;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   // --- Load Data ---
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          await Promise.all([ 
//              fetchLetters(), 
//              fetchHrList(),
//              fetchEvaluations(),
//              fetchInterviewEvaluations()
//          ]);
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchHrList, fetchEvaluations, fetchInterviewEvaluations]);


//   // --- Process Evaluations & Interview Evaluations for Dropdowns ---
//   useEffect(() => {
//     const jobMap = {}; // Key: posting_id, Value: { id, label, pureTitle, type, candidates: [] }
    
//     // Helper to add candidate to map
//     const addCandidate = (postingId, jobTitle, jobType, candidateObj) => {
//         if (!postingId) return;

//         // Create Job Entry if not exists
//         if (!jobMap[postingId]) {
//             jobMap[postingId] = {
//                 id: postingId,
//                 pureTitle: jobTitle || postingId, // Fallback to ID if title null
//                 label: `${jobTitle || 'Unknown Job'} (${postingId})`,
//                 type: jobType || "", // Store Job_Opening, Business_Opportunity etc.
//                 candidates: []
//             };
//         } 
//         // Update details if better data found (e.g. title or type)
//         else {
//              if (jobTitle && jobMap[postingId].pureTitle === postingId) {
//                  jobMap[postingId].pureTitle = jobTitle;
//                  jobMap[postingId].label = `${jobTitle} (${postingId})`;
//              }
//              if (jobType && !jobMap[postingId].type) {
//                  jobMap[postingId].type = jobType;
//              }
//         }

//         // Add Candidate (avoid duplicates based on ID or Name)
//         const exists = jobMap[postingId].candidates.find(c => c.id === candidateObj.id);
//         if (!exists) {
//             jobMap[postingId].candidates.push(candidateObj);
//         }
//     };

//     // 1. Process /evaluations/
//     evaluations.forEach(ev => {
//         // posting_type comes from this API
//         addCandidate(ev.posting_id, ev.job_title, ev.posting_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.evaluator_email, // Using this temporarily as API key suggests
//             details: ev
//         });
//     });

//     // 2. Process /interview-evaluations/
//     interviewEvaluations.forEach(ev => {
//         // job_type comes from this API
//         const title = ev.job_title || ev.job_type || "Position"; 
//         addCandidate(ev.job_posting, title, ev.job_type, {
//             id: ev.id,
//             name: ev.candidate_name,
//             email: ev.candidate_email,
//             details: ev
//         });
//     });

//     // Convert map to array for Job Dropdown
//     const jobsArray = Object.values(jobMap).sort((a, b) => a.label.localeCompare(b.label));
//     setProcessedJobs(jobsArray);

//     // Create Candidate Map for easy lookup
//     const candMap = {};
//     Object.values(jobMap).forEach(job => {
//         candMap[job.id] = job.candidates;
//     });
//     setCandidatesMap(candMap);

//   }, [evaluations, interviewEvaluations]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.fields.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.fields.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.fields.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    // --- Actions ---

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => {
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", {
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 });
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" });
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) {
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    // --- Job Title Change Handler (Updated to set opening_post) ---
//    const handleJobTitleChange = useCallback((event) => {
//      const postingId = event.target.value; // e.g., 'job-065'
//      setSelectedJobTitle(postingId);
     
//      // Find the full object
//      const jobObj = processedJobs.find(j => j.id === postingId);
//      const cleanTitle = jobObj ? jobObj.pureTitle : "";
//      const jobType = jobObj ? jobObj.type : ""; // Extract Job_Opening etc.
     
//      setSelectedJobLabel(jobObj ? jobObj.label : "");

//      // Reset Candidate
//      setSelectedCandidate(null); 
//      setFilteredCandidateOptions([]); 
//      setShowApplicantData(false);
//      setAddress(""); setPinCode(""); setMobileNumber("");

//      // Update Form with title AND opening_post
//      setFormData(prev => ({
//        ...initialFormData, 
//        section: prev.section, 
//        generationMethod: prev.generationMethod, 
//        position: cleanTitle || '',
//        opening_post: jobType // Set the hidden field
//      }));

//      // Filter Candidates for this Job ID
//      if (postingId && candidatesMap[postingId]) {
//          const candidates = candidatesMap[postingId];
//          const options = candidates.map(c => ({
//              value: c.id, 
//              label: `${c.name} ${c.email ? `(${c.email})` : ''}`,
//              fullName: c.name,
//              email: c.email,
//              details: c.details
//          })).sort((a, b) => a.label.localeCompare(b.label));
//          setFilteredCandidateOptions(options);
//      }
//    }, [processedJobs, candidatesMap, initialFormData]);

//    // --- Candidate Change Handler ---
//    const handleCandidateChange = useCallback((selectedOption) => {
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null; 
//      const applicantName = selectedOption?.fullName || selectedOption?.label?.split(' (')[0] || "";
     
//      setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
     
//      setFormData(prevState => ({ 
//          ...prevState, 
//          candidateName: applicantName, 
//          user_id: applicantId, 
//      }));

//      if (selectedOption?.details) {
//          setShowApplicantData(false);
//      }
//    }, []);

//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }
//         // Validation check for opening_post (though it should be set by job selection)
//         if (!formData.opening_post && (generationMethod === 'template' || generationMethod === 'custom')) { 
//             console.warn("Opening Post type missing for selected job.");
//             // Optional: You could block submission here, or let backend handle it.
//         }

//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             // Append Common Fields including opening_post and candidate_email
//             payload.append('opening_post', formData.opening_post);
//             if (selectedCandidate?.email) {
//                 payload.append('candidate_email', selectedCandidate.email);
//             }
            
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/";
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('section', formData.section);
//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position); 
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") {
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobLabel };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobLabel || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) {
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             handleCloseModal();
//             fetchLetters();
//             if (navigateTo) {
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [formData, selectedJobTitle, selectedJobLabel, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters, selectedCandidate]);


//    const handleOpenModal = useCallback(() => {
//      setSelectedJobTitle("");
//      setSelectedJobLabel("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true);
//    }, [initialFormData]);

//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []);

//    // --- Utilities ---
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.pk;
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.fields.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.fields.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.fields.LetterType || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)} disabled={isDownloading[pk] || !letter.fields.pdf_path} title={letter.fields.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.fields.Time)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.fields.candidate_name, letter.fields.pdf_path, letter.fields.LetterType, pk)} disabled={isSending[pk] || isSent || !letter.fields.pdf_path} title={isSent ? "Email Already Sent" : !letter.fields.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title (ID) <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || processedJobs.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {processedJobs.map((job) => (<option key={job.id} value={job.id}>{job.label}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && processedJobs.length === 0 && <Form.Text className="text-danger small">No jobs found in evaluations.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                          {generationMethod === 'template' && (
//                              <>
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer className="bg-light border-top">
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import { FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaSignature, FaFilePdf, FaEdit, FaInfoCircle } from 'react-icons/fa'; // Import React Icons

// import 'bootstrap/dist/css/bootstrap.min.css';

// // --- Professional Styles (Copied from previous correct version) ---
// const styles = {
//     gradientText: { /* ... */ }, cardHeader: { /* ... */ }, modalSection: { /* ... */ },
//     signaturePreview: { /* ... */ }, pageWrapper: { /* ... */ }, contentWrapper: { /* ... */ },
//     mainContentArea: { /* ... */ }, reactSelectStyles: { /* ... */ },
//      // --- Add missing styles back if needed ---
//       gradientText: {
//         background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         fontWeight: '600',
//       },
//       cardHeader: {
//         backgroundColor: '#ffffff',
//         borderBottom: '1px solid #e9ecef',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1rem 1.5rem',
//       },
//       modalSection: {
//         border: '1px solid #dee2e6',
//         borderRadius: '0.375rem',
//         padding: '1.5rem',
//         marginBottom: '1.5rem',
//         backgroundColor: '#f8f9fa'
//       },
//       signaturePreview: {
//         maxWidth: '200px',
//         maxHeight: '100px',
//         border: '2px dashed #ced4da',
//         padding: '10px',
//         borderRadius: '0.375rem',
//         backgroundColor: '#ffffff',
//         marginTop: '15px',
//         display: 'block',
//         marginLeft: 'auto',
//         marginRight: 'auto',
//         objectFit: 'contain',
//       },
//       pageWrapper: {
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         overflow: 'hidden',
//       },
//       contentWrapper: {
//         display: 'flex',
//         flexGrow: 1,
//         overflow: 'hidden',
//       },
//       mainContentArea: {
//         flexGrow: 1,
//         overflowY: 'auto',
//         padding: '1.5rem 2rem',
//         backgroundColor: '#f4f7fc',
//         height: 'calc(100vh - 56px)', // Adjust based on Navbar height
//       },
//       reactSelectStyles: {
//         control: (provided, state) => ({
//             /* ... control styles ... */
//              ...provided,
//               borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
//               boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
//               '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#adb5bd', },
//               minHeight: '38px', height: 'auto',
//               backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
//         }),
//         valueContainer: (provided) => ({ ...provided, padding: '2px 8px' }),
//         input: (provided) => ({ ...provided, margin: '0px', padding: '0px' }),
//         indicatorsContainer: (provided) => ({ ...provided, height: '38px' }),
//         placeholder: (provided) => ({ ...provided, color: '#6c757d' }),
//         option: (provided, state) => ({
//             /* ... option styles ... */
//              ...provided,
//               backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
//               color: state.isSelected ? 'white' : '#212529',
//               ':active': { backgroundColor: !state.isDisabled ? (state.isSelected ? '#0a58ca' : '#dbeafe') : undefined },
//         }),
//         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//         singleValue: (provided, state) => ({
//             /* ... singleValue styles ... */
//              ...provided, color: state.isDisabled ? '#6c757d' : '#212529',
//         }),
//       },
// };

// const OfferLetterGenerator = () => {
//   // --- Existing States (Unchanged) ---
//   const [letters, setLetters] = useState([]);
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(true);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null);
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false);
//   const [jobApplications, setJobApplications] = useState([]);
//   const [applicants, setApplicants] = useState([]);
//   const [jobTitles, setJobTitles] = useState([]);
//   const [selectedJobTitle, setSelectedJobTitle] = useState("");
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([]);
//   const [initialFormData] = useState({ // Keep initial state constant
//     candidateName: "", position: "", salary: "", date: "", section: "Offer Letter",
//     address: "", pinCode: "", mobileNumber: "", hr: null, user_id: null,
//     reporting_manager: "", headquarter: "",
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching (Callbacks - Logic exactly as provided in your code) ---
//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/"); // YOUR ENDPOINT
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else { console.error("Invalid letters data format:", data); setLetters([]); setNoDataFound(true); }
//     } catch (error) { console.error("Error fetching letters:", error); setLetters([]); setNoDataFound(true); }
//   }, []); // initializeSentStatus will be defined before this runs

//   const fetchJobApplications = useCallback(async () => {
//      try {
//        const response = await axios.get("https://raasbackend.vetrinahealthcare.com/job_applications_for_letter/"); // YOUR ENDPOINT
//        const data = response.data;
//        if (data && Array.isArray(data)) {
//          setJobApplications(data);
//          const uniqueTitles = [...new Set(data.map(app => app.job_title).filter(Boolean))].sort();
//          setJobTitles(uniqueTitles);
//        } else { console.error("Invalid job applications data format:", data); setJobApplications([]); setJobTitles([]); }
//      } catch (error) { console.error("Error fetching job applications:", error); setJobApplications([]); setJobTitles([]); Swal.fire("Error", "Could not fetch job application data.", "error"); }
//    }, []);

//    const fetchApplicants = useCallback(async () => {
//      try {
//        const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants_not_offered/"); // YOUR ENDPOINT
//        const data = response.data;
//        if (data && Array.isArray(data)) { setApplicants(data); }
//        else { console.error("Invalid applicants data format:", data); setApplicants([]); }
//      } catch (error) { console.error("Error fetching applicants:", error); setApplicants([]); Swal.fire("Error", "Could not fetch applicant data.", "error"); }
//    }, []);

//    const fetchHrList = useCallback(async () => {
//      try {
//        const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/"); // YOUR ENDPOINT
//        const data = response.data;
//        if (data && Array.isArray(data)) { setHrList(data); }
//        else { console.error("Invalid HR list data format:", data); setHrList([]); }
//      } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//    }, []);

//   // --- Helper Functions & Event Handlers (Core logic MUST remain as provided) ---

//   // initializeSentStatus MUST be defined before fetchLetters which calls it.
//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.pk] = letter.fields.sent == 1; // Using == as in original
//     });
//     setSentStatus(initialSentStatus);
//   }, []); // No dependencies, pure function of input

//   // Now useEffect can run safely
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//          console.log("Loading initial data...");
//          await Promise.all([ fetchLetters(), fetchJobApplications(), fetchApplicants(), fetchHrList() ]);
//          console.log("Initial data loaded.");
//       } catch (error) {
//          console.error("Error during initial data fetch:", error);
//          Swal.fire("Load Error", "Failed to load necessary data. Please refresh the page.", "error");
//       } finally {
//          setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchJobApplications, fetchApplicants, fetchHrList]); // Dependencies are the fetch functions themselves


//   const applySearchAndPagination = useCallback(() => {
//     // Logic as provided in your code
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.fields.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.fields.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.fields.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//    const sendEmail = useCallback(async (candidateName, pdfPath, LetterType, pk) => { // Removed unused index
//      if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//      setIsSending(prev => ({ ...prev, [pk]: true }));
//      try {
//        await axios.post("https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/", { // YOUR ENDPOINT & PAYLOAD
//          candidate_name: candidateName, pdf_path: pdfPath, letter_type: LetterType,
//        });
//        Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//        setSentStatus(prev => ({ ...prev, [pk]: true }));
//        await axios.put(`https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`, { sent: 1 }); // YOUR ENDPOINT & PAYLOAD
//      } catch (error) { console.error("Error sending email:", error); Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true }); }
//      finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//      setIsDownloading(prev => ({ ...prev, [pk]: true }));
//      try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" }); // YOUR ENDPOINT
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link); link.click(); document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//      } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//      finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//    }, []);

//    const handleChange = useCallback((e) => {
//      const { name, value } = e.target;
//      setFormData(prevState => ({ ...prevState, [name]: value }));
//    }, []);

//    const handleHrChange = useCallback((selectedOption) => {
//      const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//      setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//    }, [hrList]);

//    const handleFileChange = useCallback((e) => {
//      setUploadedFile(e.target.files[0] || null);
//    }, []);

//    const handleSignatureFileChange = useCallback(async (e) => {
//     // Logic exactly as provided in your code
//      const file = e.target.files[0] || null;
//      setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//      if (!file) return;
//       if (!file.type.startsWith('image/')) { // Added type check
//           Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//           if (e?.target) e.target.value = null;
//           return;
//       }
//      setIsProcessingSignature(true);
//      Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//      try {
//        const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//        const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//        setSignatureFile(processedFile);
//        const reader = new FileReader();
//        reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//        reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//        reader.readAsDataURL(processedBlob);
//      } catch (error) {
//        console.error("Error removing background:", error);
//        Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Error: ${error?.message || 'Unknown'}. Please try another image.` });
//        setSignatureFile(null); setSignaturePreviewUrl(null);
//        if (e?.target) e.target.value = null;
//      } finally {
//        setIsProcessingSignature(false);
//        if (Swal.isVisible()) { Swal.close(); }
//      }
//    }, []);

//    const handleJobTitleChange = useCallback((event) => {
//      // Logic exactly as provided in your code
//      const title = event.target.value;
//      setSelectedJobTitle(title);
//      setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//      setFormData(prev => ({
//        ...initialFormData, section: prev.section, generationMethod: prev.generationMethod, position: title || '',
//      }));
//      if (title && jobApplications.length > 0 && applicants.length > 0) {
//        const relevantApplications = jobApplications.filter(app => app.job_title === title);
//        const applicantIds = [...new Set(relevantApplications.map(app => app.applicant))];
//        const matchingApplicants = applicants.filter(applicant => applicantIds.includes(applicant.id));
//        const options = matchingApplicants.map(applicant => ({
//          value: applicant.id,
//          label: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''} (${applicant.email || `ID: ${applicant.id}`})`.replace(/\s+/g, ' ').trim(),
//          fullName: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''}`.replace(/\s+/g, ' ').trim() || `Applicant ${applicant.id}`
//        })).sort((a, b) => a.label.localeCompare(b.label));
//        setFilteredCandidateOptions(options);
//      }
//    }, [jobApplications, applicants, initialFormData]);

//    const handleCandidateChange = useCallback((selectedOption) => {
//      // Logic exactly as provided in your code
//      setSelectedCandidate(selectedOption);
//      const applicantId = selectedOption?.value || null;
//      const applicantName = selectedOption?.fullName || selectedOption?.label || "";
//      setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
//      setFormData(prevState => ({ ...prevState, candidateName: applicantName, user_id: applicantId, address: "", pinCode: "", mobileNumber: "" }));
//      if (applicantId) {
//        const applicantData = applicants.find(app => app.id === applicantId);
//        if (applicantData) {
//          const fetchedAddress = applicantData.district || "";
//          const fetchedPinCode = applicantData.zip_code || "";
//          const fetchedMobile = applicantData.phone || "";
//          setAddress(fetchedAddress); setPinCode(fetchedPinCode); setMobileNumber(fetchedMobile);
//          setShowApplicantData(true);
//          setFormData(prevState => ({ ...prevState, address: fetchedAddress, pinCode: fetchedPinCode, mobileNumber: fetchedMobile }));
//        } else { console.error(`Applicant data not found locally for ID: ${applicantId}`); setShowApplicantData(false); }
//      }
//    }, [applicants]);

//    // *** THE FIX IS HERE: Removed handleCloseModal from the dependency array ***
//    const handleSubmit = useCallback(async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         // --- Validation (Using original logic structure) ---
//         if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//         if (!selectedJobTitle && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) { Swal.fire("Validation Error", "Please select a date.", "warning"); setIsLoading(false); return; }

//         // --- Prepare Payload (Using original logic structure and keys) ---
//         let endpoint = "";
//         let payload = new FormData();
//         let headers = { 'Content-Type': 'multipart/form-data' };
//         let navigateTo = null;
//         let navigateState = null;
//         let successMessage = "";

//         try {
//             // --- Method-Specific Logic (Endpoints and Payload as per *your* original code) ---
//             if (generationMethod === "template") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/"; // YOUR ENDPOINT
//                 if (formData.section === "Offer Letter") {
//                     if (!formData.hr || !formData.position || !formData.salary || !formData.reporting_manager || !formData.headquarter) {
//                        throw new Error("Please fill HR, Position, Salary, Reporting Manager, and Headquarter for Offer Letter template.");
//                     }
//                 }
//                 // PAYLOAD KEYS from your code
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('section', formData.section);
//                 payload.append('date', formData.date);
//                 payload.append('position', formData.position || selectedJobTitle);
//                 if (formData.section === "Offer Letter") {
//                     payload.append('salary', formData.salary);
//                     payload.append('hr_id', formData.hr.id);
//                     payload.append('reporting_manager', formData.reporting_manager);
//                     payload.append('headquarter', formData.headquarter);
//                 }
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `${formData.section} template processing initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl, jobTitle: selectedJobTitle };
//                  if (formData.section !== "Offer Letter") { // Clean state for rejection letter preview
//                      delete navigateState.salary; delete navigateState.hr; delete navigateState.reporting_manager; delete navigateState.headquarter;
//                  }

//             } else if (generationMethod === "custom") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/"; // YOUR ENDPOINT
//                 if (!customContent.trim()) { throw new Error("Please enter custom letter content."); }
//                 if (formData.section === "Offer Letter" && !formData.hr) { throw new Error("Please select HR for custom Offer Letter signature."); }

//                 // PAYLOAD KEYS from your code ('letterType' used here)
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('customContent', customContent);
//                 payload.append('date', formData.date);
//                 if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//                 if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//                 successMessage = `Custom ${formData.section} creation initiated...`;
//                 navigateTo = formData.section === "Offer Letter" ? "/OfferLetter" : "/letterform";
//                 navigateState = { ...formData, customContent, section: formData.section, generationMethod: 'custom', signaturePreviewUrl, jobTitle: selectedJobTitle };
//                  if (formData.section !== "Offer Letter") { delete navigateState.hr; }

//             } else if (generationMethod === "upload") {
//                 endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/"; // YOUR ENDPOINT
//                 if (!uploadedFile) { throw new Error("Please select a PDF file to upload."); }
//                 if (uploadedFile.type !== 'application/pdf') { throw new Error("Invalid file type. Please upload a PDF."); }

//                 // PAYLOAD KEYS from your code ('letterType' used here)
//                 payload.append('candidateName', formData.candidateName);
//                 payload.append('user_id', formData.user_id);
//                 payload.append('letterType', formData.section);
//                 payload.append('uploadedFile', uploadedFile);
//                 payload.append('jobTitle', selectedJobTitle || '');

//                 successMessage = `Existing ${formData.section} upload initiated.`;
//                 navigateTo = "/letterform";
//                 navigateState = null;
//             } else { throw new Error("Invalid generation method selected."); }

//           // --- Make the Axios Request (Unchanged) ---
//           console.log(`Sending ${generationMethod} request to ${endpoint}...`);
//           const response = await axios.post(endpoint, payload, { headers: headers });
//           const backendSuccessMessage = response.data.message;

//           // --- Success Handling (Using original logic flow) ---
//           successMessage = backendSuccessMessage || successMessage;
//           if (!backendSuccessMessage) { // Fallbacks from your code
//             if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//             else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//             else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//             else successMessage = `${formData.section} processed successfully.`
//           }

//           Swal.fire({
//             title: "Success!", text: successMessage, icon: "success",
//             timer: navigateTo === "/OfferLetter" ? 1500 : 2500,
//             timerProgressBar: true, showConfirmButton: false,
//           }).then(() => {
//             // ** Use the CORRECT handleCloseModal defined outside **
//             handleCloseModal(); // Close modal first
//             fetchLetters();     // Then refresh list
//             if (navigateTo) {   // Then navigate if required
//               console.log("Navigating to:", navigateTo, "with state:", navigateState);
//               navigate(navigateTo, { state: navigateState });
//             }
//           });

//         } catch (error) {
//           // --- Error Handling (Using original logic structure) ---
//           console.error(`Error during ${generationMethod} process:`, error);
//           let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//           if (!error.message && error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//           else if (!error.message && error.request) { errorMsg = "Could not connect to the server."; }
//           Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//         } finally {
//           setIsLoading(false);
//         }
//    }, [
//        // *** CORRECTED DEPENDENCIES ***
//        formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile,
//        signaturePreviewUrl, navigate, fetchLetters, // Removed handleCloseModal
//        // Removed large lists (applicants, hrList, jobApplications) as direct dependencies aren't needed here
//    ]);


//    const handleOpenModal = useCallback(() => {
//     // Reset state here BEFORE showing modal
//      setSelectedJobTitle("");
//      setFilteredCandidateOptions([]);
//      setFormData(initialFormData);
//      setSelectedCandidate(null);
//      setAddress(""); setPinCode(""); setMobileNumber("");
//      setShowApplicantData(false);
//      setGenerationMethod("template");
//      setCustomContent("");
//      setUploadedFile(null);
//      setSignatureFile(null); setSignaturePreviewUrl(null);
//      setIsProcessingSignature(false);
//      const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//      const fileInputSignature = document.getElementById('signatureImageFile'); if (fileInputSignature) fileInputSignature.value = null;
//      setShowModal(true); // Show modal AFTER state reset
//    }, [initialFormData]); // Depends on initialFormData for resetting

//    // handleCloseModal is simple, just closes the modal visually
//    const handleCloseModal = useCallback(() => {
//      setShowModal(false);
//    }, []); // No dependencies

//    // --- Formatting Functions (Unchanged from original) ---
//    const formatDateTime = (dateTimeString) => {
//      if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//      const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//      try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//      catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//    };
//    const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//    const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//    // --- Pagination Handlers (Unchanged from original) ---
//    const handleItemsPerPageChange = useCallback((e) => {
//      setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//    }, []);
//    const handlePageChange = useCallback((pageNumber) => {
//       setCurrentPage(pageNumber);
//    }, []);

//    // --- Calculated Values (Unchanged from original) ---
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//    const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   // --- JSX Structure (Using the refined UI from previous step) ---
//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//              <Container fluid className="p-0">
//                 <Card className="shadow-sm border-0 h-100">
//                     <Card.Header style={styles.cardHeader}>
//                         <h1 className="mb-0 h5" style={styles.gradientText}>Letters Management</h1>
//                         {/* Use handleOpenModal which now resets state */}
//                         <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                             {isLoadingData ? ( <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" /> ) : ( <FaPlus className="me-1" /> )}
//                             Create Letter
//                         </Button>
//                     </Card.Header>

//                      {/* Card Body with Toolbar, Table, Pagination */}
//                      <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                          {/* Toolbar */}
//                          <Row className="mb-4 flex-shrink-0">
//                              <Col md={7} lg={5}>
//                                  <InputGroup size="sm">
//                                      <Form.Control type="search" placeholder="Search by Candidate, Type, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                                      <InputGroup.Text><FaSearch /></InputGroup.Text>
//                                  </InputGroup>
//                              </Col>
//                          </Row>

//                          {/* Table Area */}
//                          <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                              <Table hover responsive className="align-middle mb-0 small">
//                                  <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                                      {/* Table Headers */}
//                                       <tr>
//                                          <th style={{ width: '5%' }}>#</th>
//                                          <th style={{ width: '25%' }}>Candidate Name</th>
//                                          <th style={{ width: '15%' }}>Letter Type</th>
//                                          <th style={{ width: '10%' }}>Method</th>
//                                          <th style={{ width: '10%' }} className="text-center">Download</th>
//                                          <th style={{ width: '20%' }}>Generated On</th>
//                                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                                          <th style={{ width: '5%' }} className="text-center">Status</th>
//                                      </tr>
//                                  </thead>
//                                  <tbody>
//                                  {/* Table Body Content */}
//                                  {isLoadingData ? (
//                                      <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading letters...</p></td></tr>
//                                  ) : currentItems.length > 0 ? (
//                                      currentItems.map((letter, index) => {
//                                          // ... (row rendering logic - unchanged) ...
//                                          const globalIndex = indexOfFirstItem + index;
//                                         const pk = letter.pk;
//                                         const isSent = sentStatus[pk];
//                                         const method = letter.fields.generation_method || 'N/A';
//                                         const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                                         const methodBg = method === 'template' ? 'primary' : method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                                          return (
//                                              <tr key={pk}>
//                                                  <td>{globalIndex + 1}</td>
//                                                  <td>{letter.fields.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                                  <td>{letter.fields.LetterType || <span className="text-muted">N/A</span>}</td>
//                                                  <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)} disabled={isDownloading[pk] || !letter.fields.pdf_path} title={letter.fields.pdf_path ? "Download PDF" : "No PDF available"}>
//                                                          {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                                      </Button>
//                                                  </td>
//                                                  <td>{formatDateTime(letter.fields.Time)}</td>
//                                                  <td className="text-center">
//                                                      <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.fields.candidate_name, letter.fields.pdf_path, letter.fields.LetterType, pk)} disabled={isSending[pk] || isSent || !letter.fields.pdf_path} title={isSent ? "Email Already Sent" : !letter.fields.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                                          {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                                      </Button>
//                                                  </td>
//                                                  <td className="text-center">
//                                                      {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                                  </td>
//                                              </tr>
//                                          );
//                                      })
//                                  ) : (
//                                      <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No letters have been generated yet."}</td></tr>
//                                  )}
//                                  </tbody>
//                              </Table>
//                          </div>

//                         {/* Pagination Area */}
//                         {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                              <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                                  <div className="d-flex align-items-center">
//                                      <span className="me-2 text-muted small">Rows:</span>
//                                      <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                          <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                                      </Form.Select>
//                                      <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                                  </div>
//                                  <Pagination size="sm" className="mb-0">
//                                       {/* Pagination items */}
//                                       <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                                      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                      <Pagination.Item active>{currentPage}</Pagination.Item>
//                                      {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                                      {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                                      {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                                      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                                  </Pagination>
//                              </div>
//                         )}
//                     </Card.Body>
//                 </Card>
//             </Container>
//           </main>
//         </div>

//         {/* --- MODAL (Using the refined UI) --- */}
//         {/* Use handleCloseModal from outside */}
//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//            {/* Modal Header */}
//             <Modal.Header closeButton>
//                 <Modal.Title style={styles.gradientText}>
//                      { generationMethod === 'template' && <FaEdit className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      { generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }}/> }
//                      Create New Letter
//                 </Modal.Title>
//             </Modal.Header>
//            {/* Modal Body */}
//             <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//                 {/* Form with ID linked to footer button */}
//                 <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//                     {/* Section 1: Core Info */}
//                     <div style={styles.modalSection}>
//                          <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                           {/* Method, Type, Job Title, Candidate selects */}
//                           <Row>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="generationMethod">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                                           <option value="template">Generate from Template</option>
//                                           <option value="custom">Write Custom Content</option>
//                                           <option value="upload">Upload Existing PDF</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                               <Col md={6} lg={4} className="mb-3">
//                                   <Form.Group controlId="section">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Type</Form.Label>
//                                       <Form.Select name="section" value={formData.section} onChange={handleChange} required size="sm">
//                                           <option value="Offer Letter">Offer Letter</option>
//                                           <option value="Rejection Letter">Rejection Letter</option>
//                                       </Form.Select>
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                           <Row>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="jobTitleSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
//                                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
//                                           <option value="">-- Select Job --</option>
//                                           {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                       </Form.Select>
//                                       {!isLoadingData && jobTitles.length === 0 && <Form.Text className="text-danger small">No job titles loaded.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                                <Col md={6} className="mb-3">
//                                   <Form.Group controlId="candidateNameSelect">
//                                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                                       <Select
//                                           styles={styles.reactSelectStyles}
//                                           options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                                           placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                                           isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                                           noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                                       />
//                                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                                   </Form.Group>
//                               </Col>
//                           </Row>
//                          {showApplicantData && (
//                              <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                                  <FaInfoCircle className="me-1"/> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                              </Alert>
//                           )}
//                     </div>

//                     {/* Section 2: Letter Details */}
//                     <div style={styles.modalSection}>
//                        <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod})</h5>
//                         {/* Conditional Fields based on generationMethod */}
//                         {/* TEMPLATE */}
//                          {generationMethod === 'template' && (
//                              <>
//                                {/* Date Field */}
//                                <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                         <Form.Group controlId="dateTemplate">
//                                            <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                            <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                        </Form.Group>
//                                    </Col>
//                                </Row>
//                                {/* Offer Letter Specific Fields */}
//                                {formData.section === "Offer Letter" && (
//                                    <Row>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="hrNameSelectTemplate"><Form.Label className="fw-bold small text-uppercase text-muted">HR Name <span className="text-danger">*</span></Form.Label><Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required /></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="position"><Form.Label className="fw-bold small text-uppercase text-muted">Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Defaults to Job Title" size="sm"/>{!formData.position && selectedJobTitle && <Form.Text className="text-muted small">Using: '{selectedJobTitle}'</Form.Text>}</Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="salary"><Form.Label className="fw-bold small text-uppercase text-muted">Salary (LPA) <span className="text-danger">*</span></Form.Label><InputGroup size="sm"><Form.Control type="number" step="0.01" min="0" name="salary" value={formData.salary} onChange={handleChange} required placeholder="e.g., 5,50,000" /><InputGroup.Text>LPA</InputGroup.Text></InputGroup></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="reporting_manager"><Form.Label className="fw-bold small text-uppercase text-muted">Reporting Position <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's full name" required size="sm"/></Form.Group></Col>
//                                       <Col md={6} lg={4} className="mb-3"><Form.Group controlId="headquarter"><Form.Label className="fw-bold small text-uppercase text-muted">Headquarter <span className="text-danger">*</span></Form.Label><Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai, Remote" required size="sm"/></Form.Group></Col>
//                                   </Row>
//                                )}
//                                {/* Signature Upload */}
//                                <Form.Group controlId="signatureImageFileTemplate" className="mb-3 mt-3 border-top pt-3">
//                                     <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                     <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                </Form.Group>
//                             </>
//                          )}
//                          {/* CUSTOM */}
//                           {generationMethod === 'custom' && (
//                               <>
//                                 <Row>
//                                    <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="dateCustom">
//                                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm"/>
//                                       </Form.Group>
//                                     </Col>
//                                    {formData.section === "Offer Letter" && (
//                                      <Col md={6} lg={4} className="mb-3">
//                                        <Form.Group controlId="hrNameSelectCustom">
//                                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                                        </Form.Group>
//                                      </Col>
//                                    )}
//                                 </Row>
//                                 <Form.Group className="mb-3" controlId="customContent">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                                    <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the letter here..." required />
//                                 </Form.Group>
//                                 <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                                    <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                                    <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFile" disabled={isProcessingSignature} size="sm"/>
//                                     {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                                     {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                                     {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                                 </Form.Group>
//                              </>
//                           )}
//                          {/* UPLOAD */}
//                           {generationMethod === 'upload' && (
//                               <>
//                                 <Alert variant="info" className="d-flex align-items-center small">
//                                   <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em"/>
//                                   Upload the final, signed letter as a PDF document. It will be stored and associated with the selected candidate.
//                                 </Alert>
//                                 <Form.Group controlId="uploadedFile" className="mb-3">
//                                   <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                                   <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm"/>
//                                   {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                                 </Form.Group>
//                              </>
//                           )}
//                     </div>
//                 </Form>
//             </Modal.Body>
//            {/* Modal Footer */}
//             <Modal.Footer className="bg-light border-top">
//                 {/* Use handleCloseModal defined outside */}
//                 <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//                  {/* Button triggers form submit via form="letterGenerationForm" */}
//                 <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//                     {isLoading || isProcessingSignature ? ( <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//                     ) : ( generationMethod === 'upload' ? <><FaFilePdf className="me-1" /> Upload {formData.section}</> :
//                         (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? <><FaSignature className="me-1" /> Save {formData.section}</> :
//                         <><FaEdit className="me-1" /> Generate & Preview {formData.section}</>
//                       )}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default OfferLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import jsPDF from 'jspdf';

// // --- IMPORT THE BACKGROUND IMAGE ---
// // Adjust the path based on the actual location of OfferLetterGenerator.js relative to Assets
// // Example: If OfferLetterGenerator.js is in src/components/Misc/
// import backgroundImageSrc from '../../Assets/Vetrina Offer Letter-1.png';
// // Example: If OfferLetterGenerator.js is directly in src/components/
// // import backgroundImageSrc from '../Assets/Vetrina Offer Letter-1.png';
// // Example: If OfferLetterGenerator.js is directly in src/
// // import backgroundImageSrc from './Assets/Vetrina Offer Letter-1.png';


// const OfferLetterGenerator = () => {
//     const [letters, setLetters] = useState([]);
//     const [candidateNames, setCandidateNames] = useState([]);
//     const navigate = useNavigate();
//     const [searchQuery, setSearchQuery] = useState("");
//     const [filteredLetters, setFilteredLetters] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(5);
//     const [isLoading, setIsLoading] = useState(false);
//     const [noDataFound, setNoDataFound] = useState(false);
//     const [sentStatus, setSentStatus] = useState({});
//     const [isDownloading, setIsDownloading] = useState({});
//     const [isSending, setIsSending] = useState({});
//     const [address, setAddress] = useState("");
//     const [pinCode, setPinCode] = useState("");
//     const [mobileNumber, setMobileNumber] = useState("");
//     const [showApplicantData, setShowApplicantData] = useState(false);
//     const [hrList, setHrList] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedCandidate, setSelectedCandidate] = useState(null);

//     // --- New States for Generation Method ---
//     const [generationMethod, setGenerationMethod] = useState("template"); // 'template', 'custom', 'upload'
//     const [customContent, setCustomContent] = useState(""); // State for custom textarea
//     const [uploadedFile, setUploadedFile] = useState(null); // State for file input
//     // REMOVED: const [backgroundImageData, setBackgroundImageData] = useState(null);

//     // Initial form data structure
//     const initialFormData = {
//         candidateName: "",
//         position: "",
//         salary: "",
//         date: "",
//         section: "Offer Letter", // Corresponds to LetterType
//         address: "",
//         pinCode: "",
//         mobileNumber: "",
//         hr: null,
//         user_id: null,
//     };
//     const [formData, setFormData] = useState(initialFormData);

//     // REMOVED: fetchBackgroundImage function - no longer needed

//     // --- Fetching Data ---
//     const fetchLetters = useCallback(async () => {
//         // ... (fetchLetters logic remains the same)
//         try {
//             const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//             const data = response.data;
//             if (data && Array.isArray(data.letters)) {
//                 setLetters(data.letters);
//                 initializeSentStatus(data.letters);
//                 setNoDataFound(data.letters.length === 0);
//             } else {
//                 console.error("Invalid data format: letters field is not an array");
//                 setLetters([]);
//                 setNoDataFound(true);
//             }
//         } catch (error) {
//             console.error("Error fetching letters:", error);
//             setLetters([]);
//             setNoDataFound(true);
//         }
//     }, []);

//     const fetchCandidateNames = useCallback(async () => {
//         // ... (fetchCandidateNames logic remains the same)
//         try {
//         const response = await axios.get(
//             "https://raasbackend.vetrinahealthcare.com/get_candidate_names/"
//         );
//         const data = response.data;
//         if (data && Array.isArray(data.candidate_names)) {
//             setCandidateNames(data.candidate_names);
//         } else {
//             console.error(
//             "Invalid data format: candidate_names field is not an array"
//             );
//             setCandidateNames([]);
//         }
//         } catch (error) {
//         console.error("Error fetching candidate names:", error);
//         setCandidateNames([]);
//         }
//     }, []);

//     const fetchHrList = useCallback(async () => {
//         // ... (fetchHrList logic remains the same)
//         try {
//         const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//         const data = response.data;
//         if (data && Array.isArray(data)) {
//             setHrList(data);
//         } else {
//             console.error("Invalid data format: HR list is not an array");
//             setHrList([]);
//         }
//         } catch (error) {
//         console.error("Error fetching HR list:", error);
//         setHrList([]);
//         }
//     }, []);


//     useEffect(() => {
//         fetchLetters();
//         fetchCandidateNames();
//         fetchHrList();
//         // No need to explicitly fetch background image here anymore
//     }, [fetchLetters, fetchCandidateNames, fetchHrList]); // Removed fetchBackgroundImage dependency

//     // --- Search and Pagination ---
//     const applySearchAndPagination = useCallback(() => {
//         // ... (applySearchAndPagination logic remains the same)
//         let filteredData = letters.filter((letter) => {
//             const candidateMatches = letter.fields.candidate_name
//                 ?.toLowerCase()
//                 .includes(searchQuery.toLowerCase());
//             const typeMatches = letter.fields.LetterType
//                 ?.toLowerCase()
//                 .includes(searchQuery.toLowerCase());
//             const methodMatches = letter.fields.generation_method
//                 ?.toLowerCase()
//                 .includes(searchQuery.toLowerCase());
//             return candidateMatches || typeMatches || methodMatches;
//         });

//         setNoDataFound(filteredData.length === 0 && letters.length > 0);
//         setFilteredLetters(filteredData);
//     }, [letters, searchQuery]);


//     useEffect(() => {
//         // ... (useEffect logic for pagination remains the same)
//         applySearchAndPagination();
//         const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//         if (currentPage > totalPages && totalPages > 0) {
//             setCurrentPage(totalPages);
//         } else if (currentPage === 0 && totalPages > 0) {
//             setCurrentPage(1);
//         } else if (filteredLetters.length === 0) {
//             setCurrentPage(1);
//         }

//     }, [letters, searchQuery, currentPage, itemsPerPage, filteredLetters.length, applySearchAndPagination]);


//     const initializeSentStatus = (lettersData) => {
//         // ... (initializeSentStatus logic remains the same)
//         const initialSentStatus = {};
//         lettersData.forEach((letter) => {
//         initialSentStatus[letter.pk] = letter.fields.sent == 1;
//         });
//         setSentStatus(initialSentStatus);
//     };

//     // --- Actions (Send, Download) ---
//     const sendEmail = async (candidateName, pdfPath, LetterType, pk, index) => {
//         // ... (sendEmail logic remains the same)
//         if (!pdfPath) {
//             Swal.fire("Info", "No PDF available to send for this letter.", "info");
//             return;
//         }
//         const updatedSending = { ...isSending };
//         updatedSending[pk] = true;
//         setIsSending(updatedSending);

//         try {
//         await axios.post(
//             "https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/",
//             {
//             candidate_name: candidateName,
//             pdf_path: pdfPath,
//             letter_type: LetterType,
//             }
//         );
//         Swal.fire({
//             icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true,
//         });
//         const updatedSentStatus = { ...sentStatus };
//         updatedSentStatus[pk] = true;
//         setSentStatus(updatedSentStatus);

//         await axios.put(
//             `https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`,
//             { sent: 1 }
//         );

//         } catch (error) {
//         console.error("Error sending email:", error);
//         Swal.fire({
//             icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true,
//         });
//         } finally {
//         const finalSending = { ...isSending };
//         finalSending[pk] = false;
//         setIsSending(finalSending);
//         }
//     };

//     const downloadPdf = async (pdfPath, pk, candidateName, letterType) => {
//         // ... (downloadPdf logic remains the same)
//         if (!pdfPath) {
//             Swal.fire("Info", "No PDF available to download for this letter.", "info");
//             return;
//         }
//         const updatedDownloading = { ...isDownloading };
//         updatedDownloading[pk] = true;
//         setIsDownloading(updatedDownloading);

//         try {
//         const response = await axios.get(
//             `https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`,
//             { responseType: "blob" }
//         );
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
//         const link = document.createElement("a");
//         link.href = url;
//         const filename = `${candidateName}_${letterType}.pdf`.replace(/ /g, '_');
//         link.setAttribute("download", filename);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//         } catch (error) {
//         console.error("Error downloading PDF:", error);
//         Swal.fire("Error", "Could not download PDF.", "error");
//         } finally {
//         const finalDownloading = { ...isDownloading };
//         finalDownloading[pk] = false;
//         setIsDownloading(finalDownloading);
//         }
//     };

//     // --- Modal and Form Handling ---

//     const handleChange = (e) => {
//         // ... (handleChange logic remains the same)
//         const { name, value } = e.target;
//         setFormData((prevState) => ({
//         ...prevState,
//         [name]: value,
//         }));
//     };

//     const handleHrChange = (selectedOption) => {
//         // ... (handleHrChange logic remains the same)
//         const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//         setFormData((prevState) => ({
//         ...prevState,
//         hr: selectedHr || null,
//         }));
//     };

//     const handleFileChange = (e) => {
//         // ... (handleFileChange logic remains the same)
//             setUploadedFile(e.target.files[0] || null);
//         };

//     const handleCandidateChange = async (selectedOption) => {
//         // ... (handleCandidateChange logic remains the same)
//         setSelectedCandidate(selectedOption);

//         const candidateName = selectedOption?.value || "";
//         const label = selectedOption?.label || "";
//         let userId = null;

//         if (label) {
//             const match = label.match(/\(([^)]+)\)/);
//             if (match && match[1]) {
//                 userId = match[1];
//             }
//         }

//         setAddress("");
//         setPinCode("");
//         setMobileNumber("");
//         setShowApplicantData(false);
//         setFormData((prevState) => ({
//             ...prevState,
//             candidateName: candidateName,
//             user_id: userId,
//             address: "",
//             pinCode: "",
//             mobileNumber: "",
//         }));


//         if (userId && candidateName) {
//         try {
//             const response = await axios.get(
//             `https://raasbackend.vetrinahealthcare.com/applicants_data/${userId}/`
//             );
//             const applicantData = response.data;

//             setAddress(applicantData.street_address || "");
//             setPinCode(applicantData.zip_code || "");
//             setMobileNumber(applicantData.phone || "");
//             setShowApplicantData(true);

//             setFormData((prevState) => ({
//             ...prevState,
//             address: applicantData.street_address || "",
//             pinCode: applicantData.zip_code || "",
//             mobileNumber: applicantData.phone || "",
//             }));
//         } catch (error) {
//             console.error("Error fetching applicant data:", error);
//             setShowApplicantData(false);
//         }
//         }
//     };


//     // *** Combined handleSubmit Logic ***
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         // --- Validation ---
//         if (!formData.candidateName || !formData.user_id) {
//             Swal.fire("Validation Error", "Please select a candidate.", "warning");
//             setIsLoading(false);
//             return;
//         }
//         if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) {
//             Swal.fire("Validation Error", "Please select a date.", "warning");
//             setIsLoading(false);
//             return;
//         }

//         try {
//             let response;
//             let successMessage = "";
//             let navigateTo = null;
//             let navigateState = null;

//             // --- Handle based on Generation Method ---
//             if (generationMethod === "template") {
//                 // ... (template logic remains the same)
//                  if (!formData.hr && formData.section === "Offer Letter") {
//                     Swal.fire("Validation Error", "Please select an HR representative for the Offer Letter.", "warning");
//                     setIsLoading(false);
//                     return;
//                 }
//                 if (!formData.position && formData.section === "Offer Letter") {
//                     Swal.fire("Validation Error", "Please enter a Position for the Offer Letter.", "warning");
//                     setIsLoading(false);
//                     return;
//                 }
//                 if (!formData.salary && formData.section === "Offer Letter") {
//                     Swal.fire("Validation Error", "Please enter a Salary for the Offer Letter.", "warning");
//                     setIsLoading(false);
//                     return;
//                 }
//                 response = await axios.post("https://raasbackend.vetrinahealthcare.com/offer_letter/", formData);
//                 successMessage = `${formData.section} record created successfully.`;

//                 if (formData.section === "Offer Letter" && response.data.pdf_path) {
//                     successMessage = `${formData.section} generated successfully.`;
//                 } else if (formData.section === "Rejection Letter") {
//                      successMessage = "Rejection Letter record created successfully.";
//                 }


//             } else if (generationMethod === "custom") {
//                  // Custom specific validations
//                 if (!customContent.trim()) {
//                     Swal.fire("Validation Error", "Please enter custom letter content.", "warning");
//                     setIsLoading(false);
//                     return;
//                 }
//                 // No need to check backgroundImageData state anymore, rely on import
//                 if (!backgroundImageSrc) {
//                      Swal.fire("Error", "Background image failed to load. Cannot generate custom letter.", "error");
//                      setIsLoading(false);
//                      return;
//                 }

//                 // --- Generate PDF with Background on Frontend ---
//                 const doc = new jsPDF('p', 'pt', 'a4'); // Portrait, points, A4 size
//                 const pageWidth = doc.internal.pageSize.getWidth();
//                 const pageHeight = doc.internal.pageSize.getHeight();

//                 // --- Add background image using the imported source ---
//                 // jsPDF needs image dimensions. We might need to load the image first to get them,
//                 // or estimate if we know the PNG dimensions. Let's try adding directly first.
//                 // Assuming the imported src is usable by jsPDF (often a base64 string or path)
//                 try {
//                     // Get image type from the imported string if it's base64
//                     let imageType = 'PNG'; // Default
//                     if (typeof backgroundImageSrc === 'string' && backgroundImageSrc.startsWith('data:image/')) {
//                         const match = backgroundImageSrc.match(/^data:image\/(png|jpe?g|gif|bmp|webp)/);
//                         if (match && match[1]) {
//                             imageType = match[1].toUpperCase();
//                             if (imageType === 'JPEG') imageType = 'JPG'; // jsPDF uses JPG
//                         }
//                     }

//                     doc.addImage(backgroundImageSrc, imageType, 0, 0, pageWidth, pageHeight);
//                 } catch (imgError) {
//                     console.error("Error adding background image to PDF:", imgError);
//                      Swal.fire("Error", "Failed to add background image to PDF. Check image format/import.", "error");
//                      setIsLoading(false);
//                      return; // Stop processing if background fails
//                 }

//                 // Add custom text overlay
//                 doc.setFontSize(11);
//                 doc.setFont('helvetica', 'normal');
//                 const margin = 40;
//                 const maxLineWidth = pageWidth - margin * 2;
//                 let verticalOffset = margin + 40; // Adjust as needed for your template

//                 // Add Date (top right)
//                 if (formData.date) {
//                     const formattedDate = new Date(formData.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
//                     doc.setFontSize(10);
//                     doc.text(formattedDate, pageWidth - margin, margin, { align: 'right' });
//                     doc.setFontSize(11); // Reset
//                 }

//                 const lines = doc.splitTextToSize(customContent.trim(), maxLineWidth);

//                 lines.forEach((line) => {
//                     if (verticalOffset + 15 > pageHeight - margin) {
//                         doc.addPage();
//                         // Re-add background to new page
//                         try {
//                              let imageType = 'PNG'; // Default
//                             if (typeof backgroundImageSrc === 'string' && backgroundImageSrc.startsWith('data:image/')) {
//                                 const match = backgroundImageSrc.match(/^data:image\/(png|jpe?g|gif|bmp|webp)/);
//                                 if (match && match[1]) {
//                                     imageType = match[1].toUpperCase();
//                                     if (imageType === 'JPEG') imageType = 'JPG';
//                                 }
//                             }
//                             doc.addImage(backgroundImageSrc, imageType, 0, 0, pageWidth, pageHeight);
//                         } catch (newPageImgError) {
//                             console.error("Error adding background to new PDF page:", newPageImgError);
//                             // Handle error, maybe stop generation or continue without background on new page
//                         }
//                         verticalOffset = margin; // Reset vertical offset
//                          // Re-add date if needed
//                          if (formData.date) {
//                             const formattedDate = new Date(formData.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
//                             doc.setFontSize(10);
//                             doc.text(formattedDate, pageWidth - margin, margin, { align: 'right' });
//                             doc.setFontSize(11);
//                         }
//                     }
//                     doc.text(line, margin, verticalOffset);
//                     verticalOffset += 15; // Adjust line spacing if needed
//                 });

//                 const pdfBlob = doc.output('blob');
//                 const customPdfFile = new File(
//                     [pdfBlob],
//                     `${formData.candidateName}_${formData.section}_CustomGenerated.pdf`,
//                     { type: 'application/pdf' }
//                 );

//                  // Prepare Payload for Upload Endpoint
//                 const uploadPayload = new FormData();
//                 uploadPayload.append('candidateName', formData.candidateName);
//                 uploadPayload.append('user_id', formData.user_id);
//                 uploadPayload.append('letterType', formData.section);
//                 uploadPayload.append('uploadedFile', customPdfFile);
//                 uploadPayload.append('generation_method', 'custom');
//                 if (formData.date) {
//                      uploadPayload.append('date', formData.date);
//                 }


//                 // API Call using the Upload Endpoint
//                 response = await axios.post("https://raasbackend.vetrinahealthcare.com/upload_existing_letter/", uploadPayload, {
//                     headers: { 'Content-Type': 'multipart/form-data' }
//                 });
//                 successMessage = `Custom ${formData.section} generated and saved successfully.`;


//             } else if (generationMethod === "upload") {
//                 // ... (upload logic remains the same)
//                  if (!uploadedFile) {
//                     Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning");
//                     setIsLoading(false);
//                     return;
//                 }
//                 const uploadPayload = new FormData();
//                 uploadPayload.append('candidateName', formData.candidateName);
//                 uploadPayload.append('user_id', formData.user_id);
//                 uploadPayload.append('letterType', formData.section);
//                 uploadPayload.append('uploadedFile', uploadedFile);
//                 uploadPayload.append('generation_method', 'upload');

//                 response = await axios.post("https://raasbackend.vetrinahealthcare.com/upload_existing_letter/", uploadPayload, {
//                     headers: { 'Content-Type': 'multipart/form-data' }
//                 });
//                 successMessage = `Existing ${formData.section} uploaded successfully.`;
//             }

//             // --- Success Handling ---
//             Swal.fire({
//                 title: "Success!",
//                 text: response?.data?.message || successMessage,
//                 icon: "success",
//                 timer: 2000,
//                 timerProgressBar: true,
//                 showConfirmButton: false,
//             }).then(() => {
//                 handleCloseModal();
//                 fetchLetters();
//                 if (navigateTo) {
//                     if (navigateState) {
//                         navigate(navigateTo, { state: navigateState });
//                     } else {
//                         navigate(navigateTo);
//                     }
//                 }
//             });

//         } catch (error) {
//             console.error(`Error during ${generationMethod} generation:`, error);
//             // Improved error reporting
//              let errorMsg = `Failed to ${generationMethod === 'upload' || generationMethod === 'custom' ? 'save' : 'generate'} ${formData.section}. `;
//              if (error.response) {
//                  // Server responded with a status code outside 2xx range
//                  errorMsg += error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`;
//              } else if (error.request) {
//                  // The request was made but no response was received
//                  errorMsg += 'No response from server. Please check network connection.';
//              } else {
//                  // Something happened in setting up the request that triggered an Error
//                  errorMsg += `Request setup error: ${error.message}`;
//              }
//             Swal.fire({
//                 title: "Error!",
//                 text: errorMsg,
//                 icon: "error",
//                 confirmButtonText: "OK",
//             });
//         } finally {
//             setIsLoading(false);
//         }
//     };


//     const handleOpenModal = () => {
//         setShowModal(true);
//         // No background fetching needed here anymore
//     };

//     const handleCloseModal = () => {
//         // ... (handleCloseModal logic remains the same)
//         setShowModal(false);
//         setFormData(initialFormData);
//         setSelectedCandidate(null);
//         setAddress("");
//         setPinCode("");
//         setMobileNumber("");
//         setShowApplicantData(false);
//         setGenerationMethod("template");
//         setCustomContent("");
//         setUploadedFile(null);
//         const fileInput = document.getElementById('uploadedFile');
//         if (fileInput) {
//             fileInput.value = null;
//         }
//     };

//     const formatDateTime = (dateTimeString) => {
//         // ... (formatDateTime logic remains the same)
//         if (!dateTimeString) return "N/A";
//         const options = {
//         year: "numeric", month: "long", day: "numeric",
//         hour: "numeric", minute: "2-digit", hour12: true,
//         };
//         try {
//             const date = new Date(dateTimeString);
//             if (isNaN(date)) return "Invalid Date";
//             return date.toLocaleString('en-US', options);
//         } catch (e) {
//             console.error("Error formatting date:", e);
//             return "Invalid Date";
//         }
//     };

//     const formatCandidateName = (candidate) => {
//         // ... (formatCandidateName logic remains the same)
//         if (!candidate) return "";
//         return `${candidate.full_name} (${candidate.id})`;
//     };
//     const candidateOptions = candidateNames.map((candidate) => ({
//         value: candidate.full_name,
//         label: formatCandidateName(candidate),
//         }));

//     const formatHrName = (hr) => {
//         // ... (formatHrName logic remains the same)
//         if (!hr) return "";
//         return `${hr.name} (${hr.id})`;
//     };
//     const hrOptions = hrList.map((hr) => ({
//         value: hr.id,
//         label: formatHrName(hr),
//     }));


//     const handleItemsPerPageChange = (e) => {
//         // ... (handleItemsPerPageChange logic remains the same)
//         const newItemsPerPage = parseInt(e.target.value, 10);
//         setItemsPerPage(newItemsPerPage);
//         setCurrentPage(1);
//     };

//     const handlePageChange = (pageNumber) => {
//         // ... (handlePageChange logic remains the same)
//         const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         } else if (pageNumber < 1 && totalPages > 0) {
//             setCurrentPage(1);
//         } else if (pageNumber > totalPages) {
//              setCurrentPage(totalPages);
//         }
//     };

//     // Pagination Logic
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//     const renderPaginationItems = () => {
//         // ... (renderPaginationItems logic remains the same)
//         const items = [];
//         const maxPagesToShow = 5;
//         const halfPagesToShow = Math.floor(maxPagesToShow / 2);

//         let startPage = Math.max(1, currentPage - halfPagesToShow);
//         let endPage = Math.min(totalPages, currentPage + halfPagesToShow);

//         if (currentPage <= halfPagesToShow) {
//             endPage = Math.min(totalPages, maxPagesToShow);
//         }
//         if (currentPage + halfPagesToShow >= totalPages) {
//             startPage = Math.max(1, totalPages - maxPagesToShow + 1);
//         }

//         items.push(<Pagination.First key="first" onClick={() => handlePageChange(1)} disabled={currentPage === 1} />);
//         items.push(<Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />);

//         if (startPage > 1) {
//             items.push(<Pagination.Item key={1} onClick={() => handlePageChange(1)}>{1}</Pagination.Item>);
//             if (startPage > 2) {
//                 items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
//             }
//         }

//         for (let number = startPage; number <= endPage; number++) {
//             items.push(
//                 <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
//                     {number}
//                 </Pagination.Item>
//             );
//         }

//         if (endPage < totalPages) {
//              if (endPage < totalPages - 1) {
//                 items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
//             }
//             items.push(<Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>);
//         }

//         items.push(<Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />);
//         items.push(<Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />);

//         return items;
//     };


//     // --- JSX ---
//     return (
//         <>
//         <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//             <DashNavbar />
//             <div className="wrapper" style={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
//             <Sidebar />
//             <div className="main" style={{ flexGrow: 1, overflowY: 'auto', padding: '20px' }}>
//                 <div className="container-fluid mt-3">
//                 <div className="card shadow-sm mb-4">
//                     <div className="card-body">
//                         {/* ... (Table Header and Search/Create Button - remains the same) ... */}
//                         <h2 className="display-6 gradient-text mb-4 text-center">Letters Management</h2>

//                         <div className="row mb-3 align-items-center">
//                             <div className="col-md-8 col-lg-9">
//                                 <div className="input-group search1">
//                                     <input
//                                         type="search"
//                                         className="form-control"
//                                         placeholder="Search by Candidate, Letter Type, or Method"
//                                         value={searchQuery}
//                                         onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//                                         aria-label="Search Letters"
//                                     />
//                                     <button className="btn btn-primary searchicon" type="button">
//                                         <i className="fas fa-search"></i>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div className="col-md-4 col-lg-3 text-md-end mt-2 mt-md-0">
//                                 <Button onClick={handleOpenModal} variant="success">
//                                     Create Letter <i className="fas fa-plus ms-1"></i>
//                                 </Button>
//                             </div>
//                         </div>

//                         {/* ... (Table Structure - remains the same) ... */}
//                          <div className="table-responsive">
//                             <Table hover responsive="lg" size="lg" className="table-striped border">
//                             <thead className="table-dark">
//                                 <tr>
//                                 <th>Sr.No</th>
//                                 <th>Candidate Name</th>
//                                 <th>Letter Type</th>
//                                 <th>Method</th>
//                                 <th>Letter PDF</th>
//                                 <th>Time Created</th>
//                                 <th>Send Mail</th>
//                                 <th>Mail Status</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {isLoading && currentItems.length === 0 ? (
//                                     <tr><td colSpan="8" className="text-center p-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></td></tr>
//                                 ) : currentItems.length > 0 ? (
//                                 currentItems.map((letter, index) => {
//                                     const globalIndex = indexOfFirstItem + index;
//                                     const pk = letter.pk;
//                                     const isTemplateRejection = letter.fields.generation_method === 'template' && letter.fields.LetterType === 'Rejection Letter';
//                                     return (
//                                         <tr key={pk}>
//                                         <td>{globalIndex + 1}</td>
//                                         <td>{letter.fields.candidate_name || 'N/A'}</td>
//                                         <td>{letter.fields.LetterType || 'N/A'}</td>
//                                         <td>
//                                             <span className={`badge bg-${
//                                                 letter.fields.generation_method === 'template' ? 'primary' :
//                                                 letter.fields.generation_method === 'custom' ? 'info' :
//                                                 letter.fields.generation_method === 'upload' ? 'secondary' : 'light'
//                                                 } text-capitalize`}>
//                                                 {letter.fields.generation_method || 'N/A'}
//                                             </span>
//                                         </td>
//                                         <td>
//                                             <Button
//                                                 size="sm"
//                                                 onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)}
//                                                 disabled={isDownloading[pk] || !letter.fields.pdf_path || isTemplateRejection}
//                                                 variant="outline-primary"
//                                                 title={isTemplateRejection ? "Download not available for Template Rejection Letters" : "Download PDF"}
//                                             >
//                                                 {isDownloading[pk] ? (
//                                                     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                 ) : (
//                                                     <><i className={`fas fa-download me-1 ${isTemplateRejection ? 'text-muted' : ''}`}></i> Download</>
//                                                 )}
//                                             </Button>
//                                         </td>
//                                         <td>{formatDateTime(letter.fields.Time)}</td>
//                                         <td>
//                                             <Button
//                                                 size="sm"
//                                                 onClick={() => sendEmail(
//                                                     letter.fields.candidate_name,
//                                                     letter.fields.pdf_path,
//                                                     letter.fields.LetterType,
//                                                     pk,
//                                                     globalIndex
//                                                 )}
//                                                 disabled={isSending[pk] || sentStatus[pk] || !letter.fields.pdf_path || isTemplateRejection}
//                                                 variant={sentStatus[pk] ? "outline-secondary" : "outline-success"}
//                                                 title={isTemplateRejection ? "Sending not available for Template Rejection Letters" : sentStatus[pk] ? "Email already sent" : "Send Email"}
//                                                 >
//                                                 {isSending[pk] ? (
//                                                     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                 ) : sentStatus[pk] ? (
//                                                     <><i className="fas fa-check me-1"></i> Sent</>
//                                                 ) : (
//                                                     <><i className={`fas fa-paper-plane me-1 ${isTemplateRejection ? 'text-muted' : ''}`}></i> Send</>
//                                                 )}
//                                             </Button>
//                                         </td>
//                                         <td className="text-center">
//                                             {sentStatus[pk] ? (
//                                                 <FcApproval size="24px" title="Email Sent" />
//                                             ) : (
//                                                 <FcHighPriority size="24px" title="Email Not Sent / Not Applicable" />
//                                             )}
//                                         </td>
//                                         </tr>
//                                     );
//                                     })
//                                 ) : (
//                                     !isLoading && (
//                                         <tr>
//                                             <td colSpan="8" className="text-center p-4">
//                                                 {searchQuery ? "No letters found matching your search." : letters.length === 0 ? "No letters created yet." : "No letters found for this page/filter."}
//                                             </td>
//                                         </tr>
//                                     )
//                                 )}
//                             </tbody>
//                             </Table>
//                         </div>

//                         {/* ... (Pagination Controls - remains the same) ... */}
//                         {filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                             <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
//                                 <div className="d-flex align-items-center mb-2 mb-md-0">
//                                     <span className="me-2 text-muted"><small>Items per page:</small></span>
//                                     <Form.Select
//                                         size="sm"
//                                         style={{ width: "auto" }}
//                                         value={itemsPerPage}
//                                         onChange={handleItemsPerPageChange}
//                                         aria-label="Select number of items per page"
//                                     >
//                                         <option value="5">5</option>
//                                         <option value="10">10</option>
//                                         <option value="20">20</option>
//                                         <option value="50">50</option>
//                                     </Form.Select>
//                                 </div>
//                                 <Pagination size="sm" className="mb-0">
//                                     {renderPaginationItems()}
//                                 </Pagination>
//                                 <div className="text-muted mb-2 mb-md-0">
//                                     <small>Page {currentPage} of {totalPages}</small>
//                                 </div>
//                             </div>
//                         )}
//                         <div className="text-muted mt-2"><small>Total Letters: {filteredLetters.length}</small></div>

//                     </div>
//                 </div>
//                 </div>
//             </div> {/* End Main Content */}
//             </div> {/* End Wrapper */}

//             {/* --- Modal --- */}
//             <Modal show={showModal} onHide={handleCloseModal} size="lg" backdrop="static" keyboard={false}>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">Create Letter</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                  {/* REMOVED loading indicator for background image */}
//                 <Form onSubmit={handleSubmit}>
//                     {/* ... (Modal Form Structure - Generation Method, Letter Type, Candidate - remains the same) ... */}
//                     <div className="row">
//                         <div className="col-md-6">
//                              <Form.Group className="mb-3" controlId="generationMethod">
//                                 <Form.Label>Generation Method:</Form.Label>
//                                 <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)}>
//                                     <option value="template">Generate from Template</option>
//                                     <option value="custom">Write Custom Content</option>
//                                     <option value="upload">Upload Existing Letter</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </div>
//                          <div className="col-md-6">
//                              <Form.Group className="mb-3" controlId="section">
//                                 <Form.Label>Letter Type:</Form.Label>
//                                 <Form.Select name="section" value={formData.section} onChange={handleChange}>
//                                     <option value="Offer Letter">Offer Letter</option>
//                                     <option value="Rejection Letter">Rejection Letter</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </div>
//                     </div>

//                      <Form.Group className="mb-3" controlId="candidateNameSelect">
//                         <Form.Label>Candidate Name:</Form.Label>
//                         <Select
//                             options={candidateOptions}
//                             value={selectedCandidate}
//                             onChange={handleCandidateChange}
//                             placeholder="Select candidate..."
//                             isSearchable={true}
//                             required
//                             inputId="react-select-candidate"
//                         />
//                          {showApplicantData && (
//                             <div className="alert alert-secondary p-2 mt-2 mb-0">
//                                 <small>
//                                     <strong>Applicant Info:</strong>
//                                     {address && ` Address: ${address}`}
//                                     {pinCode && `, Pin: ${pinCode}`}
//                                     {mobileNumber && `, Mobile: ${mobileNumber}`}
//                                     {!address && !pinCode && !mobileNumber && ' (Details not available)'}
//                                  </small>
//                             </div>
//                         )}
//                     </Form.Group>

//                     {/* --- Fields based on Generation Method --- */}

//                     {/* 1. Generate from Template Fields */}
//                     {generationMethod === 'template' && (
//                         <>
//                          {/* ... (Template fields logic remains the same) ... */}
//                           {formData.section === "Offer Letter" && (
//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <Form.Group className="mb-3" controlId="hrNameSelect">
//                                             <Form.Label>HR Name:</Form.Label>
//                                             <Select
//                                                 options={hrOptions}
//                                                 value={formData.hr ? hrOptions.find(option => option.value === formData.hr.id) : null}
//                                                 onChange={handleHrChange}
//                                                 placeholder="Select HR..."
//                                                 isSearchable={true}
//                                                 required
//                                                 inputId="react-select-hr"
//                                             />
//                                         </Form.Group>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <Form.Group className="mb-3" controlId="position">
//                                             <Form.Label>Position:</Form.Label>
//                                             <Form.Control
//                                                 type="text" name="position"
//                                                 value={formData.position} onChange={handleChange} required
//                                             />
//                                         </Form.Group>
//                                     </div>
//                                     <div className="col-md-4">
//                                          <Form.Group className="mb-3" controlId="salary">
//                                             <Form.Label>Salary (LPA):</Form.Label>
//                                             <Form.Control
//                                                 type="text" name="salary"
//                                                 value={formData.salary} onChange={handleChange} required placeholder="e.g., 5.5"
//                                             />
//                                         </Form.Group>
//                                     </div>
//                                 </div>
//                             )}
//                             <Form.Group className="mb-3" controlId="date">
//                                 <Form.Label>Date:</Form.Label>
//                                 <Form.Control
//                                     type="date" name="date"
//                                     value={formData.date} onChange={handleChange} required
//                                 />
//                             </Form.Group>
//                         </>
//                     )}

//                     {/* 2. Write Custom Content Fields */}
//                     {generationMethod === 'custom' && (
//                         <>
//                             {/* Textarea and Date are NOT disabled anymore */}
//                             <Form.Group className="mb-3" controlId="customContent">
//                                 <Form.Label>Letter Content:</Form.Label>
//                                 <Form.Control
//                                     as="textarea" rows={10}
//                                     value={customContent} onChange={(e) => setCustomContent(e.target.value)}
//                                     placeholder="Enter the full content of the letter here. It will be placed onto the standard Vetrina template background."
//                                     required
//                                     // REMOVED: disabled={!backgroundImageData}
//                                 />
//                                 {/* REMOVED: Form.Text feedback about background loading */}
//                             </Form.Group>

//                             <Form.Group className="mb-3" controlId="dateCustom">
//                                 <Form.Label>Date:</Form.Label>
//                                 <Form.Control
//                                     type="date" name="date"
//                                     value={formData.date} onChange={handleChange} required
//                                     // REMOVED: disabled={!backgroundImageData}
//                                 />
//                             </Form.Group>
//                         </>
//                     )}

//                     {/* 3. Upload Existing Letter Fields */}
//                     {generationMethod === 'upload' && (
//                         <>
//                          {/* ... (Upload fields logic remains the same) ... */}
//                          <Form.Group controlId="uploadedFile" className="mb-3">
//                             <Form.Label>Upload PDF Letter:</Form.Label>
//                             <Form.Control
//                                 type="file" accept=".pdf"
//                                 onChange={handleFileChange} required
//                                 />
//                             {uploadedFile && <Form.Text>{uploadedFile.name}</Form.Text>}
//                         </Form.Group>
//                         </>
//                     )}

//                     {/* --- Submit Button --- */}
//                     <div className="d-grid mt-4">
//                         <Button
//                             variant="primary" type="submit"
//                             // REMOVED background image check from disabled condition
//                             disabled={isLoading}
//                             size="lg"
//                         >
//                             {isLoading ? (
//                             <>
//                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                 Processing...
//                             </>
//                             ) : (
//                                 `Save ${formData.section}`
//                             )}
//                         </Button>
//                     </div>
//                 </Form>
//             </Modal.Body>
//             </Modal>

//         </div> {/* End Outer Flex Container */}
//         </>
//     );
// };

// export default OfferLetterGenerator;


// // OfferLetterGenerator.js
// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";

// const OfferLetterGenerator = () => {
//   // ... (existing states - no changes here) ...
//   const [letters, setLetters] = useState([]);
//   const [candidateNames, setCandidateNames] = useState([]);
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredLetters, setFilteredLetters] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [isLoading, setIsLoading] = useState(false);
//   const [noDataFound, setNoDataFound] = useState(false);
//   const [sentStatus, setSentStatus] = useState({});
//   const [isDownloading, setIsDownloading] = useState({});
//   const [isSending, setIsSending] = useState({});
//   const [address, setAddress] = useState("");
//   const [pinCode, setPinCode] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [showApplicantData, setShowApplicantData] = useState(false);
//   const [hrList, setHrList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);

//   const [generationMethod, setGenerationMethod] = useState("template");
//   const [customContent, setCustomContent] = useState("");
//   const [uploadedFile, setUploadedFile] = useState(null); // For 'upload' method
//   const [signatureFile, setSignatureFile] = useState(null); // For 'custom' AND 'template' method signature
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null); // *** ADDED: For signature preview URL ***


//   const initialFormData = {
//     candidateName: "",
//     position: "",
//     salary: "",
//     date: "",
//     section: "Offer Letter",
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//   };
//   const [formData, setFormData] = useState(initialFormData);

//   // ... (fetchLetters, fetchCandidateNames, fetchHrList - unchanged) ...
//   const fetchLetters = useCallback(async () => { // Wrap in useCallback
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_letters/");
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else {
//         console.error("Invalid data format: letters field is not an array");
//         setLetters([]);
//         setNoDataFound(true);
//       }
//     } catch (error) {
//       console.error("Error fetching letters:", error);
//       setLetters([]);
//       setNoDataFound(true);
//     }
//   }, []); // Add dependencies if needed, empty means run once

//   const fetchCandidateNames = useCallback(async () => { // Wrap in useCallback
//     try {
//       const response = await axios.get(
//         "https://raasbackend.vetrinahealthcare.com/get_candidate_names/"
//       );
//       const data = response.data;
//       if (data && Array.isArray(data.candidate_names)) {
//         setCandidateNames(data.candidate_names);
//       } else {
//         console.error(
//           "Invalid data format: candidate_names field is not an array"
//         );
//         setCandidateNames([]);
//       }
//     } catch (error) {
//       console.error("Error fetching candidate names:", error);
//       setCandidateNames([]);
//     }
//   }, []); // Empty dependency array

//   const fetchHrList = useCallback(async () => { // Wrap in useCallback
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) {
//         setHrList(data);
//       } else {
//         console.error("Invalid data format: HR list is not an array");
//         setHrList([]);
//       }
//     } catch (error) {
//       console.error("Error fetching HR list:", error);
//       setHrList([]);
//     }
//   }, []); // Empty dependency array


//   useEffect(() => {
//     fetchLetters();
//     fetchCandidateNames();
//     fetchHrList();
//   }, [fetchLetters, fetchCandidateNames, fetchHrList]); // Add fetched functions as dependencies


//   // ... (applySearchAndPagination, initializeSentStatus - unchanged) ...
//   const applySearchAndPagination = useCallback(() => { // Wrap in useCallback
//     let filteredData = letters.filter((letter) => {
//       const candidateMatches = letter.fields.candidate_name
//         ?.toLowerCase() // Optional chaining
//         .includes(searchQuery.toLowerCase());
//       const typeMatches = letter.fields.LetterType
//         ?.toLowerCase() // Optional chaining
//         .includes(searchQuery.toLowerCase());
//       // Add search by generation method if needed
//       const methodMatches = letter.fields.generation_method?.toLowerCase().includes(searchQuery.toLowerCase());
//       return candidateMatches || typeMatches || methodMatches; // Search method too
//     });

//     setNoDataFound(filteredData.length === 0 && letters.length > 0); // Only show "not found" if search yields no results on existing data
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]); // Dependencies


//   useEffect(() => {
//     applySearchAndPagination();
//     // Reset page if filtered results are less than current page * itemsPerPage
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) {
//       setCurrentPage(totalPages);
//     } else if (currentPage === 0 && totalPages > 0) {
//       setCurrentPage(1); // Ensure current page is at least 1 if there are items
//     } else if (filteredLetters.length === 0) {
//       setCurrentPage(1); // Reset to 1 if no results
//     }

//   }, [letters, searchQuery, currentPage, itemsPerPage, filteredLetters.length, applySearchAndPagination]); // Added dependencies


//   const initializeSentStatus = (lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.pk] = letter.fields.sent == 1; // Use == for potential type difference
//     });
//     setSentStatus(initialSentStatus);
//   };

//   // ... (sendEmail, downloadPdf - unchanged) ...
//   const sendEmail = async (candidateName, pdfPath, LetterType, pk, index) => { // Added pk
//     if (!pdfPath) {
//       Swal.fire("Info", "No PDF available to send for this letter.", "info");
//       return;
//     }
//     const updatedSending = { ...isSending };
//     updatedSending[pk] = true; // Use pk as key for consistency
//     setIsSending(updatedSending);

//     try {
//       await axios.post(
//         "https://raasbackend.vetrinahealthcare.com/send_offer_letter_email/",
//         {
//           candidate_name: candidateName,
//           pdf_path: pdfPath, // Send the relative path stored in DB
//           letter_type: LetterType,
//         }
//       );
//       Swal.fire({
//         icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true,
//       });
//       const updatedSentStatus = { ...sentStatus };
//       updatedSentStatus[pk] = true;
//       setSentStatus(updatedSentStatus);

//       // Update backend status
//       await axios.put(
//         `https://raasbackend.vetrinahealthcare.com/update_sent_status/${pk}/`,
//         { sent: 1 }
//       );
//       // Optionally refetch letters to confirm status change from backend
//       // fetchLetters();
//     } catch (error) {
//       console.error("Error sending email:", error);
//       Swal.fire({
//         icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true,
//       });
//     } finally {
//       const finalSending = { ...isSending }; // Get latest state again
//       finalSending[pk] = false;
//       setIsSending(finalSending);
//     }
//   };

//   const downloadPdf = async (pdfPath, pk, candidateName, letterType) => { // Added pk, candidateName, letterType
//     if (!pdfPath) {
//       Swal.fire("Info", "No PDF available to download for this letter.", "info");
//       return;
//     }
//     const updatedDownloading = { ...isDownloading };
//     updatedDownloading[pk] = true; // Use pk as key
//     setIsDownloading(updatedDownloading);

//     try {
//       // Backend endpoint expects pdfPath as query param
//       const response = await axios.get(
//         `https://raasbackend.vetrinahealthcare.com/download_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`,
//         { responseType: "blob" }
//       );
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })); // Specify type
//       const link = document.createElement("a");
//       link.href = url;
//       // Generate a meaningful filename
//       const filename = `${candidateName}_${letterType}.pdf`.replace(/ /g, '_');
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link); // Clean up
//       window.URL.revokeObjectURL(url); // Release object URL
//     } catch (error) {
//       console.error("Error downloading PDF:", error);
//       Swal.fire("Error", "Could not download PDF.", "error");
//     } finally {
//       const finalDownloading = { ...isDownloading }; // Get latest state
//       finalDownloading[pk] = false;
//       setIsDownloading(finalDownloading);
//     }
//   };


//   // --- Modal and Form Handling ---

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleHrChange = (selectedOption) => {
//     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//     setFormData((prevState) => ({
//       ...prevState,
//       hr: selectedHr || null,
//     }));
//   };

//   const handleFileChange = (e) => { // For 'upload' method
//     setUploadedFile(e.target.files[0] || null);
//   };

//   const handleSignatureFileChange = (e) => { // For 'custom' & 'template' methods
//     const file = e.target.files[0] || null;
//     setSignatureFile(file); // Store the File object for upload

//     // Generate preview URL
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSignaturePreviewUrl(reader.result); // Store the Base64 URL
//         console.log("Signature Preview URL generated.");
//       };
//       reader.onerror = (error) => {
//         console.error("Error reading signature file:", error);
//         setSignaturePreviewUrl(null); // Clear on error
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setSignaturePreviewUrl(null); // Clear preview if no file selected
//       console.log("Signature file cleared, clearing preview URL.");
//     }
//   };

//   // handleCandidateChange - unchanged
//   const handleCandidateChange = async (selectedOption) => {
//     setSelectedCandidate(selectedOption); // Update selection state for react-select

//     const candidateName = selectedOption?.value || "";
//     const label = selectedOption?.label || "";
//     let userId = null;

//     if (label) {
//       const match = label.match(/\(([^)]+)\)/); // Regex to extract ID
//       if (match && match[1]) {
//         userId = match[1];
//       }
//     }

//     // Reset applicant specific data first
//     setAddress("");
//     setPinCode("");
//     setMobileNumber("");
//     setShowApplicantData(false);
//     // Update common form data parts
//     setFormData((prevState) => ({
//       ...prevState,
//       candidateName: candidateName,
//       user_id: userId, // Store user_id if found
//       address: "", // Reset address in form data
//       pinCode: "", // Reset pinCode in form data
//       mobileNumber: "", // Reset mobileNumber in form data
//     }));


//     if (userId && candidateName) { // Only fetch if we have a user ID
//       try {
//         const response = await axios.get(
//           `https://raasbackend.vetrinahealthcare.com/applicants_data/${userId}/`
//         );
//         const applicantData = response.data;

//         // Update display state
//         setAddress(applicantData.street_address || "");
//         setPinCode(applicantData.zip_code || "");
//         setMobileNumber(applicantData.phone || "");
//         setShowApplicantData(true); // Show the applicant data fields

//         // Update form data with fetched details (important for template method)
//         setFormData((prevState) => ({
//           ...prevState,
//           address: applicantData.street_address || "",
//           pinCode: applicantData.zip_code || "",
//           mobileNumber: applicantData.phone || "",
//         }));
//       } catch (error) {
//         console.error("Error fetching applicant data:", error);
//         setShowApplicantData(false); // Hide on error
//         // Keep form data reset as above
//       }
//     }
//   };


//   // *** UPDATED handleSubmit Logic for TEMPLATE method ***
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     // --- Validation (Keep as before) ---
//     if (!formData.candidateName || !formData.user_id) {
//       Swal.fire("Validation Error", "Please select a candidate.", "warning");
//       setIsLoading(false);
//       return;
//     }
//     if (!formData.date && (generationMethod === 'template' || generationMethod === 'custom')) {
//       Swal.fire("Validation Error", "Please select a date.", "warning");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       let response;
//       let successMessage = "";
//       let navigateTo = null;
//       let navigateState = null;
//       let backendSuccessMessage = "";
//       let endpoint = "";
//       let payload = {};
//       let headers = { 'Content-Type': 'application/json' }; // Default header

//       // --- Prepare Payload and Endpoint based on Method ---
//       if (generationMethod === "template") {
//         // *** TEMPLATE logic now uses FormData ***
//         endpoint = "https://raasbackend.vetrinahealthcare.com/offer_letter/"; // Original endpoint
//         headers = { 'Content-Type': 'multipart/form-data' }; // *** CHANGE: Header ***

//         // --- Validation for Template Offer Letter ---
//         if (formData.section === "Offer Letter") {
//           if (!formData.hr) {
//             Swal.fire("Validation Error", "Please select an HR representative.", "warning");
//             setIsLoading(false); return;
//           }
//           if (!formData.position) {
//             Swal.fire("Validation Error", "Please enter a Position.", "warning");
//             setIsLoading(false); return;
//           }
//           if (!formData.salary) {
//             Swal.fire("Validation Error", "Please enter a Salary.", "warning");
//             setIsLoading(false); return;
//           }
//         }
//         // --- End Validation ---

//         payload = new FormData(); // *** CHANGE: Use FormData ***
//         payload.append('candidateName', formData.candidateName);
//         payload.append('user_id', formData.user_id);
//         payload.append('section', formData.section); // Backend needs letter type
//         payload.append('date', formData.date);
//         // Append template-specific fields only if present
//         if (formData.position) payload.append('position', formData.position);
//         if (formData.salary) payload.append('salary', formData.salary);
//         if (formData.hr?.id) payload.append('hr_id', formData.hr.id); // Send HR ID
//         // Include address details if needed by backend (check backend requirements)
//         // payload.append('address', formData.address);
//         // payload.append('pinCode', formData.pinCode);
//         // payload.append('mobileNumber', formData.mobileNumber);

//         // Append signature file if selected
//         if (signatureFile) {
//           payload.append('signatureImage', signatureFile, signatureFile.name); // Key must match backend
//           console.log("Appending signature file (template):", signatureFile.name);
//         } else {
//           console.log("No signature file selected (template).");
//         }

//         // Navigation logic for template
//         successMessage = `${formData.section} record creation initiated. Proceeding to preview...`;
//         if (formData.section === "Offer Letter") {
//           navigateTo = "/OfferLetter";
//           // Pass necessary data for preview (might need adjustment if backend changes significantly)
//           navigateState = { ...formData, generationMethod: 'template', signaturePreviewUrl: signaturePreviewUrl };
//         } else {
//           navigateTo = "/letterform"; // Rejection letter template goes back to list
//           successMessage = "Rejection Letter record creation initiated."; // Adjust msg if needed
//         }

//       } else if (generationMethod === "custom") {
//         // --- Custom Logic (Unchanged - Already uses FormData) ---
//         endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_letter/";
//         headers = { 'Content-Type': 'multipart/form-data' };

//         if (!customContent.trim()) { /* ... validation ... */
//           Swal.fire("Validation Error", "Please enter custom letter content.", "warning");
//           setIsLoading(false); return;
//         }
//         if (!formData.hr && formData.section === "Offer Letter") { /* ... validation ... */
//           Swal.fire("Validation Error", "Please select an HR representative.", "warning");
//           setIsLoading(false); return;
//         }

//         payload = new FormData();
//         payload.append('candidateName', formData.candidateName);
//         payload.append('user_id', formData.user_id);
//         payload.append('letterType', formData.section);
//         payload.append('customContent', customContent);
//         payload.append('date', formData.date);
//         if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//         if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//         successMessage = `Custom ${formData.section} record creation initiated. Proceeding to preview...`;
//         if (formData.section === "Offer Letter") {
//           navigateTo = "/OfferLetter";
//           navigateState = { /* ... data for custom preview ... */
//             candidateName: formData.candidateName, date: formData.date, address: formData.address,
//             pinCode: formData.pinCode, mobileNumber: formData.mobileNumber, hr: formData.hr,
//             customContent: customContent, section: formData.section, generationMethod: 'custom',
//             signaturePreviewUrl: signaturePreviewUrl // *** ADDED ***
//           };
//         } else {
//           navigateTo = "/letterform";
//           successMessage = `Custom ${formData.section} saving initiated.`;
//         }

//       } else if (generationMethod === "upload") {
//         // --- Upload Logic (Unchanged - Already uses FormData) ---
//         endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_letter/";
//         headers = { 'Content-Type': 'multipart/form-data' };

//         if (!uploadedFile) { /* ... validation ... */
//           Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning");
//           setIsLoading(false); return;
//         }

//         payload = new FormData();
//         payload.append('candidateName', formData.candidateName);
//         payload.append('user_id', formData.user_id);
//         payload.append('letterType', formData.section);
//         payload.append('uploadedFile', uploadedFile);

//         successMessage = `Existing ${formData.section} upload initiated.`;
//         navigateTo = "/letterform"; // Go back to list after upload
//       }

//       // --- Make the Axios Request ---
//       console.log(`Sending ${generationMethod} request to ${endpoint} with payload:`, payload); // Log before sending
//       if (generationMethod !== 'upload' && generationMethod !== 'custom') { // Log FormData entries for template/custom
//         for (let pair of payload.entries()) {
//           console.log(`  Payload: ${pair[0]}: ${pair[1] instanceof File ? pair[1].name : pair[1]}`);
//         }
//       }


//       response = await axios.post(endpoint, payload, { headers: headers });
//       backendSuccessMessage = response.data.message; // Get message from backend response

//       // Adjust success message if backend provided one
//       if (backendSuccessMessage) {
//         successMessage = backendSuccessMessage;
//       } else {
//         // Fallback messages if backend doesn't provide detail
//         if (generationMethod === 'template' && formData.section !== 'Offer Letter') successMessage = "Rejection Letter record saved.";
//         else if (generationMethod === 'custom' && formData.section !== 'Offer Letter') successMessage = "Custom Rejection Letter saved.";
//         else if (generationMethod === 'upload') successMessage = "File uploaded successfully.";
//         else successMessage = "Operation successful. Proceeding to preview..." // Default preview message
//       }


//       // --- Success Handling ---
//       Swal.fire({
//         title: "Success!",
//         text: successMessage,
//         icon: "success",
//         timer: navigateTo === "/OfferLetter" ? 1500 : 2500, // Longer timer if just saving/uploading
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         handleCloseModal();
//         fetchLetters(); // Refresh list
//         if (navigateTo) {
//           console.log("Navigating to:", navigateTo, "with state:", navigateState);
//           if (navigateState) {
//             navigate(navigateTo, { state: navigateState });
//           } else {
//             navigate(navigateTo);
//           }
//         }
//       });

//     } catch (error) {
//       // --- Error Handling (Unchanged) ---
//       console.error(`Error during ${generationMethod} process:`, error);
//       let errorMsg = `Failed during ${generationMethod} process. Please try again.`;
//       if (error.response) {
//         console.error("Backend Error Response:", error.response.data);
//         errorMsg = error.response.data?.error_message || error.response.data?.error || errorMsg;
//       } else if (error.request) {
//         console.error("Backend No Response:", error.request);
//         errorMsg = "Could not connect to the server. Please check your connection.";
//       } else {
//         console.error("Frontend Setup/Script Error:", error.message);
//         errorMsg = `An application error occurred: ${error.message}`;
//       }

//       Swal.fire({
//         title: "Error!",
//         text: errorMsg,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };


//   // handleOpenModal - unchanged
//   const handleOpenModal = () => {
//     setShowModal(true);
//   };

//   // handleCloseModal - unchanged (already resets signatureFile)
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setFormData(initialFormData);
//     setSelectedCandidate(null);
//     setAddress("");
//     setPinCode("");
//     setMobileNumber("");
//     setShowApplicantData(false);
//     setGenerationMethod("template");
//     setCustomContent("");
//     setUploadedFile(null);
//     setSignatureFile(null); // Reset signature file state
//     setSignaturePreviewUrl(null); // *** ADDED: Reset signature preview URL ***


//     // Clear file input visually
//     const fileInputUpload = document.getElementById('uploadedFile');
//     if (fileInputUpload) fileInputUpload.value = null;
//     const fileInputSignature = document.getElementById('signatureImageFile'); // Use the correct ID
//     if (fileInputSignature) fileInputSignature.value = null;
//   };


//   // ... (formatDateTime, formatCandidateName, formatHrName, options - unchanged) ...
//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return "N/A"; // Handle null dates
//     const options = {
//       year: "numeric", month: "long", day: "numeric",
//       hour: "numeric", minute: "2-digit", hour12: true,
//     };
//     try {
//       return new Date(dateTimeString).toLocaleString(undefined, options);
//     } catch (e) {
//       return "Invalid Date";
//     }
//   };

//   // Candidate Name Formatting for Dropdown
//   const formatCandidateName = (candidate) => {
//     if (!candidate) return "";
//     return `${candidate.full_name} (${candidate.id})`;
//   };
//   const candidateOptions = candidateNames.map((candidate) => ({
//     value: candidate.full_name,
//     label: formatCandidateName(candidate),
//     // Include id directly if needed elsewhere without parsing label
//     // id: candidate.id
//   }));

//   // HR Name Formatting for Dropdown
//   const formatHrName = (hr) => {
//     if (!hr) return "";
//     return `${hr.name} (${hr.id})`;
//   };
//   const hrOptions = hrList.map((hr) => ({
//     value: hr.id,
//     label: formatHrName(hr),
//   }));


//   // ... (handleItemsPerPageChange, handlePageChange, pagination logic - unchanged) ...
//   const handleItemsPerPageChange = (e) => {
//     const newItemsPerPage = parseInt(e.target.value, 10);
//     setItemsPerPage(newItemsPerPage);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (pageNumber) => {
//     // Basic validation: Ensure page number is within bounds
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     } else if (pageNumber < 1) {
//       setCurrentPage(1);
//     } else if (pageNumber > totalPages) {
//       setCurrentPage(totalPages);
//     }
//   };

//   // Pagination Logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);


//   // --- JSX ---
//   return (
//     <>
//       {/* ... (Outer structure: DashNavbar, Sidebar, main container, card - unchanged) ... */}
//       <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//         <DashNavbar />
//         <div className="wrapper"> {/* Ensure 'wrapper' class exists and provides flex layout */}
//           <Sidebar />
//           <div className="main" style={{ flexGrow: 1, overflowY: 'auto', padding: '20px' }}> {/* Ensure 'main' allows scrolling */}
//             {/* Container wrapping the content */}
//             <div className="container-fluid mt-3"> {/* Use container-fluid for better responsiveness */}
//               <div className="card shadow-sm"> {/* Use card for better structure */}
//                 <div className="card-body">
//                   <h2 className="display-6 gradient-text mb-4 text-center">Letters Management</h2>

//                   {/* Search and Create Button Row */}
//                   <div className="row mb-3 align-items-center">
//                     <div className="col-md-8">
//                       {/* --- Use input-group, remove custom 'search1' class for now --- */}
//                       <div className="input-group">
//                         <input
//                           type="search"
//                           className="form-control" // Keep standard form-control
//                           placeholder="Search..." // Simplified placeholder for testing
//                           value={searchQuery}
//                           onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//                           aria-label="Search Letters"
//                         />
//                         {/* --- Remove custom 'searchicon' class for now --- */}
//                         <button className="btn btn-primary" type="button">
//                           <i className="fas fa-search"></i>
//                         </button>
//                       </div>
//                     </div>
//                     <div className="col-md-4 text-md-end mt-2 mt-md-0">
//                       {/* Assuming 'Button' is React-Bootstrap or similar */}
//                       <Button onClick={handleOpenModal} variant="success">
//                         Create Letter <i className="fas fa-plus ms-1"></i>
//                       </Button>
//                     </div>
//                   </div>

//                   {/* Table */}
//                   <div className="table-responsive"> {/* Make table responsive */}
//                     <Table hover responsive="lg" size="lg" className="table-striped"> {/* Added striped */}
//                       <thead className="table-dark"> {/* Darker header */}
//                         <tr>
//                           <th>Sr.No</th>
//                           <th>Candidate Name</th>
//                           <th>Letter Type</th>
//                           <th>Method</th>{/* Added Method Column */}
//                           <th>Letter PDF</th>
//                           <th>Time</th>
//                           <th>Send Mail</th>
//                           <th>Mail Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoading && !currentItems.length ? (
//                           <tr><td colSpan="8" className="text-center p-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></td></tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((letter, index) => {
//                             const globalIndex = indexOfFirstItem + index; // Use global index for loaders/status keys if needed
//                             const pk = letter.pk; // Use primary key for identifying rows
//                             return (
//                               <tr key={pk}>
//                                 <td>{globalIndex + 1}</td>
//                                 <td>{letter.fields.candidate_name}</td>
//                                 <td>{letter.fields.LetterType}</td>
//                                 {/* Display Generation Method */}
//                                 <td>
//                                   <span className={`badge bg-${letter.fields.generation_method === 'template' ? 'primary' :
//                                     letter.fields.generation_method === 'custom' ? 'info' :
//                                       letter.fields.generation_method === 'upload' ? 'secondary' : 'light'
//                                     }`}>
//                                     {letter.fields.generation_method?.charAt(0).toUpperCase() + letter.fields.generation_method?.slice(1) || 'N/A'}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   {/* Disable download if no pdf_path */}
//                                   {/* Removed the template rejection letter restriction for download, allow download if path exists */}
//                                   <Button
//                                     size="sm"
//                                     onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)}
//                                     disabled={isDownloading[pk] || !letter.fields.pdf_path}
//                                     variant="outline-primary" // Adjusted style
//                                   >
//                                     {isDownloading[pk] ? (
//                                       <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                     ) : (
//                                       <><i className="fas fa-download me-1"></i> Download</>
//                                     )}
//                                   </Button>
//                                 </td>
//                                 <td>{formatDateTime(letter.fields.Time)}</td>
//                                 <td>
//                                   {/* Disable send if already sent OR no pdf_path */}
//                                   {/* Removed the template rejection letter restriction for sending, allow send if path exists */}
//                                   <Button
//                                     size="sm"
//                                     onClick={() => sendEmail(
//                                       letter.fields.candidate_name,
//                                       letter.fields.pdf_path,
//                                       letter.fields.LetterType,
//                                       pk, // Pass pk
//                                       globalIndex // Pass index if needed by sendEmail internal logic
//                                     )}
//                                     disabled={isSending[pk] || sentStatus[pk] || !letter.fields.pdf_path}
//                                     variant={sentStatus[pk] ? "outline-secondary" : "outline-success"} // Adjusted style
//                                   >
//                                     {isSending[pk] ? (
//                                       <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                     ) : sentStatus[pk] ? (
//                                       <><i className="fas fa-check me-1"></i> Sent</>
//                                     ) : (
//                                       <><i className="fas fa-paper-plane me-1"></i> Send</>
//                                     )}
//                                   </Button>
//                                 </td>
//                                 <td className="text-center"> {/* Centered status icon */}
//                                   {sentStatus[pk] ? (
//                                     <FcApproval size="24px" title="Email Sent" />
//                                   ) : (
//                                     <FcHighPriority size="24px" title="Email Not Sent" />
//                                   )}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           !isLoading && (noDataFound || letters.length === 0) && ( // Check noDataFound or initial empty state
//                             <tr>
//                               <td colSpan="8" className="text-center p-4">
//                                 {searchQuery ? "No letters found matching your search." : "No letters created yet."}
//                               </td>
//                             </tr>
//                           )
//                         )}
//                       </tbody>
//                     </Table>
//                   </div> {/* End table responsive */}


//                   {/* Pagination and Items Per Page */}
//                   {filteredLetters.length > 0 && totalPages > 1 && ( // Only show pagination if needed
//                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
//                       <div className="d-flex align-items-center mb-2 mb-md-0">
//                         <span className="me-2">Items per page:</span>
//                         <Form.Select // Use Form.Select
//                           size="sm" // Smaller select
//                           style={{ width: "auto" }}
//                           value={itemsPerPage}
//                           onChange={handleItemsPerPageChange}
//                         >
//                           <option value="5">5</option>
//                           <option value="10">10</option>
//                           <option value="20">20</option>
//                           <option value="50">50</option>
//                         </Form.Select>
//                       </div>
//                       <Pagination size="sm"> {/* Smaller pagination */}
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         {/* Simple pagination display - enhance if needed */}
//                         <Pagination.Item active>{currentPage}</Pagination.Item>
//                         {/* Optional: Show next page number if not last */}
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                         {currentPage < totalPages - 1 && <Pagination.Ellipsis />}
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}

//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                       </Pagination>
//                     </div>
//                   )} {/* End pagination container */}

//                 </div> {/* End card-body */}
//               </div> {/* End card */}
//             </div> {/* End container */}
//           </div> {/* End main */}
//         </div> {/* End wrapper */}

//         {/* --- MODAL --- */}
//         <Modal show={showModal} onHide={handleCloseModal} size="lg">
//           <Modal.Header closeButton>
//             <Modal.Title className="gradient-text">Create Letter</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form onSubmit={handleSubmit}>
//               {/* ... (Generation Method, Letter Type, Candidate Name - unchanged) ... */}
//               {/* Generation Method Selection */}
//               <Form.Group className="mb-3" controlId="generationMethod">
//                 <Form.Label>Generation Method:</Form.Label>
//                 <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)}>
//                   <option value="template">Generate from Template</option>
//                   <option value="custom">Write Custom Content</option>
//                   <option value="upload">Upload Existing Letter</option>
//                 </Form.Select>
//               </Form.Group>

//               {/* Letter Type */}
//               <Form.Group className="mb-3" controlId="section">
//                 <Form.Label>Letter Type:</Form.Label>
//                 <Form.Select name="section" value={formData.section} onChange={handleChange}>
//                   <option value="Offer Letter">Offer Letter</option>
//                   <option value="Rejection Letter">Rejection Letter</option>
//                 </Form.Select>
//                 {generationMethod === 'custom' && formData.section === 'Rejection Letter' && (
//                   <Form.Text className="text-muted">
//                     Note: Custom rejection letters are saved directly and do not have a preview step.
//                   </Form.Text>
//                 )}
//               </Form.Group>

//               {/* Candidate Name */}
//               <Form.Group className="mb-3" controlId="candidateNameSelect">
//                 <Form.Label>Candidate Name:</Form.Label>
//                 <Select
//                   options={candidateOptions}
//                   value={selectedCandidate}
//                   onChange={handleCandidateChange}
//                   placeholder="Select candidate..."
//                   isSearchable={true}
//                   required
//                 />
//               </Form.Group>


//               {/* --- Fields based on Generation Method --- */}

//               {/* 1. TEMPLATE */}
//               {generationMethod === 'template' && (
//                 <>
//                   {/* ... (Template specific fields: HR, Applicant Data, Position, Salary, Date) ... */}
//                   {/* HR Dropdown (Only for Offer Letter in Template mode) */}
//                   {formData.section === "Offer Letter" && (
//                     <Form.Group className="mb-3" controlId="hrNameSelectTemplate"> {/* Unique ID */}
//                       <Form.Label>HR Name:</Form.Label>
//                       <Select
//                         options={hrOptions}
//                         value={formData.hr ? hrOptions.find(option => option.value === formData.hr.id) : null}
//                         onChange={handleHrChange}
//                         placeholder="Select HR..."
//                         isSearchable={true}
//                         required
//                       />
//                     </Form.Group>
//                   )}

//                   {/* Applicant Data (Shown when candidate selected) */}
//                   {showApplicantData && (
//                     <>
//                       <Form.Group className="mb-3" controlId="addressTemplate"> {/* Unique ID */}
//                         <Form.Label>Address:</Form.Label>
//                         <Form.Control type="text" value={address} readOnly />
//                       </Form.Group>
//                       <Form.Group className="mb-3" controlId="pinCodeTemplate"> {/* Unique ID */}
//                         <Form.Label>Pin Code:</Form.Label>
//                         <Form.Control type="text" value={pinCode} readOnly />
//                       </Form.Group>
//                       <Form.Group className="mb-3" controlId="mobileNumberTemplate"> {/* Unique ID */}
//                         <Form.Label>Mobile Number:</Form.Label>
//                         <Form.Control type="text" value={mobileNumber} readOnly />
//                       </Form.Group>
//                     </>
//                   )}

//                   {/* Position & Salary (Only for Offer Letter in Template mode) */}
//                   {formData.section === "Offer Letter" && (
//                     <>
//                       <Form.Group className="mb-3" controlId="position">
//                         <Form.Label>Position:</Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="position"
//                           value={formData.position}
//                           onChange={handleChange}
//                           required
//                         />
//                       </Form.Group>
//                       <Form.Group className="mb-3" controlId="salary">
//                         <Form.Label>Salary (Lakh Per Annum):</Form.Label>
//                         <Form.Control
//                           type="text" // Consider type="number" with step="0.01" if needed
//                           name="salary"
//                           value={formData.salary}
//                           onChange={handleChange}
//                           required
//                           placeholder="e.g., 5.5"
//                         />
//                       </Form.Group>
//                     </>
//                   )}

//                   {/* *** ADDED: Signature File Input for Template *** */}
//                   {/* Decide if signature is needed for Template Rejection Letters too */}
//                   {/* Currently shown for both Offer/Rejection in Template mode */}
//                   <Form.Group controlId="signatureImageFileTemplate" className="mb-3"> {/* Unique ID */}
//                     <Form.Label>Upload Signature Image (Optional):</Form.Label>
//                     <Form.Control
//                       type="file"
//                       accept="image/png, image/jpeg, image/gif"
//                       onChange={handleSignatureFileChange} // Use the same handler
//                       // Add id attribute for clearing
//                       id="signatureImageFile" // Keep consistent ID for clearing
//                     />
//                     <Form.Text className="text-muted">
//                       Attach signature for the letter (if applicable).
//                     </Form.Text>
//                   </Form.Group>
//                   {/* ******************************************** */}


//                   {/* Date (Required for both Offer/Rejection in Template mode) */}
//                   <Form.Group className="mb-3" controlId="dateTemplate">
//                     <Form.Label>Date:</Form.Label>
//                     <Form.Control
//                       type="date" name="date"
//                       value={formData.date} onChange={handleChange}
//                       required
//                     />
//                   </Form.Group>
//                 </>
//               )}

//               {/* 2. CUSTOM */}
//               {generationMethod === 'custom' && (
//                 <>
//                   {/* ... (Custom specific fields: HR, Applicant Data, Custom Content, Date) ... */}
//                   {/* HR Dropdown (Required for Offer Letter signature block) */}
//                   {formData.section === "Offer Letter" && (
//                     <Form.Group className="mb-3" controlId="hrNameSelectCustom">
//                       <Form.Label>HR Name (for signature):</Form.Label>
//                       <Select
//                         options={hrOptions}
//                         value={formData.hr ? hrOptions.find(option => option.value === formData.hr.id) : null}
//                         onChange={handleHrChange}
//                         placeholder="Select HR..."
//                         isSearchable={true}
//                         required // Make HR required for custom offer letter preview/generation
//                       />
//                     </Form.Group>
//                   )}

//                   {/* Applicant Data */}
//                   {showApplicantData && (
//                     <div className="alert alert-secondary p-2 mb-3">
//                       <small><strong>Applicant Info:</strong> Address: {address || 'N/A'}, Pin: {pinCode || 'N/A'}, Mobile: {mobileNumber || 'N/A'}</small>
//                     </div>
//                   )}

//                   {/* Custom Content Text Area */}
//                   <Form.Group className="mb-3" controlId="customContent">
//                     <Form.Label>Letter Content:</Form.Label>
//                     <Form.Control
//                       as="textarea" rows={10}
//                       value={customContent}
//                       onChange={(e) => setCustomContent(e.target.value)}
//                       placeholder="Enter the full content of the letter here..."
//                       required
//                     />
//                   </Form.Group>


//                   {/* Signature File Input for Custom */}
//                   <Form.Group controlId="signatureImageFileCustom" className="mb-3"> {/* Unique ID */}
//                     <Form.Label>Upload Signature Image (Optional):</Form.Label>
//                     <Form.Control
//                       type="file"
//                       accept="image/png, image/jpeg, image/gif"
//                       onChange={handleSignatureFileChange}
//                       // Add id attribute for clearing
//                       id="signatureImageFile" // Keep consistent ID for clearing
//                     />
//                     <Form.Text className="text-muted">
//                       Attach an image file (.png, .jpg, .gif) for the digital signature block.
//                     </Form.Text>
//                   </Form.Group>


//                   {/* Date */}
//                   <Form.Group className="mb-3" controlId="dateCustom">
//                     <Form.Label>Date:</Form.Label>
//                     <Form.Control
//                       type="date" name="date"
//                       value={formData.date} onChange={handleChange}
//                       required
//                     />
//                   </Form.Group>
//                 </>
//               )}

//               {/* 3. UPLOAD */}
//               {generationMethod === 'upload' && (
//                 <>
//                   {/* ... (Upload specific fields: Applicant Data, File Input) ... */}
//                   {/* Applicant Data */}
//                   {showApplicantData && (
//                     <div className="alert alert-secondary p-2 mb-3">
//                       <small><strong>Applicant Info:</strong> Address: {address || 'N/A'}, Pin: {pinCode || 'N/A'}, Mobile: {mobileNumber || 'N/A'}</small>
//                     </div>
//                   )}

//                   {/* File Input */}
//                   <Form.Group controlId="uploadedFile" className="mb-3">
//                     <Form.Label>Upload PDF Letter:</Form.Label>
//                     <Form.Control
//                       type="file" accept=".pdf"
//                       onChange={handleFileChange}
//                       required
//                     />
//                   </Form.Group>

//                 </>
//               )}

//               {/* Submit Button */}
//               <div className="d-grid">
//                 <Button variant="primary" type="submit" disabled={isLoading} size="lg">
//                   {/* ... (Button text logic - unchanged) ... */}
//                   {isLoading ? (
//                     <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Processing...</>
//                   ) : (
//                     generationMethod === 'upload' ? `Upload ${formData.section}` :
//                       (generationMethod === 'custom' && formData.section === 'Rejection Letter') ? `Save ${formData.section}` :
//                         `Generate & Preview ${formData.section}`
//                   )}
//                 </Button>
//               </div>
//             </Form>
//           </Modal.Body>
//         </Modal> {/* End Modal */}
//       </div> {/* End outer div */}
//     </>
//   );
// };

// export default OfferLetterGenerator;

/// OfferLetterGenerator.js
